// i18n namespace `recognition` (fr) — REQ-099 / REQ-102 / REQ-103.
// D-6 (2026-08-01): traducción completa desde el español (idioma fuente). Se retiraron los 34
// marcadores de traducción pendiente que diferían el trabajo a una "Fase 7" inexistente.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Retour au portail',
    collapseMenu: 'Réduire le menu',
    expandMenu: 'Développer le menu',
    fundamentals: 'Fondamentaux',
  },
  moduleTitle: 'Programme de Reconnaissance',
  nav: {
    recognize: 'Reconnaître',
    shine: 'Brilliants Ensemble',
    profile: 'Mon profil',
    admin: 'Admin',
    team: 'Équipe',
    dashboard: 'Tableau de bord',
    innovation: 'Innovation LATAM',
  },
  // F8 (paridad demo, H-96/H-97)
  frontlineMore: {
    tab: 'Voir plus',
    title: "Plus d'options",
    documents: 'Documents',
    language: 'Langue',
    selectLanguage: 'Sélectionnez la langue',
  },
  common: {
    loading: 'Chargement…',
    error: 'Impossible de charger les informations.',
    retry: 'Réessayer',
    empty: "Il n'y a rien à afficher pour le moment.",
    notConfigured: "Le service de reconnaissance n'est pas configuré.",
    forbidden: "Vous n'avez pas la permission de voir cette section.",
    close: 'Fermer',
    remove: 'Retirer',
    cancel: 'Annuler',
    insertEmoji: 'Insérer un emoji',
    actions: 'Actions',
  },
  recognize: {
    title: 'Reconnaître un collègue',
    subtitle: 'Remerciez un comportement aligné sur nos Fondamentaux.',
    feedTitle: 'Reconnaissances récentes',
    feedEmpty: "Il n'y a pas encore de reconnaissances. Soyez le premier à reconnaître !",
    newCta: 'Nouvelle reconnaissance',
    form: {
      messagePlaceholder: 'Écrivez votre message de reconnaissance…',
      anonymous: 'Envoyer de façon anonyme',
      submit: 'Envoyer la reconnaissance',
    },
  },
  wall: {
    title: 'Mur des reconnaissances',
    count: '{{count}} reconnaissances',
    empty: "Il n'y a pas encore de reconnaissances à afficher.",
    prev: 'Précédentes',
    next: 'Suivantes',
    pageOf: 'Page {{page}} sur {{total}}',
    for: 'pour',
    anonymous: 'Anonyme',
    senderHidden: 'Identité non affichée',
    userUnavailable: 'Utilisateur indisponible',
    points_one: '+{{count}} point',
    points_other: '+{{count}} points',
    pointsTitle: 'Points que vaut cette reconnaissance',
    fundamentalsRecognized: 'Fondamentaux reconnus',
    fundIconTooltipAria: 'Voir tous les Fondamentaux de cette reconnaissance',
    behaviorsRecognized: 'Comportements reconnus',
    habitsRecognized: 'Habitudes quotidiennes reconnues',
    detailUnavailable: 'Impossible de charger le détail complet.',
    reportCount: 'Signalé {{count}} fois — en cours de révision',
    receivedIn: 'Reçu dans :',
    antiSpoilerBlurredHint: "Attends la cérémonie de remise des prix de l'événement Brillamos Juntos pour voir tes nominations.",
    antiSpoilerHiddenHint: 'Certaines reconnaissances sont masquées par le mode Anti-Spoiler jusqu\'à la fin de leur campagne.',
  },
  reactions: {
    addLabel: 'Réagir',
    countLabel: '{{count}} réactions',
    modalTitle: 'Réactions',
    error: "Impossible d'enregistrer votre réaction. Réessayez.",
    whoReacted: 'Ont réagi',
    whoLoading: 'Chargement…',
    whoEmpty: "Personne n'a encore réagi.",
    whoError: 'Impossible de charger la liste.',
  },
  origin: {
    diario: 'Quotidien',
    brillamos: 'Brillons',
    personalizada: 'Campagne',
    csv: 'Import en masse',
    delegado: 'Délégué',
    sistema: 'Système',
  },
  panel: {
    title: 'Reconnaissez vos collègues',
    recipientsLabel: 'Personne',
    recipientsPlaceholder: 'Rechercher par nom ou e-mail…',
    searchError: 'Impossible de rechercher des personnes',
    fundamentalLabel: 'Fondamental (max. {{max}})',
    fundamentalLabelUnbounded: 'Fondamental',
    maxFundamentalsHint: 'Vous ne pouvez sélectionner que {{max}} Fondamental(aux) au maximum.',
    behaviorsLabel: 'Comportements',
    habitsLabel: 'Habitudes quotidiennes',
    habitRequiredHint: 'Sélectionnez au moins une habitude quotidienne avant de pouvoir envoyer.',
    summaryLabel: 'Résumé',
    edit: 'Modifier',
    messageLabel: 'Votre message',
    messagePlaceholder: 'Pourquoi reconnaissez-vous cette personne ?',
    anonymous: 'Envoyer de façon anonyme',
    sendToBrillamos: 'Envoyer aussi à "Brillants Ensemble"',
    // Decisión 6 (2026-10-15) — «Enviar también a Brillamos» avisa antes y después de enviar.
    sendToBrillamosNoCabe: 'Cette reconnaissance ne respecte pas les règles de « {{campana}} » ({{limites}}). Si vous l’envoyez ainsi, elle partira comme reconnaissance quotidienne.',
    brillamosMaxPersonas_one: 'max. {{count}} personne',
    brillamosMaxPersonas_few: 'max. {{count}} personnes',
    brillamosMaxPersonas_other: 'max. {{count}} personnes',
    brillamosMaxFundamentales_one: 'max. {{count}} Fondamental',
    brillamosMaxFundamentales_few: 'max. {{count}} Fondamentaux',
    brillamosMaxFundamentales_other: 'max. {{count}} Fondamentaux',
    sendToBrillamosSalioDiario: 'Envoyée comme reconnaissance quotidienne : elle n’est pas entrée dans « {{campana}} ».',
    charCount: '{{count}} caractères',
    charsAvailableHint: 'Vous approchez de la limite. Il vous reste {{remaining}} caractères sur {{max}}.',
    charsLimitReachedHint: 'Vous avez atteint la limite de {{max}} caractères. Raccourcissez une partie pour continuer à écrire.',
    charsLimitSentenceNote: 'La phrase composée sur le post-it compte elle aussi dans la limite.',
    errMessageTooLong: 'Votre message dépasse la limite de {{max}} caractères. Raccourcissez une partie et renvoyez-le.',
    errRecipientRequired: "Choisissez la personne que vous souhaitez reconnaître avant d'envoyer.",
    errFundamentalRequired: "Choisissez au moins un Fundamental avant d'envoyer.",
    errSessionUnknown: "Nous n'avons pas pu identifier votre session. Fermez l'application, reconnectez-vous et réessayez.",
    errRecipientWithoutCampaign_one: "{{names}} n'a pas de campagne active et ne peut donc pas recevoir cette reconnaissance. Retirez cette personne de l'envoi pour continuer.",
    errRecipientWithoutCampaign_few: "{{names}} n'ont pas de campagne active et ne peuvent donc pas recevoir cette reconnaissance. Retirez ces personnes de l'envoi pour continuer.",
    errRecipientWithoutCampaign_other: "{{names}} n'ont pas de campagne active et ne peuvent donc pas recevoir cette reconnaissance. Retirez ces personnes de l'envoi pour continuer.",
    errDelegateNotAllowed: 'Vous n’avez pas l’autorisation « Reconnaître au nom d’une autre personne ». Envoyez la reconnaissance en votre nom.',
    errDelegateOtherUnit: 'Vous ne pouvez reconnaître qu’au nom de personnes de votre unité. Choisissez un autre émetteur.',
    errDelegateNotOperational: 'Vous ne pouvez reconnaître qu’au nom du personnel opérationnel. Choisissez un autre émetteur.',
    errDelegateNotFound: 'La personne choisie comme émetteur n’existe pas ou n’est plus active. Choisissez une autre personne.',
    errDelegateRequesterWithoutUnit: 'Votre profil n’a pas d’unité attribuée : vous ne pouvez pas reconnaître au nom d’une autre personne.',
    errDelegateNotEligible: 'Vous ne pouvez pas reconnaître au nom de cette personne. Choisissez un autre émetteur.',
    errDelegateCheckUnavailable: 'Nous n’avons pas pu vérifier la personne choisie comme émetteur. Réessayez dans quelques minutes.',
    send: 'Envoyer',
    sending: 'Envoi…',
    sentTitle: 'Reconnaissance envoyée !',
    sentSubtitle: "Visible par l'équipe et le responsable.",
    sendErrorGeneric: "Impossible d'envoyer la reconnaissance. Réessayez.",
    legalHint: 'Vous devez accepter les conditions légales en vigueur avant de reconnaître.',
    sendingDisabledHint: "L'envoi de reconnaissances est temporairement désactivé.",
    scheduleRestrictedHint: "L'envoi est en dehors de la plage horaire autorisée pour votre localité en ce moment.",
    weeklyLimitHint: 'Il y a une limite de {{count}} reconnaissances par semaine pour votre localité.',
    missingRecipientsHint: 'Sélectionnez au moins une personne à reconnaître.',
    missingFundamentalHint: 'Sélectionnez au moins un Fondamental.',
    messageMinCharsHint: 'Écrivez au moins {{count}} caractères dans votre message.',
    missingBehaviorForHabitHint: 'Choisissez un comportement pour voir les habitudes quotidiennes disponibles.',
    noHabitsAvailableHint: "Ce Fondamental n'a aucune habitude quotidienne configurée ; choisissez-en un autre.",
    groupTag: 'Équipe',
    delegateTitle: "Mode d'envoi",
    modeSelfTab: 'En mon nom',
    modeOnBehalfTab: "Au nom d'un autre",
    delegateLabel: 'Au nom de',
    delegateSubtitle: 'Vous pouvez envoyer des reconnaissances au nom de collaborateurs de terrain.',
    delegatePlaceholder: 'Rechercher un collaborateur…',
    onBehalfActiveBanner: 'Vous reconnaissez au nom de {{name}}.',
  },
  profile: {
    title: 'Mon profil de reconnaissance',
    subtitle: 'Votre activité de reconnaissance et votre série.',
    received: 'Reçues',
    sent: 'Envoyées',
    streak: 'Série',
    empty: "Vous n'avez pas encore d'activité de reconnaissance.",
    weeksStreak: 'Semaines de série',
    monthsStreak: 'Mois de série',
    record: 'Record',
    totalSent: 'Envoyées',
  },
  catalog: {
    title: 'Fondamentaux',
    empty: 'Le catalogue de Fondamentaux est vide.',
  },
  notifications: {
    title: 'Notifications',
    close: 'Fermer les notifications',
    placeholder: 'La boîte de notifications sera bientôt disponible.',
    unread: '{{count}} non lues',
    markAllRead: 'Tout marquer comme lu',
    markRead: 'Marquer comme lue',
    readState: 'État de lecture',
    inviteToRecognize: "Reconnaissez quelqu'un",
    markUnread: 'Marquer comme non lue',
    loadMore: 'Voir les notifications précédentes',
    recognitionUnavailable: "Cette reconnaissance n'est plus disponible.",
    unsavedTitle: 'Vous avez des modifications non enregistrées',
    unsavedDesc: "Si vous partez maintenant, vous perdrez ce que vous êtes en train d'écrire.",
    unsavedConfirm: 'Quitter sans enregistrer',
    unsavedCancel: 'Rester ici',
    campaignInactive: 'La campagne de reconnaissance est terminée, elle ne peut donc plus être ouverte.',
    campaignUnavailable: "Cette campagne est terminée, elle ne peut donc plus être ouverte.",
    unavailable: "La boîte n'est pas disponible pour le moment.",
    empty: "Vous n'avez aucune notification.",
  },
  // ── WP-12/WP-13 (D4) — Brillons+Nominer, Bibliothèque, Profil, Wrapped ──
  home: {
    sent: 'Envoyés', received: 'Reçus', recognizeCta: 'Reconnaître maintenant', recent: 'Reconnaissances récentes',
    active: 'Campagne active',
    ended: 'Campagne terminée',
    daysLeft: '{{count}} jours restants',
    heroLogoAlt: 'Shine Together',
    nominateNow: 'Nominer maintenant',
    // Parité démo (D1/D2) — hero de /app/reconocer, calqué sur HomePage.tsx de la démo.
    titleLine1: 'Nominez qui',
    titleVive: 'vit les',
    subtitle: 'Reconnaissez un collègue qui inspire les autres en vivant nos Fondamentaux.',
    cta: "✨ Reconnaître quelqu'un",
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: "Vous n'avez encore reconnu personne !",
    emptyReceived: 'Continuez à vivre les Fondamentaux et vous serez bientôt reconnu !',
  },
  streak: {
    title: 'Votre série de reconnaissances',
    subtitle: 'Reconnaissez chaque semaine et continuez à briller !',
    subtitleMonthly: 'Reconnaissez chaque mois et continuez à briller !',
    weeks: 'sem',
    months: 'mois',
    month: 'mois',
    monthsMany: 'mois',
    record: 'Record',
    total: 'Nominations',
    activeDays: '{{count}} jours actifs cette semaine',
    currentLevel: 'NIVEAU ACTUEL',
    atRisk: 'Votre série est en danger cette semaine',
    atRiskMonthly: 'Votre série est en danger ce mois-ci',
    // PHASE 7 (parité démo, H-91) — famille .streak-* unifiée.
    current: 'Série actuelle',
    thisWeek: 'Cette semaine',
    days: 'jours',
    today: "Aujourd'hui !",
    nudgeDone: "Vous avez déjà brillé aujourd'hui ! 🌟",
    nudgeTodo: "Reconnaissez aujourd'hui et gardez votre série ! 🚀",
    periodProgress: '{{sent}} sur {{min}} cette semaine',
    periodProgressDone: 'Objectif de la semaine atteint ! ({{sent}} sur {{min}})',
    periodProgressMonthly: '{{sent}} sur {{min}} ce mois-ci',
    periodProgressDoneMonthly: 'Objectif du mois atteint ! ({{sent}} sur {{min}})',
    provisionalNote: 'Inclut cette semaine · confirmé à la clôture',
    provisionalNoteMonthly: 'Inclut ce mois-ci · confirmé à la clôture',
    badgeProvisional: 'À LA CLÔTURE',
    badgeProvisionalTooltip: 'Vous avez déjà atteint le minimum de cette période : le badge s\'affiche déjà et sera confirmé à la clôture de la période.',
    badgesTitle: 'Badges',
    celebration: {
      title: 'Badge débloqué !',
      message: 'Continue comme ça, ta régularité se voit !',
      cta: 'Génial !',
    },
    badgeWeek: '{{count}} semaine',
    badgeWeeks: '{{count}} semaines',
    badgeWeeksMany: '{{count}} semaines',
    badgeMonth: '{{count}} mois',
    badgeMonths: '{{count}} mois',
    badgeMonthsMany: '{{count}} mois',
    note: '* La série est calculée sur les reconnaissances envoyées',
    day: { mon: 'L', tue: 'M', wed: 'M', thu: 'J', fri: 'V', sat: 'S', sun: 'D' },
  },
  // 2026-08-10 — seule `crossOu` reste utilisée (par NominarView). Le reste appartenait au "Fil
  // d'activité" de Brillamos Juntos (`BrillamosFeed`, supprimé de l'arborescence à la demande du client).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "Toutes les langues",
    title: 'Documents de campagne',
    download: 'Télécharger',
    loadError: "Impossible de charger le document.",
    cat: {
      howto: 'Comment nominer',
      awards: 'Récompenses',
      legal: 'Règlement',
      privacy: 'Politique de confidentialité',
      cookies: 'Politique de cookies',
      notice: 'Mentions légales',
    },
  },
  library: {
    title: 'Les Fondamentaux',
    subtitle: 'La base de notre façon de travailler, collaborer et grandir chez Sigma.',
    watchVideo: 'Voir la vidéo',
    behaviorsCount: '{{count}} Attitudes et Comportements',
    dailyHabits: 'Habitudes Quotidiennes',
    micrositeSpace: 'Espace du microsite culturel',
  },
  nominate: {
    back: 'Brillants Ensemble',
    thanksTo: 'Merci à {{name}} pour',
    demonstrating: 'avoir démontré {{fundamental}}',
    defaultMessage: 'Reconnaissance envoyée',
    sentTitle: 'Nomination envoyée !',
    sentSubtitle: 'Merci de faire briller {{name}}.',
    redirecting: 'Retour à la campagne…',
    yourRecognition: 'Votre reconnaissance',
    thanksWord: 'Merci à',
    slotWho: 'qui ?',
    forWord: 'pour',
    slotWhat: "qu'a-t-il fait ?",
    demonstratingWord: 'en démontrant',
    slotFund: 'fondamental ?',
    elements: '{{done}}/3 éléments',
    eyebrow: 'Créer une Reconnaissance',
    title: 'Remplissez les trois champs',
    field1: 'Identifiez votre collègue',
    searchPlaceholder: 'Nom du collègue…',
    noResults: "Nous n'avons trouvé personne avec ce nom.",
    field2: 'Sur quel Fondamental ?',
    field3: "Qu'a-t-il fait ?",
    noActions: "Ce Fondamental n'a aucun comportement configuré.",
    pickFundFirst: "Choisissez d'abord un Fondamental.",
    completeMessage: 'Complétez votre message',
    personalizeTitle: 'Personnalisez votre message',
    personalizeSub: 'Ajoutez votre voix. Le reste est déjà prêt.',
    messagePlaceholder: 'Décrivez un moment précis que vous avez observé…',
    charCount: '{{count}} caractères',
    idealRange: '30–80 idéal',
    nudgeText: 'Votre message aura plus d’impact si vous ajoutez une ligne personnelle.',
    addLine: 'Ajouter une ligne',
    sendAnyway: 'Envoyer tel quel',
    send: 'Envoyer la Nomination',
  },
  wrapped: {
    readyTitle: 'Votre Recap est prêt', readySubtitle: 'Revivez les moments qui ont fait briller votre {{year}}.', open: 'Voir mon Recap',
    introHint: 'Un aperçu de votre année de reconnaissance.',
    topReceptor: 'Celui ou celle que vous avez le plus reconnu',
    topEmisor: 'Votre fan nº 1',
    topFundamentalHint: 'Celui que vous avez le plus célébré.',
    bottomFundamentalHint: 'Celui que tu as le moins célébré. Ton défi pour cette année.',
    crossOuValue: '{{count}} reconnaissances cross-OU',
    messageFrom: 'De {{name}}',
    winnerYear: 'Année {{anio}}',
    winnerPosition: 'Place nº {{position}}',
    sinceMonth: 'Votre résumé couvre depuis {{month}}.',
    streakValue: '{{count}} semaines',
    streakValueOne: '{{count}} semaine',
    streakValueMany: '{{count}} semaines',
    streakValueMonth: '{{count}} mois',
    streakValueMonthOne: '{{count}} mois',
    streakValueMonthMany: '{{count}} mois',
    unavailable: "Votre Wrapped n'est pas encore disponible.",
    // Correction RF-130 F1 (H-06) — le backend envoie une CLÉ STABLE (`GetRecognitionWrappedQueryHandler.cs`),
    // pas du texte. `WrappedModal.tsx` la résout contre ces trois, avec une liste blanche : jamais `t(cléBrute)`.
    generosityTag: {
      generoso: 'Généreux',
      muyGeneroso: 'Très généreux',
      superGeneroso: 'Super généreux',
    },
  },
  prof: {
    myFolders: 'Mes reconnaissances reçues filtrées par Fondamental',
    viewingTitle: 'Profil de {{name}}',
    backToMine: 'Mon profil',
    myTeam: 'Équipe',
    searchColleague: 'Rechercher un collègue…',
    campaignBannerSub: 'La campagne est active — entrez dans "Brillants Ensemble"',
    ctaRecognize: "Reconnaître quelqu'un",
    myWrapped: 'Mon Bilan {{year}}',
    brillamosFolder: 'Brillons Ensemble',
    emptySent: "Vous n'avez pas encore envoyé de reconnaissances.",
    emptyBrillamos: "Il n'y a pas encore de reconnaissances \"Brillants ensemble\" ici.",
    folderEmpty: "Il n'y a pas encore de reconnaissances dans ce dossier.",
    recognizeName: 'Reconnaître {{name}}',
    // PHASE 6 (parité démo, H-75/H-77/H-78) — profil `.rp2-*`.
    thisWeek: 'Cette semaine',
    weekdayInitials: 'L,M,M,J,V,S,D',
    badges: 'Badges ·"Brillants Ensemble"',
    recap: 'Bilan {{year}}',
    sigmaMsg: '"Merci de vivre la culture de Sigma"',
    sigmaFrom: '— Sigma · {{year}}',
    sigmaNote: 'Aucune reconnaissance reçue en {{year}}. Cette reconnaissance est un rappel de votre valeur pour l’équipe.',
    sigmaNoteSent: 'Aucune reconnaissance envoyée en {{year}}. Cette reconnaissance est un rappel de votre valeur pour l’équipe.',
  },
  time: {
    moment: "À l'instant",
    hours: 'Il y a {{n}} h',
    yesterday: 'Hier',
    days: 'Il y a {{n}} jours',
  },
  // ── WP-11 REQ-104 — Post-it interactif / Word Builder ──
  builder: {
    modeLabel: 'Mode de reconnaissance',
    modeClassic: 'Classique',
    modeInteractive: 'Interactif',
    previewLabel: 'Aperçu de la reconnaissance',
    thanksWord: 'Je reconnais',
    forWord: 'pour',
    demonstratingWord: 'en démontrant',
    slotWho: 'qui ?',
    slotWhat: "qu'a-t-il fait ?",
    slotFund: 'fondamental ?',
    stepOf: 'Étape {{step}} sur {{total}}',
    step1Title: 'Qui reconnaissez-vous ?',
    step3Title: 'Quel comportement ou quelle habitude ?',
    step4Title: 'Ajoutez votre message',
    complementPlaceholder: 'Décrivez le moment précis que vous avez observé…',
    noActions: "Ce Fondamental n'a ni comportements ni habitudes configurés.",
    back: 'Retour',
    next: 'Suivant',
  },
  ri: {
    bankLabel: 'Banque',
    bankTitle: 'Choisissez vos mots',
    bankHint: 'Touchez un mot ci-dessous pour compléter votre post-it 👇',
    forWhom: 'Pour qui',
    searchPlaceholder: 'Nom du collègue…',
    catAccion: 'Fondamentaux',
    catComportamiento: 'Comportements',
    catHabito: 'Habitudes',
    catImpacto: 'Impact',
    msgLabel: 'Votre message',
    msgTitle: 'Construisez votre reconnaissance',
    words: 'éléments',
    clear: 'Effacer',
    clickToRemove: 'Cliquez pour retirer',
    clickHint: 'Cliquez sur un mot de la banque',
    pickFundFirst: '👆 Choisissez un fondamental pour voir ses comportements',
    pickBehaviorFirst: '👆 Choisissez un comportement pour voir ses habitudes',
    noHabitsForFund: "👆 Ce Fondamental n'a aucune habitude configurée",
    howLabel: 'Comment ça marche ?',
    howTitle: 'Trois étapes simples',
    step1: '<strong>Passez la souris</strong> sur un mot et l’emplacement cible s’illuminera.',
    step2: '<strong>Cliquez</strong> sur le mot pour le placer dans le message.',
    step3: '<strong>Cliquez sur l’emplacement</strong> du post-it pour retirer un mot déjà placé.',
    quote: 'Reconnaître, c’est nommer l’invisible. Quand nous disons à quelqu’un ce que nous voyons en lui, nous tissons une communauté.',
    cta: 'Complétez votre message',
    ctaDone: 'Complétez votre message →',
    popupTitle: 'Ajoutez la touche personnelle',
    popupChars: '30-80 caractères idéal',
    nudgeMsg: 'Votre message aura plus d’impact si vous ajoutez une ligne personnelle 💛',
    nudgeAdd: 'Ajouter une ligne',
    nudgeSkip: 'Envoyer tel quel',
    sent: 'Reconnaissance envoyée !',
    sentIntro: 'Merci à mon',
    continueBtn: 'Continuer →',
    seeRecognition: 'Voir ma reconnaissance →',
    clearReset: 'Effacer et recommencer',
    wStep: 'Étape {{step}} sur {{total}}',
    wQPersona: 'Qui reconnaissez-vous ?',
    wQFund: 'Quel fondamental a-t-il vécu ?',
    wQBehavior: 'Quel comportement a-t-il montré ?',
    wQHabit: "Quelle était l'habitude ?",
    wQImpact: 'Quel a été son impact ?',
    templateThanks: 'Je reconnais',
    templateForLiving: 'pour avoir vécu',
    templateWith: 'avec',
    templateShowing: ', démontrant que',
    templateThat: '. Cela',
    slotPersona: 'personne',
    slotAccion: 'fondamental',
    slotComportamiento: 'comportement',
    slotHabito: 'habitude',
    slotImpacto: 'impact',
    impact1: 'nous inspire',
    impact2: 'nous fait grandir',
    impact3: 'nous aligne',
    impact4: "fait avancer l'équipe",
    tooltipFundamental: "Un Fondamental est la valeur que la personne a incarnée.",
    tooltipComportamiento: 'Le comportement concret qui a montré cette valeur.',
    tooltipHabito: "L'habitude quotidienne où ce comportement se manifeste.",
    tooltipImpacto: "L'effet que cela a eu sur l'équipe.",
    guideStep1Title: 'Choisissez vos mots',
    guideStep1Text: "Ici, vous choisissez le Fondamental, le comportement, l'habitude et l'impact que vous voulez reconnaître.",
    guideStep2Title: 'Votre post-it prend forme',
    guideStep2Text: 'Chaque mot choisi remplit un espace dans la phrase de votre reconnaissance.',
    guideStep3Title: 'Ajoutez votre touche personnelle',
    guideStep3Text: 'Ce message rend sa reconnaissance encore plus spéciale.',
    guideStep4Title: 'Envoyez votre reconnaissance',
    guideStep4Text: "Une fois complet, ce bouton s'active et vous pouvez l'envoyer.",
    guideReopen: 'Revoir le guide',
    guideNext: 'Suivant',
    guideSkip: 'Passer',
    guideDone: 'Compris',
    progressLabel: '{{value}} sur {{total}} étapes complétées',
  },
  // ── WP-11 REQ-106 — Import en masse CSV ──
  bulk: {
    or: 'ou',
    open: 'Envoi en masse',
    title: 'Envoi en masse de reconnaissances',
    subtitle: 'Importez un CSV avec plusieurs reconnaissances à la fois, vérifiez et corrigez avant de confirmer.',
    stepInstructions: 'Instructions',
    stepUpload: 'Téléverser le fichier',
    stepReview: 'Vérifier',
    stepConfirm: 'Confirmer',
    stepOf: 'Étape {{step}} sur {{total}}',
    next: 'Suivant',
    back: 'Retour',
    instructionsIntro: 'Téléchargez le modèle, remplissez-le avec un collaborateur par ligne, puis importez-le pour valider et charger le lot.',
    matchByIdentity: "Recherchez la personne par son e-mail enregistré ou par son matricule — l'un des deux suffit. Vous ne connaissez pas son e-mail ? Le matricule fonctionne tout aussi bien.",
    onePersonPerRowWarning: "Important : chaque ligne du fichier correspond à UNE seule personne. Ne mettez pas plusieurs e-mails ou matricules dans la même cellule — si vous devez reconnaître plusieurs personnes, ajoutez une ligne par personne.",
    // colRequired/colOptional : partagées avec adminBulkUsers/StepInstructions.tsx (registre
    // Europe/États-Unis) — cet assistant ne les utilise plus (ses colonnes fixes n'ont pas
    // d'étiquette obligatoire/facultatif). Ne pas les supprimer lors d'un nettoyage ici sans
    // vérifier d'abord cet autre consommateur.
    colRequired: 'Obligatoire',
    colOptional: 'Facultatif',
    colNameNombre: 'Nom',
    colNameCorreoNomina: 'E-mail ou matricule',
    colNameFundamental: 'Fondamental',
    colReceptorEmailDesc: 'E-mail de la personne qui reçoit la reconnaissance.',
    colMensajeDesc: 'Message de la reconnaissance. Peut être obligatoire selon votre unité organisationnelle.',
    colEmisorEmailDesc: 'E-mail de l’émetteur. Obligatoire : cet e-mail ou le matricule.',
    colReceptorNominaDesc: "Matricule de la personne qui reçoit (AD, SuccessFactors ou le registre Europe). Une alternative à l'e-mail — ne remplace pas ReceptorEmail, utile quand la personne n'a pas encore d'e-mail ou ne s'est pas inscrite.",
    colEmisorNominaDesc: 'Matricule de l’émetteur. Obligatoire : ce matricule ou l’e-mail.',
    markColumnsTitle: 'Et une colonne pour chaque Fondamental, Comportement et Habitude quotidienne',
    markColumnsIntro: "Après ces colonnes fixes, vous verrez une colonne pour chacun — cochez d'un X (ou de tout autre signe, comme « oui ») celle qui convient. Aucun code à saisir.",
    markFundamentalHint: "Cochez un ou plusieurs Fondamentaux par ligne — jusqu'à la limite autorisée par votre unité organisationnelle.",
    markBehaviorHint: "Le Comportement est facultatif — vous pouvez en cocher plusieurs.",
    markHabitHint: 'Les habitudes quotidiennes sont facultatives — vous pouvez en cocher plusieurs.',
    markColumnsOutro: 'La colonne Mensaje est la dernière du fichier, après toutes les colonnes de marque.',
    downloadTemplate: 'Télécharger le modèle',
    templateError: 'Impossible de télécharger le modèle.',
    catalogError: 'Impossible de charger le catalogue des Fondamentaux. Réessayez — sans le catalogue, le fichier ne peut pas être validé.',
    upload: 'Téléverser le CSV',
    dragDropHint: 'Glissez votre fichier CSV ici ou cliquez pour le sélectionner.',
    invalidFileType: 'Seuls les fichiers CSV sont acceptés.',
    emptyFile: 'Le fichier ne contient aucune ligne de données.',
    parseError: 'Impossible de lire le fichier CSV.',
    uploadError: "Impossible de traiter l'envoi en masse.",
    validRows: '{{count}} lignes valides',
    invalidRows: '{{count}} avec erreurs',
    reviewHint: 'Corrigez les lignes surlignées en rouge directement dans le tableau ; chaque modification est revalidée.',
    colLine: '#',
    colReceptor: 'Destinataire',
    colFundamental: 'Fondamental',
    colMensaje: 'Message',
    colReceptorNomina: 'Matricule',
    colBehavior: 'Comportement',
    colHabits: 'Daily Habits',
    colStatus: 'Statut',
    ok: 'Valide',
    expandRow: 'Voir le détail de la ligne {{line}}',
    collapseRow: 'Masquer le détail de la ligne {{line}}',
    habitsCount_one: '{{count}} Habitude quotidienne',
    habitsCount_other: '{{count}} Habitudes quotidiennes',
    revalidating: 'Revalidation…',
    downloadErrors: 'Télécharger les erreurs (CSV)',
    confirmSummary: '{{count}} reconnaissances seront créées. Les lignes en erreur sont ignorées.',
    confirm: 'Charger {{count}} valides',
    committed: '{{created}} reconnaissances ont été créées. {{skipped}} lignes ont été ignorées.',
    duplicatesSkipped_one: "1 reconnaissance n'a pas été envoyée : elle avait déjà été envoyée avec le même message.",
    duplicatesSkipped_other: "{{count}} reconnaissances n'ont pas été envoyées : elles avaient déjà été envoyées avec le même message.",
    notFoundTitle: "E-mails introuvables dans l'annuaire :",
    errors: {
      receptorRequired: "L'e-mail du destinataire est obligatoire.",
      receptorNotFound: "Cet e-mail n'existe pas dans l'annuaire.",
      emisorMissing: 'Émetteur manquant : indiquez l’e-mail ou le matricule de la personne qui reconnaît.',
      emisorOtherUnit: 'Émetteur hors de votre unité : vous ne pouvez importer qu’au nom de personnes de votre unité.',
      emisorStaff: 'Émetteur avec un compte professionnel (staff) : l’import n’est possible qu’au nom du personnel opérationnel.',
      delegateCheckUnavailable: 'Nous n’avons pas pu vérifier les émetteurs du fichier, rien n’a été importé. Réessayez dans quelques minutes.',
      multiplePeopleNotSupported: "Cette colonne doit contenir une seule personne (un e-mail ou un matricule). Pour reconnaître plusieurs personnes, ajoutez une ligne par personne.",
      fundamentalInvalid: "Le Fondamental est obligatoire, ou le message ne respecte pas les exigences de votre unité organisationnelle.",
      selfRecognition: 'Vous ne pouvez pas vous reconnaître vous-même.',
      blockedWord: 'Le message contient un mot non autorisé.',
      weeklyCapExceeded: "L'expéditeur a atteint sa limite hebdomadaire de reconnaissances.",
      duplicateInFile: 'Cette ligne est répétée dans le fichier.',
      behaviorInvalid: "Le Comportement n'est pas valide pour le Fondamental de cette ligne.",
      habitInvalid: "L'un des Daily Habits n'est pas valide pour le Fondamental de cette ligne.",
      campaignClosed: "La campagne n'est pas active.",
      notAllowedForCampaign: "Cette ligne n'est pas autorisée pour la campagne de ce lot.",
      maxFundamentalsExceeded: "Vous ne pouvez pas sélectionner davantage de Fondamentaux pour cette reconnaissance : la limite est définie par la configuration de l'unité organisationnelle de l'expéditeur.",
      generic: "Cette ligne n'a pas pu être validée.",
    },
  },
  // ── WP-11 REQ-107 — Actions du post-it ──
  actions: {
    // RF-086 / RN-M06 — le catalogue de motifs (`reportReasons`) a été supprimé : le motif est libre.
    reportCharsLeft: 'Il reste {{n}} caractères',
    edit: 'Modifier',
    report: 'Signaler',
    delete: 'Supprimer',
    saveEdit: 'Enregistrer',
    editError: 'Impossible de modifier la reconnaissance.',
    editMinChars: 'Le message doit comporter au moins {{min}} caractères ({{count}}/{{min}}).',
    reportReason: 'Motif du signalement',
    reportPlaceholder: 'Décrivez brièvement le problème…',
    reportError: "Impossible d'envoyer le signalement.",
    reportSent: 'Signalement envoyé. Notre équipe va l’examiner.',
    sendReport: 'Envoyer le signalement',
    deleteConfirm: 'Voulez-vous vraiment supprimer cette reconnaissance ? Cette action est irréversible.',
    deleteError: 'Impossible de supprimer la reconnaissance.',
    confirmDelete: 'Oui, supprimer',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Import en masse du registre du personnel (Europe et É.-U.)',
      descLong: "Création et mise à jour du registre du personnel Europe/É.-U. via un CSV de 24 colonnes, plus la région du fichier (Europe ou É.-U.), choisie lors de l'import. C'est incrémental : toute personne absente du fichier n'est pas modifiée, et les départs sont marqués via la colonne EMPLOYEE DELETED. En cas de départ, l'email peut être vidé ou modifié, et l'email d'une personne partie redevient disponible pour les autres. Les autres régions sont synchronisées automatiquement par SuccessFactors.",
      importHint: "Téléchargez le modèle, remplissez-le et importez-le. L'import affiche d'abord un aperçu qui n'écrit rien. Dates au format MM/dd/aaaa.",
      openWizard: "Ouvrir l'import en masse",
      wizardSubtitle: "Importez le CSV du registre, vérifiez le résultat puis confirmez — rien n'est écrit avant la dernière étape.",
      confirm: "Confirmer l'import",
      downloadErrors: 'Télécharger les erreurs (CSV)',
      received: 'Lignes',
      created: 'Créés',
      updated: 'Mis à jour',
      deactivated: 'Désactivés',
      skipped: 'Ignorés',
      disabled: "L'import en masse Europe/É.-U. est désactivé dans la configuration des sources.",
      previewNotice: "Aperçu : rien n'a encore été écrit. Voici les compteurs que produira l'import réel.",
      allOk: 'Toutes les lignes ont été traitées sans erreur.',
      blockingErrorsNotice: 'Des erreurs empêchent de continuer. Corrigez le fichier et téléchargez-le à nouveau.',
      importError: "Le fichier n'a pas pu être traité.",
      importErrorTimeout: "Le serveur a mis trop de temps à répondre. L'import a peut-être quand même abouti côté serveur — vérifiez le registre avant de réessayer. Référence : {{correlationId}}",
      ignoredColumnsNotice: 'Ces colonnes de votre fichier ne sont pas reconnues et seront ignorées : {{columns}}',
      confirmRecap: '{{total}} lignes seront traitées : {{created}} créations, {{updated}} mises à jour, {{deactivated}} désactivations.',
      committed: 'Import terminé : {{created}} créations, {{updated}} mises à jour, {{deactivated}} désactivations, {{skipped}} ignorées.',
      committedErrorsNotice: 'Certaines lignes ont eu des incidents pendant l’import. Vérifiez le détail avant de valider ces données.',
      paginationPage: 'Page {{page}} sur {{total}}',
      errorColumn: 'Colonne',
      errorDetail: 'Détail des erreurs / omissions',
      ouLabel: 'Région du fichier',
      ouPlaceholder: 'Sélectionnez une région',
      ouEuropa: 'Europe',
      ouUsa: 'États-Unis (É.-U.)',
      ouCentral: 'Central',
      ouHint: "S'applique à toutes les lignes du fichier. Elle ne se saisit plus ligne par ligne dans le CSV, pour éviter les erreurs de frappe ou de langue.",
      ouRequired: "Sélectionnez la région avant d'importer le fichier.",
      errorCode: {
        'email-in-use-active': 'Adresse e-mail déjà utilisée par un utilisateur actif, saisissez une autre adresse valide.',
        'reactivation-email-in-use': 'Non réactivé : son adresse e-mail est utilisée par un utilisateur actif, saisissez une autre adresse valide.',
        'import-audit-failed': "Le chargement a été appliqué, mais n'a pas pu être enregistré dans le journal des chargements. Contactez le support.",
        'user-audit-failed': "Le chargement a été appliqué, mais il n'a pas été possible d'enregistrer qui a chargé certaines personnes. Contactez le support.",
        'cache-not-cleared': "Le chargement a été appliqué, mais le cache n'a pas pu être vidé pour certaines personnes : leurs données peuvent sembler obsolètes pendant une heure maximum.",
        'row-write-failed': "Cette ligne n'a pas pu être enregistrée ; si le problème persiste, contactez le support.",
      },
      col: {
        employeeDeleted: "1 désactive la personne ; 0 ou vide la laisse active. Lorsqu'une personne est désactivée, son email est libéré pour les autres utilisateurs ; si elle est réactivée (0) et que son email est déjà utilisé par un utilisateur actif, elle n'est pas réactivée et la ligne est signalée.",
        localId: "Matricule du collaborateur. C'est la clé : sans elle, la ligne ne peut pas être traitée.",
        firstName: 'Prénom.',
        lastName: 'Nom de famille.',
        secondLastName: 'Second nom de famille (facultatif).',
        completeName: "Nom complet à afficher. S'il est vide, il est construit à partir des trois champs précédents.",
        email: "Email du collaborateur. Peut être vide : la fiche reste dans le registre jusqu'à ce que la personne s'inscrive. Sur les lignes de DÉPART (EMPLOYEE DELETED = 1), une cellule vide supprime l'email de la personne (elle reste sans email) et un nouvel email le remplace, tant qu'aucun autre utilisateur actif ne l'utilise ; sur les lignes qui ne sont pas des départs, une cellule vide ne change rien.",
        bu: 'Unité commerciale.',
        siteId: 'Identifiant du site/usine.',
        site: 'Nom du site/usine.',
        orgDirectionId: 'Identifiant de la Direction Organisationnelle.',
        orgDirection: 'Nom de la Direction Organisationnelle.',
        funcDirectionId: 'Identifiant de la Direction Fonctionnelle.',
        funcDirection: 'Nom de la Direction Fonctionnelle.',
        departmentId: 'Identifiant du Département.',
        department: 'Nom du Département.',
        jobPosition: 'Poste du collaborateur.',
        manager: 'Nom du supérieur direct (informatif uniquement).',
        managerId: 'Matricule du supérieur direct. Utilisé pour relier la hiérarchie ; le supérieur doit déjà exister dans le registre.',
        managerEmail: 'Email du supérieur direct (informatif uniquement).',
        hireDate: "Date d'embauche, format MM/dd/aaaa.",
        birthDate: 'Date de naissance, format MM/dd/aaaa.',
        notification: "YES ou NO : si la personne reçoit des notifications. Vide signifie « non défini », pas NO.",
        country: "Pays de la personne. Facultatif, mais sans lui la personne sort du périmètre des administrateurs pays.",
      },
    },
    title: 'Administration',
    subtitle: 'Configurez le Programme de Reconnaissance.',
    denied: "Vous n'avez pas les droits pour accéder à cette section.",
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    saved: 'Modifications enregistrées',
    saveError: "Impossible d'enregistrer les modifications.",
    rowsPerPage: 'Lignes par page',
    fundPanelTitle: 'Admin Fondamentaux — Reconnaissance',
    fundPanelSubtitle: "Chaque module est indépendant. Activez-le ou désactivez-le selon les besoins de votre organisation.",
    pager: {
      showing: 'Affichage {{range}} sur {{total}}',
      perPage: '{{size}} par page',
      all: 'Toutes',
      prev: 'Page précédente',
      next: 'Page suivante',
      pageSize: 'Résultats par page',
    },
    nav: {
      roles: 'Configurer les rôles et permissions',
      points: 'Points',
      moderation: 'Modération',
      winners: 'Gagnants',
      campaigns: 'Campagnes',
      reports: 'Rapports',
      team: 'Équipe',
      dashboard: 'Tableau de bord',
      management: 'Gestion',
      notifications: 'Notifications',
      views: 'Vues',
      docs: 'Documentation',
      recap: 'Recap',
    },
    roles: {
      title: 'Configurer les rôles et permissions',
      desc: 'Gérez les administrateurs, leur périmètre par OU/pays et leur matrice de permissions.',
      searchEmail: 'Rechercher par e-mail…',
      empty: "Il n'y a aucun administrateur à afficher.",
      colAdmin: 'Administrateur',
      colRole: 'Rôle',
      colScope: 'Périmètre',
      colStatus: 'Statut',
      allScopes: 'Tous',
      active: 'Actif',
      inactive: 'Inactif',
      edit: 'Modifier',
      remove: 'Retirer',
      removeConfirmTitle: 'Retirer un administrateur Brillamos',
      removeConfirmMsg: "Retirer « {{name}} » en tant qu'administrateur Brillamos ? Son compte reste un collaborateur standard.",
      removeConfirm: 'Oui, retirer',
      removeError: "Impossible de retirer le rôle d'administrateur. Réessayez.",
      status: 'Statut',
      permMatrix: 'Matrice de permissions',
      readOnlyConflict: '« Lecture seule » ne peut pas coexister avec des permissions d’écriture (RN-R03). Actuellement cochées : {{permisos}}. Modifier une case le résoudra ; enregistrer tel quel sera refusé par le serveur.',
      addAdmin: 'Ajouter un administrateur',
      addTitle: 'Ajouter un administrateur',
      editTitle: "Modifier l'administrateur — {{name}}",
      searchPersonLabel: 'Rechercher un collaborateur',
      searchPersonPlaceholder: 'Nom ou e-mail du collaborateur…',
      alreadyAdminNote: 'Cette personne est déjà administratrice Reconnaissance — modifiez ses données ci-dessous.',
      cannotEditGlobal: "Cette personne a déjà le rôle Admin Général. Ce rôle ne se gère pas depuis ici.",
      selectRolePlaceholder: 'Sélectionnez un rôle…',
      selectRoleFirst: "Choisissez un rôle avant d'enregistrer.",
      accountActive: 'Compte actif (accès à la plateforme)',
      accountActiveHint: "C'est le compte de la personne, pas son rôle d'administrateur. Désactivé, elle ne peut pas accéder à la plateforme.",
      deactivateAccountTitle: 'Désactiver le compte',
      deactivateAccountMsg: '{{name}} ne pourra plus accéder à la plateforme. Cela ne retire pas son rôle : le compte est désactivé. Continuer ?',
      deactivateAccountConfirm: 'Oui, désactiver le compte',
      peopleLabel: 'Personnes',
      peopleHint: "Ajoutez toutes les personnes nécessaires : recherchez-les et ajoutez-les l'une après l'autre, ou collez plusieurs e-mails séparés par des points-virgules ou des virgules. Toutes reçoivent le même rôle, la même portée et les mêmes autorisations.",
      peopleCount: 'Personnes sélectionnées : {{count}}',
      removeAllPeople: 'Tout retirer',
      removePerson: 'Retirer {{name}}',
      alreadyAdminTag: 'Déjà administrateur',
      alreadyAdminBulkNote: "{{count}} de ces personnes sont déjà administrateurs de Brillamos : à l'enregistrement, leur rôle et leurs autorisations sont remplacés par ceux ci-dessous.",
      globalSkipped: "{{names}} n'a pas été ajouté : rôle Admin Général, qui ne se gère pas ici.",
      resolvingEmails: 'Recherche de {{count}} e-mails…',
      emailsNotFound: "Personne n'a été trouvé avec ces e-mails : {{emails}}",
      bulkProgress: 'Enregistrement de {{done}} sur {{total}}…',
      bulkDone: 'Rôle attribué aux {{count}} personnes.',
      bulkPartial: 'Attribué à {{ok}} sur {{total}}. Les personnes en échec restent dans la liste ; vérifiez le motif et enregistrez à nouveau :',
      saveForPeople: 'Enregistrer pour {{count}} personnes',
      saveForbidden: "Vous n'avez pas la permission d'effectuer ce changement.",
      role: {
        AdminGlobal: 'Admin Général',
        AdminBrillamos: 'Admin Reconnaissance',
        AdminOUBrillamos: 'Admin OU Reconnaissance',

        AdminOU: 'Admin OU Pulse',
      },
    },
    perm: {
      manageUsers: 'Gérer les utilisateurs',
      manageRecognitions: 'Gérer les reconnaissances',
      manageNotifications: 'Gérer les notifications',
      manageDocuments: 'Gérer les documents',
      manageWinners: 'Gérer les gagnants',
      viewAnalytics: 'Voir les analytics',
      viewReports: 'Voir les rapports',
      exportData: 'Exporter les données',
      configureViews: 'Configurer les vues',
      bulkCsv: 'Envoi en masse (CSV)',
      moderateContent: 'Modérer le contenu',
      manageCampaigns: 'Gérer les campagnes',
      createCampaigns: 'Créer et gérer les campagnes',
      readOnly: 'Lecture seule',
      approveNominations: 'Confirmer les gagnants',
      managePoints: 'Gestion',
      manageRoles: 'Configurer les rôles et permissions',
      manageBlockedWords: 'Gérer les mots bloqués',
      managePointsConfig: 'Points',
      manageRecap: 'Modifier le Recap annuel',
      delegateRecognition: 'Reconnaître au nom d\'un autre',
      accessCatalogFundamentals: 'Catalogue Fondamentaux',
      accessCatalogOus: 'Catalogue OUs',
    },
    points: {
      title: 'Points',
      desc: 'Configurez les points par critère (0-9), en miroir Staff/Frontline. Les points ne sont jamais visibles pour l\'employé.',
      empty: 'Aucun critère de points configuré.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Actif',
      segmentActiveHint: "Si désactivé, ce tableau (Staff ou Frontline) n'attribue aucun point même si des critères sont configurés.",
      lockedCampaign: 'La configuration n\'est plus modifiable une fois la campagne démarrée.',
      campaignActiveWarning: 'Impossible de modifier la configuration des points tant qu\'une campagne est active dans cette unité organisationnelle.',
      colCategory: 'Catégorie',
      colCriterion: 'Critère',
      colPoints: 'Points',
      colActive: 'Actif',
      criterionActiveHint: "Si désactivé, ce critère n'attribue aucun point même s'il est rempli.",
      colAccumulated: 'Total cumulé',
      accumulatedFooter: 'Nominations évaluées',
      resetAccumulated: 'Réinitialiser à 0',
      resetAccumulatedConfirmTitle: "Réinitialiser le total cumulé",
      resetAccumulatedConfirmMessage: "Le compteur « Total cumulé » de cette UO et de ce segment repartira à 0. L'historique des reconnaissances n'est PAS supprimé ; il cesse simplement d'être compté à partir de maintenant. Cette action est irréversible.",
      resetAccumulatedSuccess: 'Le total cumulé a été réinitialisé à 0.',
      resetAccumulatedError: "Impossible de réinitialiser le total cumulé.",
      accumulatedError: 'Impossible de charger le décompte des nominations.',
      accumulatedDisabledHint: "Les points désactivés, le moteur n'évalue pas : le cumul reste à zéro même s'il y a des reconnaissances.",
      globalToggle: 'Points appliqués (global)',
      globalToggleHint: "Active ou désactive le système de points pour TOUTES les unités organisationnelles, quelle que soit la configuration propre à chacune.",
      visibleToEmployees: 'Visible pour les employés',
      visibleToEmployeesHint: 'Affiche sur le post-it les points de chaque reconnaissance de cette OU. Jamais le cumul d’une personne.',
      visibleUnknown: 'Impossible de lire l’état de l’interrupteur. Rien ne change tant que ce n’est pas connu.',
      visibleGdprBlocked: 'Cette OU est soumise au RGPD : les points ne s’affichent pas même si l’interrupteur est activé.',
      globalOffHint: 'Le commutateur global est désactivé : aucune OU ne crédite de points, même si son tableau est actif.',
      ouPicker: 'Unité organisationnelle',
      ouPickPlaceholder: 'Sélectionnez une unité…',
      pickOuFirst: 'Sélectionnez une unité organisationnelle pour voir et modifier sa configuration de points.',
      accumulatedNoKey: "Ce critère n'a pas de clé canonique : impossible de le rapprocher du décompte.",
      globalOverriddenHint: 'Cette unité a sa propre exception : ici le commutateur est {{estado}} quelle que soit la valeur globale.',
      globalOn: 'activé',
      globalOff: 'désactivé',

      globalUnknown: "Le commutateur global n'a pas pu être lu ; son état réel est inconnu.",
      noOuInProfile: "Votre profil n'a pas d'unité organisationnelle assignée : il n'y a pas de configuration de points à afficher. Demandez-le à l'administrateur global.",
      exportReport: 'Télécharger le rapport de points',
      exporting: 'Téléchargement…',
      exportError: 'Impossible de générer le rapport de points. Réessayez.',
      exportEmpty: "Aucune ligne de points à exporter dans ce périmètre.",
      exportTruncated: 'Le rapport a été tronqué à {{tope}} lignes ; restreignez le périmètre pour tout exporter.',
      exportNamesUnresolved: 'Certains noms n\'ont pas pu être résolus ; ces lignes affichent leur identifiant.',
      exportColPerson: 'Personne',
      exportColOu: 'Unité organisationnelle',
      exportColPoints: 'Points',
    },
    placeholder: {
      soon: 'Cette section sera bientôt disponible.',
      tracked: 'Suivi : {{req}}',
    },
    recognitions: {
      title: 'Reconnaissances',
      descLong: 'Gérez le catalogue de Fondamentaux/Habitudes : création, édition, activation/désactivation, liaison à une campagne et microsite.',
      tabActive: 'Fondamentaux',
      tabTrash: 'Corbeille',
      tabHabits: 'Daily Habits',
      newHabit: 'Nouveau Daily Habit',
      habitSearchPlaceholder: 'Rechercher un habit…',
      habitsEmpty: 'Aucun Daily Habit dans le catalogue.',
      colColor: 'Couleur',
      colNameEs: 'Nom (ES)',
      colNameEn: 'Nom (EN)',
      colParent: 'Fondamental parent',
      colOuVisibility: 'Visibilité par OU',
      ouInherited: 'Hérité du fondamental',
      habitStatusAll: 'Tous',
      habitStatusActive: 'Actifs',
      habitStatusInactive: 'Inactifs',
      deleteHabitConfirm: 'Supprimer ce Daily Habit du catalogue ?',
      newHabitTitle: 'Nouveau Daily Habit',
      editHabitTitle: 'Modifier le Daily Habit',
      new: 'Nouveau Fondamental',
      searchPlaceholder: 'Rechercher par code ou nom…',
      empty: 'Le catalogue est vide.',
      colCode: 'Code',
      colName: 'Nom',
      colHabits: 'Habitudes',
      colBrillamos: 'Brillons',
      colMicrosite: 'Microsite',
      colStatus: 'Statut',
      inBrillamos: 'Dans Brillons',
      notInBrillamos: 'Hors',
      openMicrosite: 'Ouvrir',
      edit: 'Modifier',
      deleteConfirm: 'Envoyer ce Fondamental à la corbeille ?',
      trashEmpty: 'La corbeille est vide.',
      newTitle: 'Nouveau Fondamental',
      editTitle: 'Modifier {{code}}',
      needAllLangs: 'Complétez le nom dans les 7 langues.',
      fieldCode: 'Code',
      fieldOrder: 'Ordre',
      fieldName: 'Nom',
      fieldShortName: 'Nom court',
      fieldColor: 'Couleur',
      fieldMicrosite: 'URL du microsite',
      fieldCampaignScope: 'Campagne liée',
      campaignScopeHint: 'Id de campagne (vide = catalogue global)',
      fieldBrillamos: 'Participe à Brillons Ensemble',
      legacyCatalogWarning: 'Ce catalogue est temporaire : les modifications faites ici ne sont pas encore reflétées dans ce que les personnes voient lors d\'une reconnaissance (P2-010).',
    },
    moderation: {
      desc: 'Mots bloqués et boîte de signalements.',
      title: 'Modération',
      descLong: 'Boîte de signalements avec acheminement, catalogue de mots bloqués et interrupteurs de modération.',
      contentTitle: 'Modération du Contenu',
      wordsTitle: 'Mots Bloqués',
      wordsDesc: "Ils sont détectés et bloqués automatiquement lors de l'envoi d'une reconnaissance.",
      wordsCounted: 'mots bloqués',
      manageWords: 'Gérer',
      wordsManagerDesc: 'Ajoutez, modifiez ou supprimez des mots par langue. Compatible avec plus de 100 mots.',
      newWord: 'Nouveau mot',
      region: 'Pays/Région',
      regionGlobal: 'Global (tous)',
      regionHint: 'Une même langue peut avoir des mots différents selon le pays ou la région.',
      allRegions: 'Toutes les régions',
      searchWord: 'Rechercher…',
      editWord: 'Modifier le mot',
      word: 'Mot',
      wordPlaceholder: 'Ex. : inapproprié…',
      language: 'Langue',
      addWord: 'Ajouter',
      wordsEmpty: 'Aucun mot ne correspond au filtre.',
      langOther: 'Autres',
      // RF-082 — table pays→langues qui determine quel catalogue s'applique a chaque emetteur.
      countryLanguagesTitle: 'Pays et langues',
      countryLanguagesDesc: 'Définissez les langues parlées dans chaque pays. Un pays multilingue (Belgique : nl et fr) applique les mots de toutes ses langues sans les saisir deux fois. Pays en ISO-3166 (MX, ES, BE) et langues parmi les 7 de la plateforme (es, en, pt, fr, de, nl, ro). Pour limiter un mot à un pays précis, utilisez son champ Pays/Région.',
      countryLanguagesEmpty: 'La table des pays et des langues est vide.',
      regionsTitle: 'Régions',
      regionMembers: 'Pays qui la composent',
      countryLanguagesInvalid: "Vérifiez ces codes avant d'enregistrer : {{codes}}. Le pays s'écrit en ISO à 2 lettres (MX) et la langue doit être l'une des 7 de la plateforme (es, en, pt, fr, de, nl, ro), sans variante de pays.",
      countryLanguagesUnreadable: "La table n'a pas pu être lue, elle ne peut donc pas être enregistrée : l'enregistrement la remplace entièrement et ce qui n'est pas affiché serait perdu.",
      country: 'Pays',
      languages: 'Langues',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Ajouter un pays',
      countryPlaceholder: 'MX',
      autoTitle: 'Configuration de la Modération Automatique',
      aiAutoBlock: 'Blocage automatique par IA',
      aiAutoBlockHint: "Lorsqu'il est activé, chaque message de reconnaissance est vérifié par IA (Azure AI Content Safety) à l'envoi et bloqué s'il est offensant.",
      helpAria: 'Aide',
      aiHelp: "Vérifie chaque message par IA (Azure AI Content Safety) à l'envoi et détecte la toxicité en contexte (haine, menaces, harcèlement). S'ajoute au catalogue de mots bloqués : les deux peuvent être actifs en même temps. Nécessite que « Modération active (globale) » soit activée ; si l'interrupteur global est désactivé, cette couche ne s'applique pas.",
      globalHelp: "Interrupteur principal de la modération. S'il est désactivé, RIEN n'est modéré : ni le blocage par IA, ni le catalogue de mots bloqués, et aucun signalement n'est accepté. Activez-le pour que les autres couches fonctionnent.",
      wordsHelp: "Bloque des mots exacts à l'envoi, quel que soit le contexte. Complète le blocage par IA (qui détecte la toxicité en contexte). Les deux couches nécessitent que « Modération active (globale) » soit activée.",
      hideThreshold: 'Seuil de signalements pour masquer',
      notifyReporter: "Notifier l'auteur du signalement",
      aiPendingNote: "Lorsque le blocage automatique par IA est activé, les messages de reconnaissance sont validés par Azure AI Content Safety à l'envoi et refusés s'ils enfreignent les règles de savoir-vivre. Il fonctionne conjointement avec le catalogue de mots bloqués.",
      hideThresholdHint: "Nombre de signalements nécessaires pour masquer automatiquement une reconnaissance. La valeur 1 correspond à la règle actuelle : le masquage a lieu dès le premier signalement.",
      notifyReporterHint: "Enregistre la préférence et la transmet avec l'événement de modération. Le courriel au signalant sera envoyé par NotificationService lorsque cette notification existera.",
      advanced: 'Configuration avancée',
      globalEnabled: 'Modération active (globale)',
      reportEnabledGlobal: 'Signalement activé par défaut',
      dailyReportLimit: 'Limite quotidienne de signalements',
      // RF-084 — exceptions de "autoriser les signalements" par noeud, en cascade Site -> BU -> OU.
      overridesTitle: 'Signalement par unité (cascade)',
      overridesDesc: "Exceptions à la valeur globale. C'est le nœud le plus spécifique qui l'emporte : Site, puis BU, puis OU et ses unités supérieures. Une unité sans exception hérite de celle de son unité mère.",
      overridesNode: 'Unité, BU ou Site',
      overridesNodePlaceholder: 'Choisissez une OU ou saisissez un id de BU/Site',
      overridesAllow: 'Autorisé',
      overridesBlock: 'Bloqué',
      overridesEmpty: 'Aucune exception : toutes les unités utilisent la valeur globale.',
      overridesDuplicate: "Une exception pour « {{node}} » existe déjà. Les identifiants ne distinguent pas les majuscules des minuscules : modifiez ou supprimez l'existante.",
      inboxTitle: 'Boîte de Signalements',
      inboxDesc: "Signalements des utilisateurs. En masquant, la reconnaissance disparaît du mur de celui qui l'a reçue et des reconnaissances envoyées par celui qui l'a émise ; elle est aussi retirée du tableau des médailles et ses points sont annulés.",
      searchName: 'Rechercher par nom…',
      filterAll: 'Tous',
      filterOu: 'OU : Toutes',
      filterBu: 'BU : Toutes',
      filterSite: 'Site : Tous',
      filterFrom: 'Du',
      filterTo: 'Au',
      filterType: 'Type : Tous',
      type: { fundamentales: 'Fondamentaux', brillamos: 'Brillons Ensemble', diario: 'Reco Quotidienne' },
      uiStatus: { pendiente: 'En attente', restaurado: 'Restauré', eliminado: 'Supprimé' },
      uiStatusPlural: { pendiente: 'En attente', restaurado: 'Restaurés', eliminado: 'Supprimés' },
      status: { Publicado: 'Publié', Pendiente: 'En attente', Resuelto: 'Résolu', Desestimado: 'Rejeté' },
      reportsEmpty: 'Aucun signalement ne correspond au filtre.',
      colReportedBy: 'Signalé par',
      colRecognitionFrom: 'Reconnaissance de',
      colTo: 'Pour',
      colDetail: 'Détail',
      colReason: 'Motif',
      colDate: 'Date',
      colStatus: 'Statut',
      colActions: 'Actions',
      // RF-090 — bouton enveloppe : transmet le cas a l'admin de l'OU/pays sans attendre le recap.
      notifyAdmin: "Prévenir l'admin",
      notifyAdminHint: "Envoie tout de suite un avis à l'administrateur de l'unité de cette reconnaissance, sans attendre le récapitulatif hebdomadaire.",
      notifyAdminConfirm: "Envoyer un avis à l'administrateur de l'unité de {{name}} ? Un e-mail part immédiatement.",
      notifyAdminSent: "Avis envoyé à l'administrateur.",
      notifyAdminError: "Impossible d'envoyer l'avis à l'administrateur.",
      // RF-090 — aperçu des destinataires : le bouton enveloppe annonçait « envoyé » même sans destinataire.
      notifyPreviewTitle: 'Cet avis parviendra à :',
      notifyPreviewLoading: 'Résolution des destinataires…',
      notifyPreviewEmpty: "Aucun destinataire n'a pu être résolu.",
      notifyPreviewError: "Impossible de vérifier à qui parviendrait l'avis.",
      notifyReason: {
        'sin-admins-en-la-ou': "Cette unité n'a aucun administrateur enregistré, et il n'y a pas d'administrateurs globaux vers qui escalader le cas.",
        'escalado-a-globales': "L'unité n'a pas d'administrateur propre : le cas est escaladé aux administrateurs globaux.",
        'admin-sin-correo': "L'administrateur n'a pas d'adresse e-mail exploitable dans l'annuaire, il est donc impossible de lui écrire.",
        'directorio-no-responde': "L'annuaire des utilisateurs n'a pas répondu : impossible de savoir qui devrait être averti.",
        'suprimido-por-allowlist': "L'envoi serait abandonné : cette adresse ne figure pas dans la liste des destinataires autorisés du service de notifications.",
        'allowlist-desconocida': "La liste des destinataires autorisés n'a pas pu être vérifiée ; l'envoi pourrait être abandonné sans laisser de trace.",
        desconocido: "L'avis ne peut pas être envoyé pour une raison que le service n'a pas su expliquer.",
      },
      deleteLabel: 'Supprimer',
      hideHint: 'Masque la reconnaissance du mur, la retire du tableau des médailles et annule ses points.',
      restore: 'Restaurer',
      reopen: 'Rouvrir',
      reopenHint: "Renvoie le cas dans la file en statut En attente et masque de nouveau la reconnaissance.",
      viewDetail: 'Voir le détail',
      detailTitle: 'Détail du signalement',
      whoReported: 'Qui a signalé',
      whoWasReported: 'Qui a été signalé',
      reportedRecognition: 'Reconnaissance signalée',
      messageUnavailable: 'Texte non disponible.',
      // RF-087 — acheminement du cas : l'e-mail et l'OU s'affichent toujours, avec un repère s'ils manquent.
      dataUnavailable: 'Non disponible',
      detailLoading: 'Chargement…',
      detailError: "Impossible de charger les coordonnées à jour ; celles enregistrées au moment du signalement sont affichées.",
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
      colCampaign: 'Campagne',
      filterCampaign: 'Campagne : Toutes',
    },
    winners: {
      // Task 2.5 — grille de cartes des badges de campagne dans Gagnants (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Badges de campagne',
        permanenceNote: 'Ces badges sont permanents : ils ne s’activent ni ne se désactivent comme les badges de série ; ils restent liés à la campagne et à l’année pour lesquelles ils ont été attribués.',
        empty: 'Aucun badge de campagne pour le moment.',
        edit: 'Modifier',
        delete: 'Supprimer',
        deleteConfirm: 'Supprimer le badge de campagne « {{name}} » ? Son nom dans les 7 langues, son icône et son année seront perdus. Cette action est irréversible.',
        add: '+ Ajouter un badge',
        editTitle: 'Modifier le badge de campagne',
        fieldTitle: 'Titre',
        fieldYearSubtitle: 'Année / Sous-titre',
        fieldYear: 'Année du prix',
        yearNone: 'Sans année',
        fieldYearHint: 'Vérifiée à l’attribution : un badge d’une année ne peut pas être remis dans une campagne d’une autre. « Sans année » désactive la vérification.',
        fieldImage: 'Image',
        imageUploadHintNew: 'Enregistrez d’abord le badge pour pouvoir téléverser son image.',
        imageFormatInvalid: 'Le format de l’image n’est pas valide. Utilisez PNG, JPG, WEBP ou SVG.',
        previewTitle: 'Aperçu',
      },
      bulkTitle: 'Confirmation par lot',
      bulkSelected: '{{count}} sélectionnés',
      bulkConfirm: 'Confirmer {{count}}',
      bulkConfirming: 'Confirmation…',
      bulkClear: 'Annuler la sélection',
      bulkSelectAll: 'Sélectionner tous les en attente de cette page',
      bulkSelectOne: 'Sélectionner {{name}}',
      bulkFailed: '{{count}} n’ont pas pu être confirmés. Les autres oui ; réessayez avec ceux-là uniquement.',
      editTitle: 'Modifier le lauréat — {{nombre}}',
      actionError: 'L\'action n\'a pas pu être effectuée.',
      badExtension: 'Format non pris en charge. Acceptés : {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Poste',
      colDepto: 'Département',
      colFundamental: 'Fondamental',
      colStatus: 'Statut',
      colUser: 'Utilisateur',
      colUserNomina: 'Matricule : {{nomina}}',
      colSite: "Site",
      colEmail: "E-mail",
      exportSheetName: "Gagnants",
      exportTitle: "Gagnants",
      exportSubtitle: "Gagnants enregistrés avec les filtres appliqués",
      colYear: 'Année',
      colBadge: 'Badge',
      badgeNone: 'Sans badge',
      exportFiltered: 'Télécharger en Excel les gagnants correspondant aux filtres actuels',
      exportEmpty: 'Aucun gagnant à exporter avec ces filtres',
      exporting: 'Exportation…',
      exportError: 'Le téléchargement n’a pas pu aboutir. Réessayez.',
      confirmAction: 'Confirmer comme lauréat',
      confirmDelete1: 'Retirer {{nombre}} de la liste des lauréats ?',
      confirmDelete2: 'Cette action est irréversible et elle est journalisée. Confirmer ?',
      deleteTitle: 'Retirer un lauréat',
      deleteConfirm: 'Retirer',
      countryAll: 'Pays : tous',
      editAction: 'Modifier',
      editClosed: 'Hors période de modification.',
      editWindowNote: 'Vous pouvez modifier un lauréat jusqu\'à 1 mois après son chargement. L\'Admin Général peut modifier n\'importe quel lauréat des 3 dernières années.',
      exportNominations: 'Exporter les nominations',
      exportWinners: 'Exporter les gagnants',
      exportNominationsEmpty: 'Il n\'y a aucune nomination à exporter pour cette campagne.',
      exportPending: 'L\'export sera raccordé dans le prochain lot.',
      filterCountry: 'Pays',
      filterFundamental: 'Fondamental',
      filterYear: 'Année',
      filtersToggle: 'Filtres',
      flowHint: 'Les lauréats sont chargés par fichier. Le principe : chargez le modèle → il s\'affiche ici → vous confirmez le lauréat final.',
      fundamentalAll: 'Fondamental : tous',
      fundamentalNone: 'Sans fondamental',
      importErrorsTitle: 'Lignes rejetées',
      importSummary: '{{importados}} lignes importées sur {{total}} · {{rechazados}} rejetées.',
      manageTitle: 'Gestion des lauréats',
      moduleHint: 'Activez-le pour permettre le chargement des lauréats et l\'attribution des badges.',
      moduleOffWarn: "Module Lauréats désactivé. Pour l'instant, ce réglage est seulement enregistré : il ne change encore rien pour les utilisateurs.",
      moduleSaveError: "Impossible d'enregistrer le changement du module Lauréats. Réessayez.",
      moduleTitle: 'Module Lauréats',
      needsCsv: 'Il s\'agit d\'un classeur Excel binaire, illisible ici. Ouvrez-le et enregistrez-le en CSV (UTF-8) avant de le charger.',
      noResults: 'Aucun lauréat ne correspond au filtre.',
      ouAll: 'OU : toutes',
      pagerInfo: 'Page {{page}} sur {{paginas}} · {{total}} lauréats',
      searchByName: 'Rechercher par nom…',
      statusConfirmed: '✓ Confirmé',
      statusPending: '⏳ En attente',
      uploadFile: 'Charger Excel',
      uploadCampaign: 'Campagne du fichier',
      uploadMode: 'Édition du fichier',
      uploadModeCurrent: 'En cours',
      uploadModeHistoric: 'Historique',
      uploadOpen: 'Charger le fichier',
      uploadOpenHint: "Ouvre l'assistant pour charger le fichier des lauréats, en cours ou historique.",
      uploadModalTitle: 'Charger le fichier des lauréats',
      uploadModalToggleHint: 'Choisissez « En cours » si le fichier appartient à une campagne active sur le site. Choisissez « Historique » pour charger des récompenses des années précédentes qui ne sont pas documentées comme une campagne.',
      uploadBadge: 'Badge',
      uploadBadgeHint: 'Chaque ligne du fichier va recevoir CE badge. Choisissez-le avant de charger le fichier.',
      uploadBadgePick: 'Choisissez le badge…',
      uploadBadgeClarify: "Ce n'est pas une campagne : c'est l'image que la personne verra comme récompense obtenue (par exemple, une médaille ou un trophée).",
      pickBadgeFirst: "Choisissez d'abord le badge que vont recevoir les lauréats de ce fichier.",
      uploadHistoricWarning: "Les données historiques sont enregistrées directement, sans être liées à une campagne. Vérifiez le nom, l'e-mail et le badge avant de charger le fichier.",
      helpOpen: 'Aide pour charger le fichier',
      helpModalTitle: 'Comment charger le fichier des lauréats ?',
      helpIntroVigente: "En cours : utilisez ce mode quand la récompense appartient à une campagne qui existe sur le site et qui est active en ce moment. Vous choisissez la campagne et le badge (l'image affichée comme récompense obtenue) et téléchargez le modèle : il ne demande que l'e-mail ou le matricule de la personne. Le nom, l'année et l'OU/le site sont déjà connus du système — inutile de les saisir.",
      helpIntroHistorico: "Historique : utilisez ce mode quand la récompense vient d'une ancienne campagne qui n'existe plus sur le site, ou d'une campagne dont vous n'avez aucune trace. Vous ne choisissez PAS de campagne : à la place, vous choisissez UN seul badge (l'image affichée comme récompense obtenue, pas le nom d'une campagne), qui sera donné à TOUTES les personnes du fichier. Téléchargez le modèle à 2 colonnes (Nom et E-mail ou matricule), remplissez-le et chargez-le.",
      helpDirectorio: "L'e-mail ou le matricule doit exister dans l'annuaire de l'entreprise. Si aucun des deux n'est trouvé, cette ligne est rejetée et le reste du fichier se charge quand même. Si la personne n'a pas d'e-mail (par exemple, le personnel d'usine), indiquez son matricule dans cette même colonne — l'e-mail n'est pas nécessaire si vous avez déjà mis le matricule.",
      helpNoDownload: "Si vous essayez de télécharger un fichier et qu'il n'y a aucune donnée à afficher, rien ne se télécharge : un message s'affiche à l'écran à la place.",
      downloadTemplateHint: 'Téléchargez un Excel vide avec les bonnes colonnes pour ce mode, dans votre langue.',
      downloadTemplateCurrent: 'Télécharger le modèle en cours',
      downloadTemplateHistoric: 'Télécharger le modèle historique',
      uploadFileHint: "Chargez l'Excel rempli avec les données du fichier.",
      importWizard: {
        subtitle: "Chargez le fichier, vérifiez le résultat avant de confirmer, et téléchargez les erreurs en cas d'échec.",
        colNombreDesc: "Nom du gagnant, tel qu'il sera affiché.",
        colNombreDescVigente: "Nom du gagnant. Vous pouvez le laisser vide : si vous ne le saisissez pas, le nom déjà enregistré pour cette personne est utilisé.",
        colEmailDesc: "E-mail OU matricule de la personne — un seul des deux suffit ; il identifie qui reçoit le prix.",
        colFundamentalDesc: "Fondamental reconnu (nom dans n'importe quelle langue, ou code du catalogue). Ignoré s'il ne correspond à aucun.",
        badgePreviewHint: "Voici à quoi ressemble le badge — exactement ce que chaque lauréat de ce fichier va recevoir.",
        dropHint: 'Faites glisser votre fichier Excel ou CSV ici, ou cliquez pour le choisir.',
        reviewHint: "Ceci est une VALIDATION : rien n'est encore enregistré. Vérifiez le résumé et, si besoin, revenez en arrière pour choisir un fichier corrigé.",
        previewPending: 'Validation du fichier…',
        noErrors: 'Aucune erreur — toutes les lignes sont valides.',
        fileLevelError: 'Fichier/sélection',
        confirmPending: 'Enregistrement…',
      },
      filterEstado: 'Statut',
      estadoAll: 'Statut : tous',
      uploadCampaignPick: 'Choisissez la campagne…',
      pickCampaignFirst: "Choisissez d'abord la campagne à laquelle appartient le fichier.",
      exportNominationsCatalogError: "Impossible de charger le catalogue des Fondamentaux/Habitudes : l'export pourrait être incomplet. Réessayez.",
      yearAll: 'Année : toutes',
      desc: 'Registre des gagnants de Brillons Ensemble.',
      title: 'Gagnants',
      descLong: 'Gagnants par campagne/OU. Création manuelle et import CSV de l’historique avec retour ligne par ligne.',
      filterCampaign: 'Campagne',
      campaignIdHint: 'Id de campagne',
      filterOu: 'OU',
      ouHint: "Id d'OU",
      add: 'Ajouter un gagnant',
      addTitle: 'Nouveau gagnant',
      fieldCampaign: 'Campagne',
      fieldUser: 'Utilisateur',
      fieldName: 'Nom',
      fieldOuName: 'OU',
      fieldCountry: 'Pays',
      fieldPosition: 'Position',
      save: 'Enregistrer',
      importTitle: 'Import CSV',
      importHint: 'Téléchargez le modèle, remplissez-le et importez-le. L’import est idempotent par campagne + utilisateur.',
      downloadTemplate: 'Télécharger le modèle',
      uploadCsv: 'Importer un CSV',
      templateError: 'Impossible de télécharger le modèle.',
      importError: "Impossible de traiter l'import.",
      deleteError: "Impossible de supprimer ce gagnant.",
      totalRows: 'Lignes totales',
      imported: 'Importés',
      rejected: 'Rejetés',
      row: 'Ligne',
      reason: 'Motif',
      empty: "Il n'y a aucun gagnant pour ces filtres.",
      colPosition: 'Position',
      colName: 'Nom',
      colOu: 'OU',
      colCountry: 'Pays',
      colCrossed: 'Origine croisée',
      colDate: 'Enregistré',
      // Task 16 — en-têtes de l'export brut des nominations (i18n, plus d'espagnol figé).
      nominationsExport: {
        // Les clés `nominee*` portent la personne qui A NOMINÉ (le bloc Nominee_* du DTO vient de
        // Recognition.EmisorSnapshot). La personne nominée est le bloc `candidate*` ci-dessous.
        nomineeName: 'Nominateur : Nom',
        nomineeEmail: 'Nominateur : E-mail',
        nomineeEmployeeId: 'Nominateur : Matricule',
        nomineeOu: 'Nominateur : OU',
        nomineeBu: 'Nominateur : BU',
        nomineeSite: 'Nominateur : Site',
        nomineeDepartment: 'Nominateur : Poste',
        onBehalfOfName: 'Au nom de : Nom',
        onBehalfOfEmail: 'Au nom de : E-mail',
        onBehalfOfEmployeeId: 'Au nom de : Matricule',
        onBehalfOfOu: 'Au nom de : OU',
        onBehalfOfBu: 'Au nom de : BU',
        onBehalfOfSite: 'Au nom de : Site',
        onBehalfOfDepartment: 'Au nom de : Poste',
        candidateName: 'Candidat : Nom',
        candidateEmail: 'Candidat : E-mail',
        candidateEmployeeId: 'Candidat : Matricule',
        candidateOu: 'Candidat : OU',
        candidateBu: 'Candidat : BU',
        candidateSite: 'Candidat : Site',
        candidateDepartment: 'Candidat : Poste',
        date: 'Date',
        year: 'Année',
        month: 'Mois',
        habitPrefix: 'Habitude',
        comment: 'Commentaire',
        streakBadge: 'Badge de série',
        fromDayToDay: 'Vient du quotidien',
        status: 'Statut',
        type: 'Type',
        audienceNominee: 'Audience du nominateur',
        audienceCandidate: 'Audience du candidat',
        points: 'Points',
        retiredHabitsGroup: 'Autres / habitudes retirées',
      },
    },
    campaigns: {
      desc: 'Assistant de campagnes de reconnaissance.',
      statusDivider: 'Statut des campagnes',
      title: 'Campagnes',
      descLong: 'Liste des campagnes et assistant en 5 étapes : Info, Audience, Configuration, Documents et Publication.',
      filterAll: 'Toutes',
      status: {
        Borrador: 'Brouillon', Activa: 'Active', Finalizada: 'Terminée', PendienteAprobacion: 'Approbation en attente',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Active · hors période',
        ActivaPorIniciar: 'Active · pas encore commencée',
        // ADR 0014 — estado visible de la pestaña Brillamos (Activa con inicio futuro).
        PorIniciar: 'À venir',
        ActivaVencidaHint: 'La campagne est toujours marquée active, mais sa période est terminée : les collaborateurs de son périmètre ne la voient pas.',
        ActivaPorIniciarHint: 'La campagne est active mais sa date de début n’est pas encore arrivée.',
      },
      approvals: 'Approbations',
      new: 'Nouvelle campagne',
      empty: "Il n'y a aucune campagne.",
      colName: 'Nom',
      colType: 'Type',
      colStatus: 'Statut',
      colScope: 'Périmètre',
      allScopes: 'Toutes les OUs',
      editBtn: 'Modifier',
      duplicate: 'Dupliquer',
      panic: 'Arrêter la campagne',
      deactivateConfirmTitle: 'Arrêter la exception par OU',
      deactivateConfirmMsg: "Arrêter cette exception par OU maintenant ? Elle cessera immédiatement de s'appliquer à son périmètre.",
      panicConfirm: 'Arrêter cette campagne immédiatement ?',
      type: { Fundamentales: 'Fondamentaux', Brillamos: 'Brillons', Personalizada: 'Personnalisée' },
      wizardEditTitle: 'Modifier la campagne',
      wizardNewTitle: 'Nouvelle campagne',
      wizardSub: 'Complétez les 6 étapes pour créer ou modifier la campagne.',
      backToList: 'Retour à la liste',
      step: { info: 'Info', design: 'Design', audience: 'Audience', config: 'Configuration', documents: 'Documents', publish: 'Publier' },
      tabFundamentales: 'Fondamentaux',
      tabBrillamos: 'Shine Together',
      tabPersonalizadas: 'Personnalisées',
      fundActiveTitle: 'Toujours actif',
      fundRules: 'Règles d’envoi',
      fundActiveDesc: 'Les Fondamentaux sont la base du programme de reconnaissance. Impossible de les désactiver, seulement configurer leurs règles.',
      fundConfigNote: 'Les règles d’envoi et les limites détaillées se gèrent dans la section Gestion.',
      globalPanic: 'Arrêter toutes les campagnes',
      globalPanicConfirm: 'Terminer immédiatement TOUTES les campagnes Shine Together actives ? Cette action est irréversible.',
      globalPanicDone: '{{count}} campagne(s) terminée(s).',
      docCategoria: 'Catégorie',
      docCatNone: 'Sans catégorie',
      fieldType: 'Type de campagne',
      fieldName: 'Nom',
      fieldDescription: 'Description',
      fieldSlug: 'Slug de la landing',
      fieldScope: 'Périmètre (OUs)',
      fieldExclusions: 'Exclusions',
      fieldStart: 'Date de début',
      fieldEnd: 'Date de fin',
      fieldTimezone: 'Fuseau horaire',
      fieldStreakMinimum: 'Minimum de série de la campagne',
      streakMinimumInherit: 'Utiliser le global',
      streakMinimumHint: 'Envois exigés par cette campagne pour cumuler la série sur la période (1-20). Vide = le minimum global de Gestion s\'applique.',
      streakMinimumLocked: 'La campagne a déjà démarré : le minimum de série ne peut pas changer sans requalifier la période en cours.',
      fieldRecognitionsLimitOwn: 'Plafond d\'envois de la campagne',
      recognitionsLimitOwnInherit: 'Utilise la valeur globale',
      recognitionsLimitNotApplicable: 'Non applicable (aucun plafond d\'envois)',
      recognitionsLimitNotApplicableShort: 'Sans plafond',
      fieldSameFundamentalLimit: 'Fois même fondamental à la même personne',
      sameFundamentalInherit: 'Utilise la valeur globale',
      sameFundamentalNotApplicable: 'Non applicable (sans limite)',
      sameFundamentalNotApplicableShort: 'Sans limite',
      recognitionsLimitOwnHint: 'Reconnaissances autorisées par cette campagne par période. Vide = le plafond global de Gestion s\'applique. Modifiable à tout moment, même campagne déjà active.',
      visibility: 'Visibilité',
      postSendTitle: 'Modification et Anti-Spoiler',
      visSender: "Afficher l'expéditeur",
      visFundamental: 'Afficher le fondamental',
      visText: 'Afficher le texte',
      visHabit: "Afficher l'habitude",
      visSent: 'Compteur d’envoyés',
      visReceived: 'Compteur de reçus',
      visAnonymous: 'Autoriser les anonymes',
      visBulk: 'Import en masse CSV',
      visReactions: 'Réactions (👏❤️😊🎉👍)',
      visCampaignTag: 'Afficher l’étiquette de campagne',
      visFromFundamentals: 'Autoriser l’envoi depuis les Fondamentaux',
      visSendingDisabled: 'Désactiver l’envoi de reconnaissances',
      anonymousOverrideLabel: 'Reconnaissances anonymes',
      anonymousOverrideInherit: 'Hériter de Gestión',
      anonymousOverrideAllow: 'Autoriser',
      anonymousOverrideDeny: 'Ne pas autoriser',
      anonymousOverrideHint: 'S\'applique UNIQUEMENT à cette campagne. Laissé sur "Hériter de Gestión", cette campagne utilise le réglage global.',
      points: 'Points',
      pointsLocked: 'Les points sont immuables : la campagne a déjà démarré.',
      pointsHint: "Europe uniquement ; le frontend n'affiche jamais les points.",
      applyPoints: 'La campagne octroie des points',
      brillamosRecurringDesc: 'Campagne de nomination récurrente basée sur les Fondamentaux.',
      paisScheduleTitle: 'Horaires et Dates par Pays',
      paisScheduleIntro: 'Configure des horaires ou des dates différents par pays. Sans valeur, hérite de la fenêtre globale.',
      paisScheduleInfoIntro: "Consultez les dates et horaires en vigueur des campagnes actives de chaque OU, pour savoir quand la reconnaissance entre OU est possible. Informatif uniquement.",
      paisStateOn: "Actif",
      paisStateOff: "Arrêté",
      paisStateNoCampaign: "Aucune campagne",
      paisCol: 'Pays',
      paisOpen: 'Heure d\'ouverture',
      paisClose: 'Heure de fermeture',
      paisActive: 'Actif',
      paisClearHours: "Effacer l'horaire",
      paisOverrideBadge: "Campagne d'UO",
      paisOverrideWins: 'Prime sur cette ligne : {{alcance}}.',
      paisOverrideNoSend: 'Envoi désactivé',
      paisOverrideDates: 'Du {{inicio}} au {{fin}}',
      paisOverrideHours: 'Horaire {{inicio}}–{{fin}}',
      paisScheduleNoActive: "Aucune campagne Brillamos Juntos n'est active : dès qu'il y en aura une, ses dates et horaires par pays s'afficheront ici.",
      saveDraftFirst: 'Enregistrez le brouillon pour gérer ses documents.',
      saveDraft: 'Enregistrer le brouillon',
      saveDraftLater: 'Le brouillon est enregistré à la fin de la configuration. Utilisez « Suivant » pour parcourir les étapes.',
      dates: 'Dates',
      publishRequirements: 'Requiert un nom dans les 7 langues, au moins une OU de périmètre et des dates de début et de fin. Enregistrer s\'active une fois la configuration complète.',
      valNameAllLangs: 'Saisissez le nom dans les 7 langues.',
      valScope: 'Sélectionnez au moins une unité organisationnelle dans le périmètre.',
      scopeConflict: "Ces unités font déjà partie d'une campagne active : {{campanas}}. Retirez-les du périmètre ou terminez cette campagne.",
      valScopeConflict: "Le périmètre entre en conflit avec une campagne active : {{campanas}}.",
      scopeConflictPartial: "Il y a plus de campagnes actives que celles qui ont pu être vérifiées : la détection de conflits peut être incomplète.",
      scopeEmpty: "Vous n'avez aucune unité organisationnelle dans votre périmètre pour créer des campagnes. Demandez à un administrateur global de vous attribuer un périmètre.",
      outOfScopeHint: "Cette campagne inclut des unités organisationnelles hors de votre périmètre : seul un administrateur qui les couvre toutes peut la modifier.",
      valScopeExcludesOwn: "Vous ne pouvez pas exclure votre propre unité organisationnelle du périmètre.",
      valStart: 'Indiquez la date de début de la campagne.',
      valEnd: 'Indiquez la date de fin de la campagne.',
      valTimezone: 'Sélectionnez le fuseau horaire de la campagne.',
      valDateOrder: 'La date de fin doit être postérieure à la date de début.',
      valPastDate: "Les dates de la campagne ne peuvent pas être antérieures à aujourd'hui.",
      designMenu: 'Icône et titre dans le menu latéral',
      designMenuHint: 'Voici comment la campagne apparaîtra dans la barre latérale de la plateforme.',
      designIcon: 'Icône',
      designMenuTitle: 'Titre du menu',
      designMenuTitlePh: 'ex. Innovation LATAM',
      designSections: 'Sections de la landing',
      designSectionsHint: 'La bannière et le formulaire de nomination sont toujours présents. Activez les sections optionnelles.',
      designShowStreak: 'Série de reconnaissances',
      designShowRecent: 'Reconnaissances récentes',
      designBrillamosLocked: 'L’identité de Shine Together est immuable : son design ne peut pas être modifié.',
      approvalSent: "Demande d'approbation envoyée.",
      submitApproval: 'Envoyer pour approbation',
      submitApprovalConfirmTitle: 'Envoyer pour approbation',
      submitApprovalConfirmMsg: "Envoyer cette campagne pour approbation ? L'Admin General devra la valider avant qu'elle ne soit active.",
      prev: 'Précédent',
      next: 'Suivant',
      docLang: 'Langue',
      docUrl: 'URL du document',
      docTitle: 'Titre',
      addDoc: 'Ajouter un document',
      docCategoryRequired: "Sélectionnez une catégorie avant d'ajouter le document.",
      docTitleRequired: "Complétez le titre dans les 7 langues avant d'ajouter le document.",
      docsEmpty: "Il n'y a aucun document.",
      docsFallbackNote: "Si aucun document n'est chargé ici, cette campagne affiche ceux de la section Documentation de l'administration.",
      approvalsTitle: 'Approbations en attente',
      approvalsSub: 'Campagnes en attente de votre approbation (AdminGlobal).',
      approvalsEmpty: "Il n'y a aucune approbation en attente.",
      colCampaign: 'Campagne',
      requestedBy: 'Demandée par',
      approve: 'Approuver',
      approveConfirmTitle: 'Approuver la campagne',
      approveConfirmMsg: 'Approuver cette campagne ? Elle deviendra active et visible pour son périmètre.',
      reject: 'Rejeter',
      rejectReason: 'Motif du refus (obligatoire)',
      rejectConfirm: 'Confirmer le refus',
      viewDetail: 'Voir le détail',
      bannerDesign: 'Design de la bannière',
      bannerScopeLabel: "Cette bannière s'applique uniquement à cette campagne ; si elle n'est pas configurée, elle hérite de la bannière globale du programme.",
      bannerDesignHint: 'Changez de langue ci-dessus pour modifier le titre, le sous-titre et le logo de cette langue — l’aperçu se met à jour en direct.',
      bannerTitle1: 'Titre (ligne 1)',
      bannerTitle2: 'Titre (ligne 2)',
      bannerSubtitle: 'Sous-titre',
      bannerLogoNote: 'Le téléversement de l’image du logo (PNG par langue) arrive bientôt.',
      bannerLogo: 'Logo (image pour cette langue)',
      bannerLogoUpload: 'Téléverser PNG',
      bannerLogoReset: 'Réinitialiser',
      bannerLogoHint: 'Recommandé : PNG transparent ~4:3. Le logo Fundamentals s’affiche par défaut.',
      bannerLogoErrPng: 'Le logo doit être un PNG.',
      bannerLogoErrSize: 'Le PNG ne doit pas dépasser 500 Ko.',
      bannerPreview: 'Aperçu',
      bannerPreviewEmpty: 'Titre de la bannière',
      bannerCta: 'Reconnaître quelqu’un',
      brillamosBannerTitle: 'Bannière Shine Together',
      brillamosBannerHint: 'Personnalisez le sous-titre et le logo du hero Shine Together par langue. L’aperçu se met à jour en direct.',
      brillamosBannerLogoHint: 'Recommandé : PNG transparent. Le logo Shine est affiché par défaut.',
      entryPoints: 'Mode de reconnaissance (entry points)',
      entry: { A: 'Entry A — Formulaire classique', B: 'Entry B — Post-it interactif (Word Builder)', both: 'Les deux visibles (test A/B)' },
      commentRequired: 'Commentaire obligatoire',
      vista: 'Vue :',
      vistaGlobal: 'Admin Global',
      vistaOu: 'Admin OU / Ambassadeur',
      rulesTitle: 'Règles d’envoi',
      brillamosRulesIntro: 'Ces regles ne concernent que Shine Together. Un champ vide herite de la valeur globale de Gestion.',
      ruleMultiPersona: 'Multi-personne',
      ruleMultiFundamental: 'Multi-fondamental',
      ruleBulkCsv: 'Import CSV en masse',
      ruleReactions: 'Réactions sur le mur',
      ruleSendingDisabled: 'Désactiver l’envoi',
      ruleAnonymousEnabled: 'Autoriser les reconnaissances anonymes',
      anonymousGestionHint: 'S\'applique à tout (Fondamentaux, Brillamos et campagnes personnalisées), sauf si une campagne définit sa propre configuration à l\'étape Configuration de l\'assistant. N\'affecte pas l\'anonymisation automatique RGPD en Europe.',
      ruleMinChars: 'Car. min.',
      moderationTitle: 'Modération',
      modPostEdit: 'Édition après envoi',
      modPostEditDescription: 'Édition après envoi : l’expéditeur peut modifier ou supprimer ses reconnaissances tant que la campagne est ouverte.',
      moderationNote: 'Le bouton Signaler et le filtre de mots se gèrent dans la section Modération.',
      postEditPerCampaignNote: '« Édition après envoi » se configure dans chaque campagne (étape 5 de l’assistant) et, pour les Fondamentaux, dans leur onglet. Il n’y a plus de délai.',
      modAntiSpoiler: 'Mode Anti-Spoiler',
      modAntiSpoilerDescription: 'Mode Anti-Spoiler : masque les reconnaissances reçues jusqu’à la fin de la campagne. Seul leur expéditeur les voit.',
      antiSpoilerPerCampaignNote: '« Mode Anti-Spoiler » se configure dans chaque campagne (étape 5 de l’assistant) et cesse de protéger à la clôture de la campagne. Pour les Fondamentaux, dans leur onglet ; il se désactive manuellement.',
      multiEnvioPerCampaignNote: '« Multi-personne », « Multi-fondamental » et « Fondamentaux par reco » se configurent dans chaque campagne (étape 5 de l’assistant).',
      multiEnvioEuropaAviso: 'Cette campagne inclut des OU d’Europe (RGPD) : autoriser plusieurs personnes ou plusieurs Fondamentaux relève de la responsabilité de la personne qui configure la campagne.',
      multiEnvioNoLimitHint: 'Avec « Fondamentaux par reco » désactivé, il n’y a pas de limite de Fondamentaux.',
      entryPointsPerCampaignNote: 'Le mode de reconnaissance se configure dans chaque campagne (étape 5 de l’assistant).',
      resetToGlobal: 'Réinitialiser (hériter du global)',
      streakTitle: 'Configuration de la série (Fondamentaux)',
      streakActive: 'Série active',
      streakSentNote: 'La série est calculée à partir des reconnaissances ENVOYÉES.',
      streakInProfile: 'Afficher la série au profil',
      badgesActive: 'Badges actifs',
      streakPeriod: 'Période',
      periodWeekly: 'Hebdomadaire',
      periodMonthly: 'Mensuel',
      periodDaily: 'Quotidien',
      limitsTitle: 'Plafonds (Gestion des limites)',
      limitsActive: 'Plafonds actifs',
      limitName: 'Nom',
      limitDescription: 'Description',
      limitRecognitionsDesc: 'Reconnaissances maximum',
      limitFundamentalsDesc: 'Max sélectionnables par envoi',
      limitValue: 'Limite',
      limitFrequency: 'Fréquence',
      limitActiveCol: 'Actif',
      limitRecognitions: 'Reconnaissances par période',
      limitFundamentals: 'Fondamentaux par reco',
      perSubmission: 'Par envoi',
      readonlyTitle: 'Configuration générale — Fondamentaux (appliquée par défaut)',
      readonlyBadge: 'Lecture seule',
      readonlyNote: 'Si vous souhaitez ajouter une exception par OU, elle passera par l’approbation de l’Admin Global.',
      colDate: 'Date',
      exc: {
        title: 'Exceptions par OU',
        intro: 'Exceptions ponctuelles à la configuration de base pour un périmètre OU/BU/Site précis. Chacune passe par l\'approbation de l\'Admin Global.',
        new: 'Nouvelle exception par OU',
        colException: 'Exception',
        colScope: 'OU / BU / Site',
        colState: 'Statut de l’exception',
        fullOu: 'Toute l\'OU',
        sites: '{{count}} sites',
        scopePopTitle: 'Sites du périmètre',
        stateActive: 'Active',
        stateInactive: 'Inactive',
        toggleHint: 'Seule une exception approuvée peut être activée ou désactivée.',
        edit: 'Modifier',
        delete: 'Supprimer',
        empty: 'Aucune exception par OU pour l\'instant.',
        deleteTitle: 'Supprimer l\'exception',
        deleteMsg: 'Cette exception par OU sera supprimée définitivement. Cette action est irréversible.',
        deleteConfirm: 'Supprimer',
        summaryTope: 'Plafond : {{max}} recos / {{freq}}',
        summaryDisable: 'Désactiver l\'envoi',
        disableTitle: 'Désactiver l\'envoi (override)',
        disableNote: 'Bloque temporairement l\'envoi de reconnaissances pour le périmètre sélectionné, sans désactiver le programme. Nécessite l\'approbation de l\'admin global.',
        summarySchedule: 'Horaire restreint',
        summaryVisibility: 'Visibilité',
        summaryBanner: 'Bannière',
        approvalsTitle: 'Approbations',
        approvalsColSolicitante: 'Demandeur',
        approvalsColAprobador: 'Approbateur',
        approvalsColFecha: 'Date',
        approvalsColEstado: 'Statut',
        approved: 'Approuvée',
        pending: 'En attente',
        rejected: 'Rejetée',
        approvalsEmpty: 'Aucune exception à approuver pour l\'instant.',
        pendingBanner: 'Vous avez {{count}} exception(s) en attente de votre approbation.',
        approve: 'Approuver',
        reject: 'Rejeter',
        rejectReason: 'Motif du rejet (obligatoire)',
        rejectConfirm: 'Confirmer le rejet',
        back: 'Exceptions par OU',
        wizardTitle: 'Exception par OU — Fondamentaux',
        wizardTitleBrillamos: 'Exception par OU — Brillants Ensemble',
        stepScope: 'Périmètre',
        stepSchedule: 'Horaires',
        stepBanner: 'Bannière',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Campagne de base',
        baseCampaignHint: 'Une exception par OU ne fonctionne pas seule : elle REMPLACE des parties d’une campagne active pour votre périmètre. Sans campagne active couvrant ces OUs, cette exception n’aura aucun effet. S’il vous faut une campagne complète propre à l’OU, créez-la depuis Campagnes, pas ici.',
        baseCampaignLabel: 'Campagne remplacée',
        baseCampaignNone: 'Non déclarée (s’applique à la campagne active qui couvre le périmètre)',
        baseCampaignNinguna: 'Aucune campagne Brillants Ensemble active. Créez-en une et activez-la, sinon cette exception ne s’appliquera à personne.',
        baseCampaignRequerida: 'Choisissez la campagne de base pour pouvoir enregistrer : sans elle, l’exception ne s’appliquerait à personne.',
        baseCampaignVentana: 'La campagne de base va du {{inicio}} au {{fin}}. Ces dates sont celles de la campagne et ne se modifient pas ici.',
        baseCampaignSinVentana: 'La campagne de base n’a pas de période définie.',
        scheduleWindow: 'Date et heure locales de l’exception',
        scheduleStart: 'Début de l’exception',
        scheduleEnd: 'Fin de l’exception',
        scheduleTz: 'Fuseau horaire',
        scheduleRestrictTitle: 'Désactiver les reconnaissances',
        scheduleRestrictNote: 'Lorsque activé, les reconnaissances ne peuvent pas être envoyées en dehors de la date et de l\'heure configurées pour ce périmètre. Nécessite l\'approbation de l\'admin global.',
        scheduleWindowNota: 'Si vous définissez une plage, les envois de ce périmètre y seront restreints. Laissez-la vide pour ne rien restreindre.',
        scheduleInvalid: 'La fenêtre horaire nécessite une date/heure de début et de fin, et la fin doit être postérieure au début.',
        bannerTitle: 'Bannière Shine Together (override)',
        bannerIntro: "Remplace le sous-titre et le logo de la bannière Shine Together uniquement pour le périmètre de cette exception. Si vous ne modifiez aucune langue ici, la bannière globale reste inchangée.",
        bannerScopeLabel: "Cette bannière s'applique uniquement au périmètre de cette exception, pas à la bannière globale Shine Together.",
        stepDocs: 'Documents',
        stepVisibility: 'Visibilité',
        scopeIntro: 'Définissez le périmètre organisationnel.',
        docsIntro: 'Joignez des documents spécifiques à cette exception par OU.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Portes d\'envoi activées (override)',
        entryPointModeApp: 'Formulaire uniquement',
        entryPointModePostit: 'Post-it interactif uniquement',
        entryPointModeAmbos: 'Les deux',
        reglasEnCampanaNote: 'Dans Brillamos, « Mode de reconnaissance », « Multi-personne » et « Multi-fondamental » se configurent dans chaque campagne (étape 5 de l’assistant) et priment sur cette exception.',
        visTitle: 'Visibilité de la reconnaissance (override)',
        visIntro: 'Configurez les informations affichées à l\'utilisateur lorsqu\'il reçoit ou consulte une reconnaissance.',
        visText: 'Afficher le texte/commentaire de la reconnaissance',
        visFundamental: 'Afficher le fondamental attribué',
        visSender: 'Afficher le nom de l\'expéditeur',
        visHabit: 'Afficher le Daily Habit sélectionné',
        visRanking: 'Afficher le classement des autres OU',
        visMultiFund: 'Autoriser plusieurs Fondamentaux par reconnaissance',
        maxFundamentales: 'Max. Fondamentaux par reconnaissance',
        rulesTitle: 'Règles d\'envoi (override)',
        ruleMultiPersona: 'Multi-personne',
        ruleComment: 'Commentaire obligatoire',
        ruleMinChars: 'Car. min.',
        ruleCsv: 'Import CSV',
        modTitle: 'Modération (override)',
        modReport: 'Bouton Signaler',
        modEditDelete: 'Boutons Modifier et Supprimer (envoyés uniquement)',
        streakTitle: 'Série (override)',
        streakMin: 'Min. envois/semaine',
        streakPeriod: 'Période',
        limitsTitle: 'Plafonds (override)',
        limitMax: 'Max. recos',
        limitFreq: 'Fréquence',
        approvalRequiredTitle: 'Approbation requise',
        approvalRequiredMsg: 'Toutes les modifications devront être approuvées par l\'Admin Global avant d\'être appliquées.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Frequence',
      frecuenciaPlaceholder: 'Ex. Mensuel, Toutes les 3 reunions…',
      frecuencia: {
        mensual: 'Mensuel',
        trimestral: 'Chaque trimestre',
        cadaNReuniones: 'Toutes les 3 reunions',
        porEvento: 'Par evenement',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Réactiver la campagne',
      // Ticket 04 — borrar borradores y pendientes de aprobación (Brillamos).
      deleteBtn: 'Supprimer',
      deleteConfirmTitle: 'Supprimer la campagne ?',
      deleteConfirm: '« {{name}} » sera supprimée. Action irréversible.',
      deleteConfirmPending: '« {{name}} » sera supprimée et sa demande d’approbation retirée. Action irréversible.',
      deleteDone: 'Campagne supprimée.',
      approvalCampaignGone: 'Cette campagne n’existe plus.',
      undoPanicConfirm: 'Cette campagne sera reactivee et de nouveau visible dans son perimetre. Possible uniquement dans les 24 h. Continuer?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Objectif de participants",
      metaParticipantesInherit: "Sans objectif",
      metaParticipantesHelp: "Personnes distinctes qui participent, en reconnaissant ou en étant reconnues. Vide = sans objectif.",
      tooltip: {
        entryPoints: 'Comment les collaborateurs peuvent reconnaître quelqu\'un : formulaire classique, post-it interactif, ou les deux à la fois.',
        ruleMultiPersona: 'Permet d\'inclure plusieurs personnes comme destinataires dans une même reconnaissance.',
        ruleMultiFundamental: 'Permet de sélectionner plusieurs Fondamentaux dans une même reconnaissance.',
        commentRequired: 'Exige la rédaction d\'un commentaire pour pouvoir envoyer la reconnaissance.',
        ruleBulkCsv: 'Active l\'import en masse de reconnaissances via un fichier CSV.',
        ruleReactions: 'Permet à d\'autres personnes de réagir avec des emojis à une reconnaissance.',
        ruleSendingDisabled: 'Désactive complètement l\'envoi de reconnaissances pour ce périmètre, sans affecter celles déjà envoyées.',
        ruleAnonymousEnabled: 'Permet d\'envoyer une reconnaissance sans afficher le nom de l\'expéditeur.',
        modPostEdit: 'Permet à l’expéditeur de modifier ou supprimer une reconnaissance envoyée. Dans une campagne, seulement tant qu’elle est ouverte ; les administrateurs le peuvent toujours. Utile pour corriger une erreur dans le texte sans demander de l’aide.',
        modAntiSpoiler: 'Tant que la campagne est ouverte, les reconnaissances reçues par ses participants ne sont visibles que par leur expéditeur : ni par le destinataire ni par ses collègues, quelle que soit la campagne d\'origine. Il prend fin à la clôture de la campagne. Utilisez-le quand la campagne récompense les plus reconnus : personne ne sait combien il en a avant la remise des prix.',
        antiSpoiler: 'Tant qu\'il est activé, les reconnaissances sans campagne ne sont visibles que par leur expéditeur. Il ne s\'arrête pas tout seul : il faut le désactiver.',
        streakActive: 'Active le décompte de la série hebdomadaire de reconnaissances pour cette campagne.',
        dailyHabitsMandatory: 'Exige de sélectionner une habitude quotidienne pour que la reconnaissance compte dans la série.',
        streakInProfile: 'Affiche la série actuelle sur le profil public de l\'utilisateur.',
        badgesActive: 'Active l\'attribution de badges pour l\'atteinte des objectifs de série.',
        limitsActive: 'Active les plafonds d\'envoi configurés ci-dessous, par reconnaissances et par Fondamentaux.',
        recognitionsLimitActive: 'Applique le plafond de reconnaissances par période à ce périmètre.',
        recognitionsLimitDisabled: 'Cochez « Non applicable » pour que cette campagne n\'ait AUCUN plafond total d\'envois : la personne peut envoyer autant de reconnaissances qu\'elle veut sur la période, quel que soit le plafond global de la Gestion. Laissez décoché (et le champ vide) pour utiliser le plafond global.',
        streakMinimum: 'Nombre minimal de reconnaissances qu\'une personne doit ENVOYER sur la période pour que celle-ci compte pour sa série (1-20). Remplace le minimum global de la Gestion pour cette campagne uniquement ; vide = le global s\'applique. Non modifiable une fois la campagne démarrée.',
        recognitionsLimitOwn: 'Nombre TOTAL maximal de reconnaissances qu\'une personne peut envoyer sur la période (à qui que ce soit, quel que soit le fondamental). Remplace le plafond global de la Gestion pour cette campagne uniquement ; vide = le global s\'applique. Modifiable à tout moment, même une fois la campagne démarrée.',
        sameFundamentalLimit: 'Combien de FOIS une personne peut reconnaître une autre sur le MÊME fondamental sur la période (à la même personne). Remplace la valeur globale de la Gestion pour cette campagne uniquement ; vide = le global s\'applique. En Europe, le minimum légal (RGPD) est conservé.',
        sameFundamentalLimitDisabled: 'Cochez « Non applicable » pour autoriser la répétition du même fondamental à la même personne SANS limite, quel que soit le global. Laissez décoché (et le champ vide) pour utiliser le global. En Europe, la limite légale est conservée même si coché.',
        fundamentalsLimitActive: 'Applique le plafond de Fondamentaux par envoi à ce périmètre.',
        designShowStreak: 'Affiche le bloc de série sur la page d\'accueil de cette campagne.',
        designShowRecent: 'Affiche les reconnaissances récentes sur la page d\'accueil de cette campagne.',
        visSender: 'Affiche le nom de la personne qui envoie la reconnaissance.',
        visFundamental: 'Affiche le Fondamental attribué dans la reconnaissance.',
        visText: 'Affiche le texte ou le commentaire de la reconnaissance.',
        visHabit: 'Affiche le Daily Habit sélectionné, le cas échéant.',
        visSent: 'Affiche l\'onglet des reconnaissances envoyées.',
        visReceived: 'Affiche l\'onglet des reconnaissances reçues.',
        visBulk: 'Active l\'import en masse par CSV uniquement pour cette campagne.',
        visReactions: 'Active les réactions avec emojis uniquement pour cette campagne.',
        visCampaignTag: 'Affiche l\'étiquette avec le nom de la campagne sur chaque post-it.',
        visFromFundamentals: 'Permet de démarrer cette reconnaissance depuis l\'écran des Fondamentaux.',
        visSendingDisabled: 'Désactive l\'envoi de reconnaissances uniquement pour cette campagne.',
        applyPoints: 'Les reconnaissances de cette campagne attribuent des points échangeables. Impossible à désactiver une fois la campagne démarrée.',
        visRanking: 'Affiche le classement comparé à celui des autres OU.',
        visMultiFund: 'Permet de sélectionner plusieurs Fondamentaux, en exception pour cette OU.',
        modReport: 'Permet de signaler une reconnaissance inappropriée.',
        modEditDelete: 'Active la modification et la suppression d\'une reconnaissance déjà envoyée, uniquement pour cette OU. Le backend gère les deux permissions avec un seul interrupteur.',
        scheduleEnabled: 'Restreint l\'envoi de reconnaissances à la plage horaire définie ci-dessus.',
        disableSend: 'Bloque l\'envoi de reconnaissances pour ce périmètre précis.',
        paisActive: 'Si désactivé, la campagne cesse d\'être active pour ce pays même si la date et l\'horaire configurés sont toujours en vigueur.',
        paisApplySchedule: "Désactivé, la date et l'horaire de cette ligne restent enregistrés mais ne s'appliquent PAS : le pays n'a aucune restriction horaire. Pratique pour préparer une plage et l'activer plus tard sans la ressaisir.",
        gestStreakEnabled: "Valeur globale : active le décompte de la série de reconnaissances. Chaque programme ou campagne peut définir le sien.",
        gestWrappedByOu: "Interrupteur principal du bilan annuel (Wrapped). Désactivé, personne ne le voit ; activé, chaque OU le voit pendant la fenêtre de visibilité de sa configuration dans Bilan.",
        gestAllowPromote: "Permet d'envoyer une reconnaissance de Fondamentaux aussi vers Brillamos : affiche la case dans Reconnaître et l'⭐ du mur et du profil.",
        gestStreakPerPersonCap: "Limite le nombre de reconnaissances 1:1 à la même personne qui comptent pour la série (anti-abus). Les reconnaissances de groupe comptent toujours. Le maximum se définit ci-dessous.",
        gestAvatarEnabled: "Permet à ceux qui entrent par la webapp de personnaliser un avatar de couleur. Ceux qui entrent par Teams gardent leur photo de profil.",
        gestAvatarSelector: "Affiche le sélecteur d'avatar juste après l'inscription. Nécessite que l'avatar personnalisable soit activé.",
        gestPanic: "Kill switch global : arrête immédiatement l'envoi de reconnaissances dans toutes les campagnes actives (Brillamos Juntos et Fondamentaux), sans toucher à celles déjà envoyées. Il ne peut être activé que s'il existe au moins une campagne Brillamos active.",
      },
      tooltipAria: 'Aide',
    },
    reports: { desc: 'Rapports et analytics du programme.' },
    translate: {
      button: 'Traduire vers les autres langues',
      buttonFrom: 'Traduire depuis {{lang}} vers les autres langues',
      loading: 'Traduction en cours…',
      hint: 'Saisissez au moins une langue pour traduire.',
      error: 'La traduction automatique a échoué.',
      sessionExpired: 'Votre session a expiré. Veuillez recharger la page et vous reconnecter.',
    },
    misSolicitudes: {
      title: "Mes demandes de campagne",
      desc: "L'état de ce que vous avez proposé. Vous pouvez retirer une demande tant qu'elle est en attente, et la renvoyer si elle a été refusée.",
      empty: "Vous n'avez encore envoyé aucune demande.",
      colCampana: "Campagne",
      colFecha: "Date de demande",
      colEstado: "État",
      colComentario: "Commentaire",
      colAcciones: "Actions",
      editar: "Modifier",
      retirar: "Retirer la demande",
      reenviar: "Renvoyer",
      estado: {
        pendiente: "En attente",
        aprobada: "Approuvée",
        rechazada: "Refusée",
      },
    },
    management: {
      desc: 'Règles d’envoi, plafonds et série.',
      title: 'Gestion',
      descLong: 'Paramètres globaux : description de la série ×7, badges, interrupteurs globaux et freeze. Enregistrement atomique.',
      fixValidation: "Corrigez les validations avant d'enregistrer.",
      streakDescription: 'Description de la série',
      fundamentalsTitle: 'Fondamentaux disponibles',
      fundamentalsDesc: 'Quels Fondamentaux sont proposés lors d’une reconnaissance. En retirer un ne le supprime pas du catalogue : il cesse d’apparaître dans ce programme.',
      fundamentalsLastOne: 'C’est le dernier disponible : si vous le retirez, personne ne pourrait envoyer de reconnaissance.',
      avatarTitle: 'Configuration de l’avatar (Frontline)',
      avatarDesc: 'Les utilisateurs frontline qui se connectent via la webapp peuvent personnaliser un avatar de couleur. Ceux qui passent par Teams gardent leur photo de profil.',
      avatarEnabled: 'Avatar personnalisable actif',
      avatarSelector: 'Afficher le sélecteur après l’inscription',
      avatarColors: 'Avatars disponibles :',
      placeholderTitle: 'Description configurable du champ de texte',
      placeholderDesc: 'Le texte d’aide du champ message lors d’une reconnaissance. Chaque langue laissée vide utilise le texte par défaut du produit.',
      placeholderLabel: 'Texte d’aide du message',
      panicTitle: 'Bouton d’urgence — Brillamos Juntos',
      panicDesc: 'Désactive immédiatement l’envoi de reconnaissances dans toutes les campagnes actives. S’applique aussi bien à Shine Together qu’à Reconnaître (Fondamentaux). Admin Général uniquement.',
      panicToggle: 'Kill Switch global Brillamos',
      panicActiveHint: 'L’envoi est DÉSACTIVÉ : personne ne peut envoyer de reconnaissance en ce moment.',
      panicSameSwitchHint: 'C’est un interrupteur global : tant qu’il est actif, aucun réglage par programme ou par campagne ne peut réactiver l’envoi.',
      panicNoActiveCampaign: 'Cet interrupteur s’active dès qu’au moins une campagne Brillants Ensemble est active (RN-C08). Il n’y en a aucune pour le moment, donc aucun envoi de campagne à arrêter.',
      needAllLangs: 'Complétez les 7 langues.',
      globalToggles: 'Interrupteurs globaux',
      streakEnabled: 'Série active',
      multinomination: 'Multinomination',
      dailyHabitsMandatory: 'Habitudes quotidiennes obligatoires',
      antiSpoiler: 'Anti-spoiler',
      antiSpoilerTitle: 'Mode Anti-Spoiler (remise de prix)',
      antiSpoilerDesc: 'Masque temporairement les profils et les reconnaissances des autres pendant la remise de prix annuelle, afin de ne pas révéler les gagnants.',
      antiSpoilerActivo: 'Anti-spoiler actif',
      antiSpoilerFrom: 'Du',
      antiSpoilerTo: 'Au',
      antiSpoilerHint: 'Tant qu’il est actif, les collaborateurs ne peuvent voir ni les profils de leurs collègues ni le détail des reconnaissances des autres.',
      antiSpoilerSinVentana: 'Sans dates, il protège tant que l’interrupteur est activé.',
      antiSpoilerVentanaInvertida: '« Du » est postérieur à « Au » : une telle fenêtre ne protège jamais. Corrigez-la pour enregistrer.',
      wrappedByOu: 'Wrapped par OU',
      reactionsEnabled: 'Réactions (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Autoriser l’envoi vers Brillamos',
      allowPostEdit: 'Édition après envoi',
      postEditTitle: 'Modification des reconnaissances envoyées',
      postEditDesc: 'Permet à l’expéditeur de modifier le message d’une reconnaissance déjà envoyée. Désactivé par défaut.',
      postEditWindow: 'Fenêtre de modification',
      postEditWindowOpt: { '24h': '24 heures', '48h': '48 heures', '7d': '7 jours', unlimited: 'Sans limite' },
      streakPerPersonCapEnabled: 'Plafond par personne (série)',
      streakPerPersonCap: 'Max par personne (série)',
      weeklyMinimum: 'Minimum par période',
      periodicity: 'Périodicité',
      period: { weekly: 'Hebdomadaire', monthly: 'Mensuelle' },
      periodicityHint: 'Le minimum s\'applique à la période choisie : en Mensuelle, la série progresse ou se rompt par mois calendaire, non par semaine.',
      periodicityMonthlyWarning: 'En Mensuelle, la série compte des MOIS consécutifs et l\'application le reflète déjà (widget, Profil, Wrapped et seuils). DEUX décisions Produit restent avant activation en production : le RF-038 définit les seuils de badge en semaines (1/4/8/12/20), donc celui de 4 serait atteint au bout de 4 mois ; et le plafond anti-abus de 2 reconnaissances par personne passe de la semaine au mois, ce qui peut rendre un minimum élevé inatteignable dans de petites équipes.',
      freezeFrom: 'Freeze depuis',
      freezeTo: "Freeze jusqu'à",
      badges: 'Badges',
      noBadges: "Aucun badge n'est configuré.",
      badge: 'Badge',
      weeksRequired: '{{count}} semaines',
      weeksRequiredOne: '{{count}} semaine',
      weeksRequiredMany: '{{count}} semaines',
      badgeName: 'Nom du badge',
      badgeIcon: 'Icône',
      badgeColor: 'Couleur',
      weeks: 'Semaines requises',
      notApplicable: 'Sans objet',
      iconFormatInvalid: "Format d'image invalide. Utilisez PNG, JPG, WEBP ou SVG.",
      addBadge: '+ Ajouter un badge',
      editBadge: 'Modifier',
      deleteBadge: 'Supprimer',
      deleteBadgeConfirm: 'Supprimer le badge « {{name}} » ? Son nom dans les 7 langues, son icône et son seuil seront perdus. La suppression prend effet à l’enregistrement.',
      badgeActive: 'Actif',
      badgeInactive: 'Inactif',
      imageUploadHintNew: "Enregistrez d'abord le badge pour pouvoir importer l'icône.",
      previewTitle: 'Aperçu',
      saveBadgeChanges: 'Enregistrer les modifications',
    },
    // PHASE 7 (parité démo, H-93/H-94/H-95) — Admin › Notifications (REQ-135).
    notifications: {
      title: 'Configuration des notifications',
      desc: "Configurez quels avis par e-mail sont envoyés et à quel niveau de l'organisation. Les valeurs non définies à ce niveau sont héritées du niveau suivant.",
      precedenceTitle: 'Comment la configuration est résolue',
      precedence1: "Priorité : Site > BU > OU > Global. La valeur définie au niveau le plus spécifique l'emporte.",
      precedence2: "Un bouton « Hérité » n'est pas désactivé : il prend la valeur du niveau inférieur. Seul ce que vous définissez ici est enregistré.",
      precedence3: "Chaque personne peut aussi désactiver ses propres e-mails depuis son profil ; cette préférence ne réactive jamais ce qui est désactivé ici.",
      scopeTitle: 'Niveau de configuration',
      scopeUnit: 'Unité',
      scopePick: 'Sélectionnez une unité…',
      scopeRequired: 'Sélectionnez une unité pour voir et modifier sa configuration.',
      scopeOuContext: "OU de l'unité",
      scopeOuFirst: "Sélectionnez d'abord une OU…",
      unsavedLock: "Vous avez des modifications non enregistrées ; le niveau reste fixe jusqu'à ce que vous les enregistriez ou les abandonniez.",
      discard: 'Abandonner les modifications',
      scope: { global: 'Global (tout le tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'E-mail', categories: "Types d'avis", summary: 'Résumé périodique', blocked: 'E-mails bloqués' },
      blocked: {
        desc: "Adresses qui ne recevront aucun e-mail du programme, quels que soient leurs réglages personnels.",
        scopeWarning: "Le blocage vaut pour TOUT le tenant, pas seulement pour ce niveau : un e-mail bloqué ici l'est dans toutes les OU. Il prime aussi sur l'interrupteur principal.",
        placeholder: 'nom@entreprise.com',
        add: 'Bloquer',
        remove: 'Débloquer {{email}}',
        empty: "Aucun e-mail bloqué.",
      },
      design: {
        title: 'Design des e-mails',
        desc: 'Voici à quoi ils ressemblent aujourd\'hui : les Fondamentaux utilisent un style chaleureux et Shine Together un style sombre avec des étoiles. Le design de chaque e-mail se règle dans le modèle lui-même, pas ici.',
        fund: { name: 'Fondamentaux', style: 'Style chaleureux · Crème/Orange' },
        shine: { name: '✨ Shine Together', style: 'Style sombre · Étoiles/Violet' },
      },
      broadcast: {
        title: 'Avis système',
        desc: 'Pour les maintenances, les interruptions ou tout avis ponctuel. Il part avec le modèle déjà conçu : il suffit d\'écrire le message.',
        overridesHint: '🔴 Cet avis atteint TOUT LE MONDE, même les personnes qui ont coupé leurs notifications. Ce n\'est pas du contenu du programme : c\'est une information sur l\'outil.',
        kindLabel: 'Type d\'avis',
        kind: { maintenance: 'Maintenance planifiée', suspension: 'Interruption temporaire', restored: 'Service rétabli', general: 'Avis général' },
        subject: 'Objet',
        subjectPlaceholder: 'Maintenance planifiée — samedi 2 h',
        message: 'Message',
        messagePlaceholder: 'Message pour les utilisateurs...',
        everyone: 'Tout le monde',
        singleOu: 'Une UO précise',
        chooseOu: 'Choisir une UO',
        send: 'Envoyer l\'avis maintenant',
        error: 'L\'avis n\'a pas pu être envoyé.',
        sentSummary: 'Envoyé à {{sent}} personnes sur {{recipients}}.',
        skipped: '· {{count}} sans identité résoluble ne l\'ont pas reçu.',
      },
      channel: { inapp: 'Cloche', email: 'E-mail', teams: 'Teams' },
      tables: {
        shine: '✨ Notifications — Shine Together',
        admin: '🛡️ Notifications — Admin',
        colType: 'Type',
        colSubject: 'Objet (ES)',
        colLanguages: 'Langues',
        editSubject: 'Modifier l\'objet de « {{row}} » dans les 7 langues',
        subjectByLanguage: 'Objet par langue',
        close: 'Fermer',
        saveSubject: 'Enregistrer l\'objet',
        nineRows: 'Neuf lignes et non treize : quatre de celles que la maquette dessine ne correspondent à aucun avis que le système envoie aujourd\'hui.',
        rows: {
          'campaign-new': { name: 'Nouvelle campagne lancée', trigger: 'Un administrateur active une campagne' },
          'campaign-ending': { name: 'Campagne bientôt terminée', trigger: 'Derniers jours pour nommer' },
          'recognition-sent': { name: 'Reconnaissance envoyée à Shine Together', trigger: 'Confirmation qu\'elle compte pour la campagne' },
          'ranking-position': { name: 'Position au classement', trigger: 'Vous montez au classement' },
          'campaign-approval': { name: 'Demande de campagne locale', trigger: 'Un admin d\'UO crée une demande → Admin Global' },
          'moderation-case-alert': { name: 'Signalement de modération', trigger: 'Un nouveau signalement attend l\'admin de l\'UO' },
          'moderation-educational': { name: 'Message signalé, avis à l\'expéditeur', trigger: 'Prévient la personne qui a envoyé la reconnaissance' },
          'low-participation-alert': { name: 'Alerte de faible participation', trigger: 'Une campagne est sous le seuil de participation' },
          'pending-nomination-manager': { name: 'Nomination en attente (manager)', trigger: 'Une nomination doit être approuvée' },
        },
      },
      master: {
        label: 'Notifications par e-mail',
        desc: "Interrupteur principal : s'il est désactivé, aucun e-mail du programme n'est envoyé dans cette portée. N'affecte ni Teams ni la cloche.",
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Reconnaissances reçues', desc: "Avis à la personne lorsque quelqu'un la reconnaît." },
        streakAndBadgesEnabled: { label: 'Séries et badges', desc: 'Rappels de série et badges débloqués.' },
        campaignsEnabled: { label: 'Campagnes', desc: 'Nouvelle campagne, campagne bientôt terminée, gagnants et approbations.' },
        digestEnabled: { label: 'Résumé hebdomadaire', desc: "Digest avec l'activité accumulée de la semaine." },
      },
      monthly: {
        label: 'Résumé mensuel',
        desc: 'Désactivé par défaut. Activez-le uniquement si cette unité souhaite aussi un résumé mensuel.',
      },
      masterOffHint: "Les types individuels ne fonctionnent qu'avec l'interrupteur principal activé.",
      inherited: 'Hérité',
      inApp: { label: 'Notifications in-app (cloche)', desc: 'La cloche du portail. Elle ne dépend pas de l’interrupteur e-mail : c’est un canal à part.' },
      teams: { label: 'Activity Feed de Teams', desc: 'L’avis dans le fil d’activité Teams, pour les personnes ayant un compte d’entreprise.' },
      frequency: {
        label: 'Fréquence d’envoi (e-mail)',
        desc: 'À quelle fréquence les avis sont regroupés en un résumé. Les e-mails par événement ne sont pas concernés.',
        opt: {
          immediate: 'Immédiat (par événement)',
          daily: 'Résumé quotidien',
          weekly: 'Résumé hebdomadaire',
          biweekly: 'Résumé bimensuel (toutes les 2 semaines)',
        },
        immediateHint: 'Avec « Immédiat » aucun résumé n’est envoyé, même si sa catégorie reste activée : chaque avis part seul.',
      },
      resetToInherited: 'Revenir à hérité',
      active: 'actifs',
      saved: 'Modifications enregistrées !',
      loadError: 'Impossible de charger la configuration de ce niveau.',
      saveError: "Impossible d'enregistrer la configuration. Veuillez réessayer.",
    },
    views: {
      title: 'Vues des utilisateurs',
      desc: 'Vues visibles par le collaborateur et microsites.',
      descLong: 'Quelles vues chaque OU propose à ses collaborateurs. Compatible bureau + mobile.',
      scope: 'Niveau de configuration',
      scopeGlobal: 'Global (toutes les OU)',
      unsavedLock: 'Enregistrez ou annulez vos modifications avant de changer de niveau.',
      cancelChanges: 'Annuler les modifications',
      infoAria: 'Aide sur {{label}}',
      micrositesTitle: 'URLs des microsites par Fondamental',
      micrositesDesc: 'Lien externe avec plus d’informations sur chaque Fondamental. Laissez vide s’il n’y a pas de microsite.',
      card: {
        medallero: { label: 'Palmarès', desc: 'Envoyées + reçues' },
        perfilUsuario: { label: 'Profil utilisateur', desc: 'Reçues du plus récent au plus ancien' },
        enviarReconocimiento: {
          label: 'Envoyer une reconnaissance', desc: 'Selon la configuration de l’admin',
          tooltip: 'Affiche le bouton et le formulaire pour reconnaître un collègue. Se combine avec l’interrupteur général d’envoi : si celui-ci est désactivé, cette vue n’apparaît pas même si elle est activée ici.',
        },
        historicoPorAnio: {
          label: 'Historique par année', desc: 'Année en cours d’abord',
          tooltip: 'Permet de voir l’historique des reconnaissances regroupé par année, année en cours d’abord. Dépend aussi du fait que la campagne active ait l’historique activé.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Classement',
          tooltip: 'Affiche le classement des personnes qui ont envoyé ou reçu le plus de reconnaissances. C’est la seule vue désactivée par défaut.',
        },
        feedActividad: { label: 'Fil d’activité', desc: 'Chronologie récente' },
        resumenMensual: {
          label: 'Résumé mensuel', desc: 'Rétrospective façon Spotify',
          tooltip: 'Active la rétrospective façon « Wrapped » avec les chiffres de la période pour chaque collaborateur. Visible seulement si le Wrapped est activé pour l’OU et que la campagne est déjà clôturée.',
        },
        busquedaCompaneros: {
          label: 'Recherche de collègues', desc: 'Voir le palmarès des autres',
          tooltip: 'Permet de rechercher et de voir le palmarès d’autres collègues. Se masque automatiquement pendant que le Mode Anti-Spoiler est actif, pour ne pas gâcher les surprises avant une remise de prix.',
        },
        vistaFundamentales: {
          label: 'Vue Fondamentaux', desc: 'Infos sur chaque fondamental',
          tooltip: 'Affiche la constellation avec les informations de chaque Fondamental de la culture dans l’écran Brillamos Juntos.',
        },
        banderaReportar: {
          label: 'Drapeau de signalement', desc: 'Signaler des reconnaissances inappropriées',
          tooltip: 'Ajoute un bouton pour que les collaborateurs puissent signaler une reconnaissance inappropriée. Dépend aussi du fait que le drapeau de signalement soit activé dans Modération.',
        },
        recordatorioDiario: { label: 'Rappel quotidien', desc: 'Incitation quotidienne à reconnaître' },
        verATuEquipo: {
          label: 'Voir votre équipe', desc: 'Réservé aux responsables',
          tooltip: 'Permet aux responsables et managers de voir les reconnaissances des personnes qu’ils encadrent. S’applique uniquement à qui est responsable dans l’organigramme et possède la permission des indicateurs d’équipe.',
        },
      },
      compose: {
        sending: 'Dépend aussi du bouton d’urgence : avec l’envoi désactivé, cette vue n’apparaît pas même si elle est activée ici.',
        campaign: 'Dépend aussi du toggle d’historique de la campagne active (RN-PR09).',
        wrapped: 'Dépend aussi de l’activation du Wrapped dans l’OU et de la clôture de sa campagne.',
        antiSpoiler: 'Dépend aussi du mode Anti-Spoiler : tant que sa fenêtre est active, cette vue est masquée.',
        report: 'Dépend aussi du toggle « Bouton Signaler » de la section Modération.',
        manager: 'Dépend aussi du fait d’être responsable dans l’organigramme et d’avoir la permission de métriques d’équipe.',
      },
    },
    docs: {
      desc: 'Documents corporatifs et légaux.',
      legalTab: 'Mentions légales',
      privacyTab: 'Avis de confidentialité',
      corpTab: 'Entreprise',
      pillsTab: 'Pills utilisateur',
      bibliotecaTab: 'Bibliothèque',
      legalesTab: 'Docs légaux',
      gestionTitle: 'Gestion de la documentation',
      gestionDesc: 'Configurez les accès rapides des utilisateurs, gérez la bibliothèque de fichiers et les documents juridiques obligatoires.',
      pills: {
        nueva: 'Ajouter une pastille',
        sectionTitle: 'Accès rapides (Pills)',
        sectionSubtitle: 'Capsules d’accès rapide visibles dans l’interface utilisateur. Définissez le nom, l’icône, la couleur et le contenu qu’elles ouvrent au clic.',
        editar: 'Modifier la pastille',
        titulo: 'Titre',
        tipo: 'Type',
        tipos: { documento: 'Document', url: 'Lien', video: 'Vidéo' },
        icono: 'Icône',
        color: 'Couleur',
        orden: 'Ordre',
        documento: "Document d'entreprise",
        elegirDocumento: 'Choisir un document…',
        sinDocumentos: "Aucun document d'entreprise disponible. Téléversez-les dans l'onglet Entreprise.",
        url: 'URL de destination',
        visibilidad: 'Visibilité par UO',
        visibilidadHint: 'Aucune UO sélectionnée = visible par toutes les unités.',
        activa: 'Pastille active (affichée dans le rail)',
        activaSi: 'Active',
        activaNo: 'Inactive',
        estado: 'État',
        vistaPrevia: 'Aperçu',
        nombre: 'Nom',
        tipoContenido: 'Type de contenu',
        documentoColumna: 'Document lié',
        documentoNoEncontrado: 'Document introuvable',
        documentoAlcanceIncompleto: "Ne couvre pas toutes les UO de cette pill",
        sinTitulo: 'Sans titre',
        todas: 'Toutes',
        vacio: 'Aucun accès rapide configuré pour le moment.',
        eliminar: 'Supprimer la pastille',
        eliminarConfirm: 'Supprimer cet accès rapide du rail ?',
        errorCargar: 'Impossible de charger les accès rapides.',
        errorGuardar: "Impossible d'enregistrer l'accès rapide.",
        errorEliminar: "Impossible de supprimer l'accès rapide.",
      },
      corp: {
        firstLogin: 'Première connexion',
        versionEs: 'Version ES',
        versionEn: 'Version EN',
        subirVersion: 'Téléverser',
        reemplazar: 'Remplacer',
        verVersion: 'Voir la version',
        quitarVersion: 'Retirer la version',
        triggerUpdate: 'Déclencher MàJ',
        ousActivas: 'OUs actives',
        nombre: 'Nom du document',
        tipo: 'Type',
        visibilidad: 'Visibilité par OU',
        idiomas: 'Langues',
        idiomasHint: 'Aucune sélection = toutes les langues.',
        versionesPorIdioma: 'Versions par langue',
        versionesPorIdiomaCount: 'Versions ({{count}}/{{total}})',
        archivo: 'Fichier PDF',
        elegirArchivo: 'Choisir un PDF…',
        subir: 'Téléverser le document',
        agregarDocumento: 'Ajouter un document',
        subirArchivo: 'Téléverser un fichier',
        libType: { todos: 'Tous', pdf: 'PDF', video: 'Vidéo', imagen: 'Image' },
        filterType: 'Type',
        nombreArchivo: 'Nom du fichier',
        idioma: 'Langue',
        pillAsignado: 'Pastille assignée',
        subido: 'Téléversé',
        documento: 'Document',
        actualizado: 'Mis à jour',
        mediaKind: 'Type de fichier',
        externalUrl: 'URL externe',
        externalUrlHint: 'Collez le lien de la vidéo ou de l’image (Teams, SharePoint, etc.).',
        requiereUrl: 'Saisissez une URL externe valide.',
        abrir: 'Ouvrir',
        dropMain: 'Glissez les fichiers ici ou cliquez pour téléverser',
        dropSub: 'PDF · Max. 25 Mo par fichier',
        subidoOk: 'Document téléversé.',
        errorSubir: "Le document n'a pas pu être téléversé.",
        lista: 'Documents téléversés',
        listaCount: '{{count}} documents configurés',
        legalInfo: 'Ces documents s\'affichent dans la fenêtre d\'acceptation obligatoire. La première connexion les active au premier accès. Déclencher une mise à jour les réaffiche même si l\'utilisateur les a déjà acceptés. Une acceptation explicite est requise pour continuer.',
        searchPlaceholder: 'Rechercher un fichier…',
        filterLang: 'Filtrer par langue',
        filterLangAll: 'Toutes les langues',
        noResults: 'Aucun document ne correspond au filtre.',
        vacio: "Il n'y a pas encore de documents d'entreprise.",
        fecha: 'Date',
        acciones: 'Actions',
        descargar: 'Télécharger',
        editar: 'Modifier',
        eliminar: 'Supprimer',
        guardar: 'Enregistrer les modifications',
        cancelar: 'Annuler',
        eliminarConfirm: 'Supprimer ce document du référentiel ?',
        errorEliminar: "Le document n'a pas pu être supprimé.",
        errorActualizar: "Le document n'a pas pu être mis à jour.",
        errorCargar: "La liste n'a pas pu être chargée.",
        soloPdf: 'Seuls les PDF jusqu’à 25 Mo sont acceptés.',
        requiereNombre: 'Saisissez un nom.',
        requiereOu: 'Sélectionnez au moins une OU.',
        requiereArchivo: 'Choisissez un fichier PDF.',
        tipos: {
          PoliticaPrivacidad: 'Politique de confidentialité',
          BasesLegales: 'Mentions légales',
          GuiaUsuario: "Guide de l'utilisateur",
          Premios: 'Prix',
          CookiesPolicy: 'Politique de cookies',
          LegalNotice: 'Mentions légales',
        },
      },
      currentVersion: 'Version en vigueur',
      noVersionYet: "Aucune version n'a encore été publiée",
      newVersionLabel: 'Nouvelle version à publier',
      loadError: 'Impossible de charger le brouillon.',
      titleLabel: 'Titre',
      sectionHeading: 'Titre de section',
      sectionBody: 'Contenu',
      addSection: 'Ajouter une section',
      removeSection: 'Supprimer la section',
      saveDraft: 'Enregistrer le brouillon',
      publish: 'Publier',
      publishConfirm: 'Vous allez publier une nouvelle version. Tous les utilisateurs devront l’accepter à nouveau avant de pouvoir reconnaître un collègue. Continuer ?',
      missingLanguages: 'Langues manquantes : {{languages}}',
      draftSaved: 'Brouillon enregistré',
      published: 'Version publiée',
      saveError: "Impossible d'enregistrer le brouillon.",
      publishError: 'Impossible de publier la version.',
    },
    recap: {
      title: 'Recap Annuel',
      desc: 'Configurez l’expérience Recap par édition. Les fonds et les icônes sont configurables par slide ; les données de l’utilisateur (reconnaissances, Fondamental le plus reçu, fan nº 1, série) sont injectées automatiquement par la plateforme.',
      deniedRole: 'La gestion du Recap est réservée à l’Admin Général et à l’Admin Fondamentaux.',
      fixValidation: "Complétez les textes obligatoires avant d'enregistrer.",
      noEditions: "Il n'y a pas encore d'éditions du Recap.",
      createFirst: 'Créer la première édition',
      edition: 'Édition',
      editionName: "Nom visible par l'utilisateur",
      newEdition: 'Nouvelle édition',
      newConfig: 'Nouvelle configuration',
      newConfigName: 'Recap {{year}} · nouvelle configuration',
      newEditionTitle: 'Nouvelle édition du bilan',
      newEditionYear: 'Année de l’édition',
      newEditionYearRange: 'Choisissez une année entre {{min}} et {{max}}.',
      newEditionFutureWarn: 'Personne ne verra une édition {{year}} avant cette année-là.',
      newEditionExisting: 'Il existe déjà des configurations pour {{year}} : une autre sera créée, inactive.',
      newEditionCreate: 'Créer l’édition',
      delete: 'Supprimer',
      deleteAria: 'Supprimer la configuration {{name}}',
      deleteTitle: 'Supprimer la configuration',
      deleteConfirm: '« {{name}} » ({{year}}) sera supprimée : elle disparaît de l’historique et du sélecteur. Continuer ?',
      deleteBlockedActive: 'Seules les éditions en Brouillon peuvent être supprimées. Passez « Recap actif » à Inactif et enregistrez d’abord.',
      deleteError: 'La configuration n’a pas pu être supprimée.',
      vistasOff: 'Le Bilan est désactivé dans Vues pour {{ous}} : activez-le pour qu’il soit visible.',
      gestionOff: 'Le Bilan est désactivé dans Gestion (« Bilan par OU ») : activez-le pour qu’il soit visible.',
      gestionOffCreate: 'Tant que le Bilan est désactivé dans Gestion (« Bilan par OU »), aucune édition ni configuration ne peut être créée.',
      configsHint: 'Chaque configuration a son propre périmètre d’UO, son statut, sa fenêtre et sa notification. Plusieurs peuvent être actives en même temps tant qu’elles ne partagent pas d’UO ; si une UO est incluse dans une autre (MEXICO et l’une de ses usines), chaque collaborateur voit la plus spécifique pour son UO.',
      openConfig: 'Ouvrir la configuration {{name}}',
      scope: 'Périmètre OU',
      scopeGlobal: 'Global (toutes)',
      active: 'Recap actif',
      activeOn: 'Actif',
      activeOff: 'Inactif',
      visibleFrom: 'Début de visibilité',
      visibleTo: 'Fin de visibilité',
      notification: 'Notification',
      notifiedAt: 'Envoyée {{date}}',
      neverNotified: 'Non notifiée',
      difusionLockHint: 'Ce Recap a déjà été annoncé. Vous pouvez ÉLARGIR sa portée et sa fenêtre de visibilité, mais pas les réduire : retirer une OU ou raccourcir les dates exclurait des personnes déjà prévenues. Le reste de l’édition reste modifiable.',
      slidesTitle: 'Configuration des slides ({{count}} slides)',
      slidesHint: 'Les icônes de Fondamentaux et les données de l’utilisateur sont injectées automatiquement. Ici vous configurez uniquement la couche visuelle et les textes.',
      i18nHint: 'Multilingue : le titre de chaque slide est saisi dans les 7 langues depuis le bouton Modifier.',
      slidesFor: 'Configurer les diapositives pour',
      slidesForGlobal: 'Global (toutes les OU)',
      slidesForGlobalNote: "Configuration de base : utilisée par toutes les OU qui n'ont pas la leur.",
      slidesForCustomNote: "{{ou}} a sa propre configuration de diapositives ; elle s'applique aussi à ses sous-OU qui n'ont pas la leur.",
      slidesForInheritedNote: '{{ou}} utilise la configuration de {{from}}. Activer ou désactiver une diapositive crée une configuration propre à {{ou}}.',
      slidesForRemoveCustom: 'Supprimer la configuration propre',
      customizedOus: 'OU avec leur propre configuration :',
      customizedOuCount: '{{count}} diapositives',
      lastSlideOn: 'Au moins une diapositive doit rester activée.',
      colSlide: 'Slide',
      colPreview: 'Aperçu',
      colTitle: 'Titre',
      colActive: 'Actif',
      colActions: 'Actions',
      edit: 'Modifier',
      titleMissing: 'Sans titre',
      needAllLangs: 'Il manque des langues à saisir (les 7 sont requises).',
      slides: {
        portada:    { name: 'Couverture',                  hint: 'Écran de bienvenue' },
        numeros:    { name: 'Votre année en chiffres',     hint: 'Reçues + envoyées' },
        define:     { name: 'Ce qui vous définit',         hint: 'Fondamental le plus reçu (donnée automatique)' },
        mensaje:    { name: 'Le message',                  hint: 'Reconnaissance la plus longue (donnée automatique)' },
        quienes:    { name: 'Qui vous a reconnu',          hint: 'Totaux et personnes (donnée automatique)' },
        red:        { name: 'Votre réseau',                hint: 'Différents domaines qui vous ont reconnu (donnée automatique)' },
        constancia: { name: 'Votre constance',             hint: 'Série de semaines (donnée automatique)' },
        reto:       { name: 'Votre défi de l’an prochain', hint: 'Fondamental le moins montré et appel à l’action' },
        ganador:    { name: 'Gagnant Annuel',              hint: 'Si l’utilisateur a gagné : badge réel de la section Gagnants' },
      },
      notifyTitle: 'Notification du Recap',
      notifyDesc: 'Informez les collaborateurs du périmètre sélectionné que leur Recap {{year}} est prêt.',
      preview: 'Aperçu',
      send: 'Envoyer la notification',
      notifyNeedsActive: "Activez l'édition pour pouvoir la notifier.",
      notifyError: "Impossible d'envoyer la notification.",
      previewNote: 'Voici comment l’édition se parcourt : seuls les slides actifs, avec leurs fonds et titres. Les chiffres sont ceux de l’utilisateur qui l’ouvre.',
      genericTitle: 'Message générique (repli)',
      genericDesc: 'Il s’affiche quand l’utilisateur n’a pas de reconnaissances sur la période ou quand il entre avant que le Recap soit visible.',
      genericTitleLabel: 'Titre du message générique',
      genericDescLabel: 'Sous-titre / description',
      genericNote: 'Ce message est le repli : celui qui a des données verra son Recap personnalisé.',
      imageUrlPlaceholder: "URL de l'image (PNG / JPG)",
      historyTitle: 'Historique du Recap et gagnants annuels',
      historyDesc: 'Éditions enregistrées et gagnants annuels associés à chacune.',
      colEdition: 'Édition',
      colYear: 'Année',
      colScope: 'Périmètre',
      colSlides: 'Slides',
      colWinners: 'Gagnants annuels',
      colStatus: 'Statut',
      winnersCount: '{{count}} gagnants',
      status: { activa: 'Active', completada: 'Terminée', borrador: 'Brouillon', programada: 'Programmée' },
      editorTitle: 'Modifier le slide {{index}}',
      editorDescData: 'Configurez le titre (7 langues), le fond et le texte qui accompagne la donnée dynamique. L’aperçu se met à jour pendant que vous écrivez.',
      editorDescIcon: 'Configurez le titre (7 langues), le fond et l’icône du slide. L’aperçu se met à jour pendant que vous écrivez.',
      titleLangs: 'Titre (7 langues)',
      titlePlaceholder: 'Titre en {{lang}}',
      autoIcon: 'L’icône de ce slide est automatique : elle utilise le badge réel du gagnant configuré dans Gagnants.',
      icon: 'Icône',
      iconPlaceholder: "Emoji ou URL d'image",
      numberLabels: 'Texte sous les chiffres',
      numberLabelsHint: 'Les chiffres sont calculés par la plateforme ; ici vous définissez le mot qui va dessous.',
      numberLabelPlaceholder: 'Ex. : reçues',
      background: 'Fond',
      uploadPhoto: 'Importer une photo',
      uploadingPhoto: 'Importation…',
      removePhoto: 'Retirer la photo',
      photoHint: 'PNG · taille recommandée 1080 × 1920 px · 5 Mo max. La photo s’affiche par-dessus la couleur, qui reste en secours.',
      photoErrPng: 'Le fond doit être une image PNG.',
      photoErrSize: 'L’image dépasse 5 Mo.',
      photoErrUpload: 'Impossible d’importer l’image. Réessayez.',
      photoErrNotPng: 'Le fichier a l’extension .png mais est en réalité {{formato}}. Enregistrez-le au format PNG et importez-le à nouveau.',
      photoErrRejected: 'Le serveur a refusé l’image : {{motivo}}',
      photoErrUnavailable: 'L’import de fonds n’est pas encore disponible dans cet environnement (404). Contactez le support.',
      photoErrForbidden: 'Vous n’avez pas l’autorisation d’importer des fonds du Récap.',
      photoErrUploadCode: 'Impossible d’importer l’image (code {{codigo}}). Réessayez ; si le problème persiste, contactez le support.',
      previewLabel: 'Aperçu',
      previewDataNote: 'Les chiffres affichés sont ceux de l’utilisateur qui ouvre son Recap.',
      apply: 'Appliquer',
    },
  },
  // ── WP-16 REQ-140 — Modales légales ──
  legal: {
    privacy: 'Politique de confidentialité',
    legal: 'Règlement du Programme',
    reachedEnd: 'Vous êtes arrivé à la fin !',
    scrollHint: "Faites défiler jusqu'à la fin pour accepter",
    accept: "J'accepte",
    acceptError: "Nous n'avons pas pu enregistrer votre acceptation. Vérifiez votre connexion et réessayez ; si le problème persiste, contactez le support.",
    loadError: 'Impossible de charger le document.',
    pdfError: "Impossible d'afficher le document PDF.",
    retry: 'Réessayer',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
  },
  // ── WP-16 REQ-139 — Inscription standalone Frontline ──
  register: {
    backToLogin: '← Retour à la connexion',
    entraTitle: 'Vous avez déjà un e-mail professionnel ?',
    entraSub: "Vous n'avez pas besoin de vous inscrire — connectez-vous directement avec votre compte Sigma.",
    title: 'Inscription',
    subtitle: 'Créez votre accès au Programme de Reconnaissance "Shine together"',
    fullName: 'Nom complet',
    email: 'Adresse e-mail',
    ou: 'Entreprise',
    selectOu: 'Sélectionnez votre OU',
    startDate: "Date d'entrée chez Sigma",
    employeeId: 'Numéro de matricule',
    bu: 'Entreprise',
    site: 'Site de travail',
    department: 'Département',
    selectBu: 'Sélectionnez votre Entreprise',
    selectSite: 'Sélectionnez votre site de travail',
    selectDepartment: 'Sélectionnez votre département',
    errName: 'Saisissez votre nom complet.',
    errEmail: 'Saisissez une adresse e-mail valide.',
    errOu: 'Sélectionnez votre OU.',
    errCatalogs: 'Complétez entreprise, site et département.',
    errStartDate: "Saisissez votre date d'entrée.",
    errEmployeeId: 'Saisissez votre numéro de matricule.',
    catalogsError: 'Impossible de charger les catalogues.',
    submit: "M'inscrire",
    submitError: "Impossible de finaliser l'inscription.",
    checkEmailTitle: 'Vérifiez votre e-mail',
    checkEmailSub: 'Nous avons envoyé un lien de vérification à {{email}}.',
    verified: 'E-mail vérifié',
    allSet: 'Tout est prêt !',
    allSetSub: "Votre compte est configuré. Vous pouvez d'ores et déjà reconnaître vos collègues.",
    password: 'Mot de passe (min. 8 caractères)',
    confirmPassword: 'Confirmer le mot de passe',
    errPassword: 'Le mot de passe doit contenir entre 8 et 256 caractères.',
    errPasswordMatch: 'Les mots de passe ne correspondent pas.',
    errLegal: 'Acceptez le Règlement.',
    errLegalVersion: 'Impossible de charger le document légal. Réessayez.',
    errPrivacy: "Vous devez accepter l'Avis de confidentialité.",
    errLocalId: "Saisissez votre matricule (jusqu'à 8 chiffres).",
    errDepartment: 'Sélectionnez votre département.',
    acceptPrivacy: "J'ai lu et j'accepte l'",
    acceptLegalBases: "J'ai lu et j'accepte le",
    privacyLink: 'Avis de confidentialité',
    legalLink: 'Règlement',
    localId: 'Matricule',
    policyPlaceholder: "Lisez le document en entier. Vous pourrez l'accepter une fois arrivé à la fin.",
    createdTitle: 'Compte créé',
    createdSub: 'Vous pouvez maintenant vous connecter avec votre e-mail et votre mot de passe. Une fois connecté, vous pourrez choisir votre avatar.',
    checkEmailHint: 'Ouvrez le lien pour confirmer votre adresse e-mail et pouvoir vous connecter. Expiration dans 24 heures.',
    resend: "Renvoyer l'e-mail",
    resendDone: "Si votre compte est en attente de vérification, nous vous avons envoyé un autre lien (valable 24 heures). Vérifiez aussi vos courriers indésirables. Si vous l'avez déjà vérifié, connectez-vous avec votre e-mail et votre mot de passe.",
    errOuNotFound: "Nous n'avons pas trouvé cette organisation. Choisissez-en une autre dans la liste.",
    errOuUnavailable: "L'inscription n'est pas disponible pour l'organisation sélectionnée.",
    errNoMatch: "Nous n'avons pas pu valider vos données avec les registres de l'entreprise. Vérifiez que votre unité organisationnelle et votre numéro de matricule (ou votre Local ID, si vous êtes en Europe) sont corrects. Si vous êtes déjà inscrit, connectez-vous ou réinitialisez votre mot de passe. Si le problème persiste, contactez les Ressources humaines.",
    errEmailInUse: 'Cette adresse e-mail a déjà un compte associé.',
    corporateEmail: 'Cet e-mail est professionnel et vous avez déjà accès via la connexion Sigma (SSO) ; il ne peut donc pas servir à vous inscrire. Connectez-vous avec votre compte Sigma.',
    errNetwork: 'Connexion impossible. Vérifiez votre connexion et réessayez.',
    errTooMany: 'Trop de tentatives. Patientez un instant et réessayez.',
    errServer: "Nous avons rencontré un problème de notre côté et n'avons pas pu terminer l'inscription. Réessayez dans quelques minutes. Si cela continue, communiquez cette référence au support : {{referencia}}.",
    verifyConfirmTitle: 'Confirmez votre e-mail',
    verifyConfirmSub: 'Appuyez sur le bouton pour terminer la vérification de votre e-mail et activer votre compte.',
    verifyConfirmCta: 'Confirmer mon e-mail',
    verifyAlready: 'Votre e-mail est déjà vérifié',
    verifyAlreadySub: "Vous n'avez rien d'autre à faire : vous pouvez vous connecter.",
    verifyTemporary: "Nous n'avons pas pu vérifier votre e-mail pour le moment",
    verifyTemporarySub: 'Le lien est toujours valide. Vérifiez votre connexion et réessayez.',
    verifyRetry: 'Réessayer',
    errPayrollTaken: 'Ce numéro de matricule a déjà un compte associé.',
    payrollTakenAction: 'Si vous avez déjà créé votre compte auparavant, vous pouvez accéder directement à votre compte ou demander la réinitialisation de votre mot de passe si vous ne vous en souvenez plus.',
    payrollTakenRecover: 'Récupérer le mot de passe',
    linkInvalidTitle: "Le lien n'est plus valide",
    linkInvalidBody: 'Nous sommes désolés, ce lien de confirmation a expiré ou a été invalidé pour des raisons de sécurité.',
    linkInvalidHint: 'Si vous avez demandé cet accès, veuillez en demander un nouveau depuis notre application. Si vous ne reconnaissez pas ce site web, vous pouvez ignorer ce message en toute sécurité.',
    linkInvalidCta: "Aller à l'accueil",
    checkEmailWrong: "Ce n'est pas votre e-mail ? Corrigez-le",
    verifyEmailTaken: 'Cet e-mail est déjà utilisé',
    verifyEmailTakenSub: "Une autre personne a vérifié cet e-mail avant vous. S'il est à vous, connectez-vous ou réinitialisez votre mot de passe ; sinon, inscrivez-vous de nouveau avec votre e-mail.",
  },
  // ── Connexion (RF-002) ──
  login: {
    title: 'Se connecter',
    subtitle: 'Programme de Reconnaissance',
    entraRouteTitle: 'Connectez-vous avec votre e-mail professionnel',
    entraRouteSub: 'Utilisez votre compte Sigma (Entra ID).',
    entra: "Se connecter avec l'e-mail Sigma",
    frontlineRouteTitle: "Vous n'avez pas d'e-mail professionnel ?",
    frontlineRouteSub: 'Connectez-vous avec votre e-mail et votre mot de passe.',
    email: 'E-mail',
    password: 'Mot de passe',
    submit: 'Se connecter',
    submitting: 'Connexion…',
    or: 'ou',
    toRegister: "Pas de compte ? Inscrivez-vous",
    noAccountLede: "Vous n'avez pas de compte institutionnel ?",
    noAccountSub: 'Utilisez un e-mail personnel',
    alreadyRegisteredLede: 'Vous êtes déjà inscrit ?',
    hasInstitutionalEmailLede: 'Avez-vous un e-mail professionnel ?',
    register: 'Inscrivez-vous',
    back: 'Retour',
    forgot: 'Mot de passe oublié ?',
    forgotIntro: 'Saisissez votre adresse e-mail et nous vous enverrons un lien pour créer un nouveau mot de passe.',
    forgotSubmit: 'Envoyez-moi le lien',
    forgotSent: 'Si cette adresse est enregistrée, nous vous avons envoyé un lien. Il expire dans 60 minutes.',
    resendVerification: "Vous n'avez pas reçu l'e-mail de vérification ?",
    resendIntro: 'Saisissez votre adresse e-mail et nous vous enverrons un nouveau lien de vérification.',
    resendSubmit: "Renvoyer l'e-mail",
    resendSent: "Si votre compte est en attente de vérification, nous vous avons envoyé un autre lien (valable 24 heures). Vérifiez aussi vos courriers indésirables. Si vous l'avez déjà vérifié, connectez-vous avec votre e-mail et votre mot de passe.",
    errNotVerified: "Votre e-mail n'est pas encore vérifié. Ouvrez le lien que nous vous avons envoyé ou demandez-en un autre avec « Vous n'avez pas reçu l'e-mail de vérification ? ».",
    errInactive: 'Votre compte est désactivé. Contactez les Ressources humaines.',
    errTempExpired: 'Votre mot de passe temporaire a expiré. Demandez-en un nouveau aux Ressources humaines.',
    errNetwork: 'Connexion impossible. Vérifiez votre connexion et réessayez.',
    corporateEmailHint: 'Cet e-mail est professionnel : connectez-vous avec votre compte Sigma, sans mot de passe.',
    errRequired: 'Saisissez votre e-mail et votre mot de passe.',
    errCredentials: 'E-mail ou mot de passe incorrect.',
  },
  // ── Page d'accueil commune (règle #3) ──
  landing: {
    question: "Quels Fundamentals allons-nous reconnaître aujourd'hui ?",
    subtitle: 'Choisis un espace pour vivre tes Fundamentals',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: 'Comment était ton équipe à la dernière réunion ? Dis-leur ce que tu as remarqué 💬',
    shineHover: 'Envie de voir qui brille et de nommer un collègue ?',
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  activate: {
    errTemporary: "Nous n'avons pas pu activer votre compte pour le moment. Vérifiez votre connexion et réessayez ; votre lien est toujours valide.",
  },
  reset: {
    titleTemporary: 'Choisissez votre mot de passe définitif',
    subtitleTemporary: 'Vous vous êtes connecté avec un mot de passe temporaire. Choisissez-en un nouveau pour continuer.',
    errTemporary: "Nous n'avons pas pu traiter votre demande pour le moment. Vérifiez votre connexion et réessayez ; votre lien est toujours valide.",
    title: 'Créez votre nouveau mot de passe',
    subtitle: 'Choisissez un mot de passe pour vous reconnecter.',
    password: 'Nouveau mot de passe (8 caractères min.)',
    confirmPassword: 'Confirmer le mot de passe',
    submit: 'Changer mon mot de passe',
    errPassword: 'Le mot de passe doit comporter au moins 8 caractères.',
    errPasswordMatch: 'Les mots de passe ne correspondent pas.',
    errInvalidLink: "Le lien n'est pas valide ou a expiré. Demandez-en un nouveau depuis la page de connexion.",
    doneTitle: 'Mot de passe mis à jour',
    doneSub: 'Vous pouvez maintenant vous connecter avec votre e-mail et votre nouveau mot de passe.',
    noToken: 'Lien non valide',
    noTokenSub: "Le lien n'est pas valide ou est incomplet. Vérifiez l'e-mail que vous avez reçu.",
  },
  auth: {
    retryIn: 'Vous pouvez réessayer dans {{seconds}} s',
    contactHR: "Si vous avez des difficultés à vous inscrire, contactez votre équipe Capital Humain.",
    errorTitle: "Nous n'avons pas pu continuer",
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Choisissez votre avatar',
    subtitle: "Choisissez l'image qui vous représente.",
    loading: 'Chargement des avatars…',
    empty: "Aucun avatar n'est encore disponible.",
    loadError: 'Impossible de charger les avatars.',
    saveError: "Impossible d'enregistrer votre avatar.",
    saved: 'Avatar enregistré',
    confirm: 'Confirmer',
    required: 'Choisissez votre avatar pour continuer.',
    unavailable: "Cet avatar n'est plus disponible. Veuillez en choisir un autre.",
    change: "Changer d'avatar",
    continueWithout: 'Continuer sans avatar',
  },
  // ── WP-08 — Rapports de Reconnaissance ──
  reports: {
    title: 'Rapports',
    subtitle: 'Analytique du Programme de Reconnaissance. N’affiche jamais les points.',
    emptyScope: 'Aucune unité organisationnelle ne vous est attribuée dans votre périmètre.',
    tabs: {
      daily: 'Reco Diario',
      shine: 'Brillamos Juntos',
      heatmap: 'Carte de chaleur',
      network: 'Réseau ONA',
      generational: 'Démographique',
      leaders: 'Leaders',
      moderation: 'Modération',
      campaigns: 'Historiques',
    },
    common: {
      loading: 'Chargement des rapports…',
      error: 'Impossible de charger le rapport.',
      empty: "Il n'y a aucune donnée pour les filtres sélectionnés.",
      retry: 'Réessayer',
      suppressedNote: "Certains agrégats ont été masqués par le seuil d'anonymat (moins de 5).",
      suppressedNoteHelp: 'Lorsqu’un groupe compte moins de 5 personnes, ses mesures détaillées ne sont pas publiées : avec si peu, la donnée permettrait d’identifier quelqu’un par déduction. Ce n’est ni une erreur ni un manque d’information.',
      colScope: 'Périmètre (unités)',
      colScopeHelp: 'Unités organisationnelles visées par la campagne.',
      colAudienceHelp: 'Nombre de collaborateurs visés par la campagne. C’est le dénominateur du taux de participation.',
      scopeAll: 'Toute l’organisation',
      scopeMore: '+{{n}} de plus',
      masked: 'Masqué par anonymat',
      showingRange: 'Affichage {{desde}}–{{hasta}} sur {{total}}',
      pageSize: 'Lignes par page',
      perPage: '{{n}} par page',
      exportExcel: 'Exporter vers Excel',
      yes: 'Oui',
      no: 'Non',
    },
    context: {
      unifiedTitle: 'Métriques unifiées',
      unifiedText: '— Reconnaissance Quotidienne et Brillants Ensemble utilisent la même logique de comptage. Les données sont cohérentes entre les modules.',
      auditTitle: 'Audit activé.',
      auditText: 'Chaque téléchargement est enregistré avec votre utilisateur, l’onglet et la date.',
      showing: 'Affichage :',
      wholeOrg: 'toute l’organisation',
    },
    filters: {
      allFundamentals: 'Tous les Fondamentaux',
      allOus: 'Toutes les OU',
      site: 'Site',
      allSites: 'Tous les sites',
      dateFrom: 'Du',
      dateTo: 'Au',
      reset: 'Effacer',
      ou: 'Unité',
      fundamental: 'Fondamental',
      dateRange: 'Dates',
      remove: 'Retirer le filtre {{filter}}',
      person: 'Personne',
      personPlaceholder: 'Rechercher une personne…',
      openCalendar: "Ouvrir le calendrier",
      personClear: 'Retirer la personne sélectionnée',
      personNoResults: "Aucune correspondance dans l'annuaire",
      personSearching: 'Recherche en cours…',
      personError: "Impossible d'interroger l'annuaire",
    },
    notApplicable: {
      title_one: 'Le filtre {{filtros}} ne s\'applique pas à cette section.',
      // `title_few` — alias inerte de `title_other`, conservado solo por paridad de claves con `ro`.
      title_few: 'Les filtres {{filtros}} ne s\'appliquent pas à cette section.',
      title_other: 'Les filtres {{filtros}} ne s\'appliquent pas à cette section.',
      and: 'et',
      reason: {
        embudo: "L'entonnoir répartit toute la population entre Habitués, Occasionnels et Inactifs ; limité à une seule personne, ce ne serait plus une répartition.",
        historico: "Ces chiffres portent sur « depuis toujours », pas sur la période choisie : ils comptent quiconque a déjà reconnu quelqu'un, dans tout son historique sur la plateforme.",
        audienciaCampana: "Cet indicateur se calcule sur l'audience convoquée par la campagne, qui reste la même quels que soient le Fondamental ou la personne choisis.",
        porBanda: 'La répartition regroupe les personnes par tranche générationnelle ; avec une seule personne sélectionnée, il ne resterait qu\'une tranche, ce qui ne serait plus une répartition.',
        porOu: 'Cette vue regroupe par unité organisationnelle, pas par personne.',
        redOu: 'Les nœuds du réseau sont des unités organisationnelles, pas des personnes.',
        promedioPulso: "Ce tableau vient des scores moyens de Pulso (1-4) par génération et par Fondamental, pas du compte de reconnaissances ni du recensement des effectifs : aucun des deux filtres ne le limite.",
        resumenCampana: "Cet indicateur provient du résumé de toute la campagne : le backend ne permet pas de le limiter à une seule personne (il permet de le limiter par Fondamental).",
        casosReportados: "Ce rapport liste des CAS signalés, et le motif du signalement est rédigé par la personne qui signale : il n'est pas lié à un Fondamental de la reconnaissance. L'OU, la plage de dates et la personne, elles, limitent bien ce tableau.",
        campanaFinalizada: "La campagne choisie est terminée : elle est présentée en entier, du début à la fin.",
      },
    },
    daily: {
      title: 'Reconnaissance Quotidienne',
      subtitle: 'Reconnaissances du quotidien uniquement, hors campagnes : période choisie vs. précédente, entonnoir de participation et tops.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Période choisie',
      prevPeriod: 'Période précédente',
      vsPrev: '{{variacion}} vs. période précédente · {{previo}}',
      fundamentalDistribution: 'Répartition par Fondamental',
      totalSentTitle: 'Total des reconnaissances envoyées',
      totalSentHint: 'Somme de toutes les reconnaissances envoyées sur la période',
      retiredFundamental: 'Fondamental retiré',
      unresolvedFundamental: 'Fondamental (catalogue indisponible)',
      retiredFundamentalHint: 'Fondamental retiré du catalogue : il reste dans l’historique car des reconnaissances l’ont utilisé, mais il ne peut plus être choisi.',
      adoptionStaff: 'Utilisateurs Staff',
      adoptionFrontline: 'Utilisateurs Frontline',
      adoptionTotal: 'Utilisateurs au total',
      noActivity: 'Sans activité',
      adoptionHint: '{{reconocedores}} sur {{plantilla}} ont déjà reconnu quelqu’un',
      adoptionTotalHint: '{{pct}} de l’effectif total ({{plantilla}})',
      noActivityHint: 'N’ont jamais envoyé de reconnaissance',
      variation: 'Variation',
      sparkAria: 'Tendance quotidienne de {{label}} : {{dias}} jours, de {{primero}} à {{ultimo}}',
      uniquePeople: 'Personnes uniques',
      pares: 'Pairs',
      lideres: 'Leaders',
      groupRecognitions: 'Reconnaissances de groupe',
      groupRecognitionsHint: 'sur {{total}} envoyées · à 2 personnes ou plus',
      funnel: 'Entonnoir de participation',
      funnelRange: 'Période : {{from}} – {{to}}',
      funnelPeople: '{{count}} personnes',
      topPeople: 'Top personnes reconnues',
      topRecognizers: 'Top reconnaisseurs',
      topFundamentals: 'Top fondamentaux',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Exporter le quotidien (6 feuilles)',
      colStage: 'Étape',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Nom",
      colDepto: "Département",
      colOu: "OU",
      colFundamental: "Fondamental",
      colRecos: 'Reconnaissances',
      colEnviados: "Envoyées",
      colCrossOu: "Inter-OU",
      colType: "Type",
      crossOu: {
        si: "Oui",
        no: "Non",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'Courriel',
      colEmployeeId: 'Matricule',
      colRecognitions: 'Reconnaissances',
      colDominantType: 'Type dominant',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05). El libro entero sale en el idioma de quien descarga.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Résumé exécutif',
        sheetDefinitions: 'Définitions',
        sheetFunnel: "Entonnoir d'adoption",
        sheetTopRecognized: 'Top reconnus',
        sheetTopRecognizers: 'Top contributeurs',
        sheetAllRecognitions: 'Toutes les reconnaissances',
        sheetReceived: 'Reconnaissances reçues',
        summaryTitle: 'Reconnaissance quotidienne — Fondamentaux du quotidien',
        summarySubtitle: 'Indicateurs de la période sélectionnée : qui reconnaît, qui est reconnu et à quelle fréquence.',
        definitionsTitle: 'Que signifie chaque donnée ?',
        definitionsSubtitle: "Explication en langage simple, pour toute personne qui télécharge ce fichier, sans avoir besoin de s'y connaître en données.",
        funnelTitle: "Entonnoir d'adoption",
        funnelSubtitle: 'Segmentation calculée d\'après la fréquence des reconnaissances envoyées sur la période ({{rango}}), en moyenne mensuelle.',
        funnelEmpty: 'Aucune donnée : il n\'y a pas de reconnaissances sur la période.',
        topRecognizedTitle: 'Les plus reconnus',
        topRecognizersTitle: 'Top contributeurs',
        rankingSubtitle: 'Classement calculé à partir des reconnaissances de cette période.',
        topRecognizersEmpty: "Aucune donnée : personne n'a envoyé de reconnaissance pendant la période.",
        allRecognitionsTitle: 'Toutes les reconnaissances',
        allRecognitionsSubtitle: "Détail brut du quotidien sur la période, hors envois de campagne : une ligne par candidat reconnu. Les noms de colonne gardent leur forme d'origine pour que les tableaux croisés dynamiques du comité continuent de fonctionner.",
        allRecognitionsNoRange: "Aucune donnée : la plage exacte de la période n'a pas pu être déterminée, car l'agrégat est supprimé par le seuil d'anonymat et le filtre ne comporte pas de dates explicites.",
        receivedTitle: 'Reconnaissances reçues',
        receivedSubtitle: 'Reconnaissances de la période reçues par des personnes des OU sélectionnées, quelle que soit l’OU de l’émetteur : une ligne par personne reconnue. Pour une reconnaissance de groupe, seules les personnes de ces OU apparaissent.',
        receivedAllOus: 'Aucun enregistrement : avec toutes les OU, ce qui est reçu équivaut à ce qui est envoyé et figure déjà dans « Toutes les reconnaissances ». Sélectionnez une ou plusieurs OU pour voir ici ce qu’elles ont reçu.',
        metaPeriod: 'Période',
        metaFilters: 'Filtres appliqués',
        metaFunnelMonth: 'Période de l\'entonnoir',
        metaGenerated: 'Généré',
        colKpi: 'KPI',
        colValue: 'Valeur',
        colDetail: 'Détail',
        colDatum: 'Donnée',
        colWhatIs: "Ce que c'est",
        colHowCalculated: 'Comment on la calcule',
        colPercentOfTotal: '% du total',
        colSegment: 'Segment',
        colPeople: 'Personnes',
        colAdministrative: 'Administratifs',
        colOperational: 'Opérationnels',
        colFundamental: 'Fondamental',
        colRank: '#',
        colArea: 'Domaine',
        colSite: 'Site',
        headcountTitle: 'Effectif',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personnes',
        kpiPeers: 'Pairs (reconnaissances uniques entre pairs)',
        kpiLeaders: "Leaders (reconnaissances uniques impliquant un leader)",
        datumTeamRecognitions: 'Reconnaissances adressées à des équipes',
        datumAudienceStaff: 'Audience Staff (administratifs)',
        datumAudienceFrontline: 'Audience Frontline (opérationnels)',
        datumComparison: 'Période précédente et variation',
        datumRankings: 'Top reconnus / Top contributeurs',
        datumLeader: 'Leader',
        whatRecognitionsMade: 'Combien de reconnaissances ont été envoyées au total pendant la période, avec les filtres appliqués.',
        calcRecognitionsMade: 'On additionne les reconnaissances du quotidien datées dans la période choisie. Celles qui appartiennent à une campagne sont comptées dans le rapport Brillants Ensemble.',
        whatUniqueRecognized: "Combien de personnes différentes ont reçu au moins une reconnaissance. Celle qui en a reçu cinq ne compte qu'une seule fois.",
        calcUniqueRecognized: 'On compte les personnes différentes qui apparaissent comme destinataires pendant la période.',
        whatTeamRecognitions: "Une reconnaissance est collective quand elle compte plus d'un destinataire.",
        calcTeamRecognitions: "La colonne « Recognition type » de la feuille « Toutes les reconnaissances » marque chaque ligne comme Individuelle ou Collective.",
        whatPeers: "Reconnaissances où ni l'émetteur ni le destinataire n'encadre d'équipe : collaborateur à collaborateur, leader à leader, manager à manager.",
        calcPeers: 'On filtre les reconnaissances entre pairs dans la période.',
        whatLeaders: "Reconnaissances impliquant au moins une personne qui encadre une équipe.",
        calcLeaders: "On filtre les reconnaissances où l'émetteur ou le destinataire a un rôle de leader, superviseur ou manager.",
        whatStaffAdoption: 'Parmi toutes les personnes de bureau (Staff), le pourcentage qui a déjà reconnu quelqu’un pendant la période.',
        calcStaffAdoption: "Personnes Staff avec au moins une reconnaissance envoyée pendant la période, divisé par l'effectif Staff total du périmètre.",
        whatFrontlineAdoption: 'Parmi toutes les personnes de production ou de site (Frontline), le pourcentage qui a déjà reconnu quelqu’un pendant la période.',
        calcFrontlineAdoption: "Personnes Frontline avec au moins une reconnaissance envoyée pendant la période, divisé par l'effectif Frontline total du périmètre.",
        whatTotalUsers: 'Combien de personnes du périmètre ont envoyé au moins une reconnaissance à un moment donné, depuis la création de leur compte.',
        calcTotalUsers: 'Personnes avec au moins une reconnaissance envoyée sur tout leur historique. Cela ne dépend pas de la période sélectionnée : la donnée vient du recensement quotidien.',
        whatNoActivity: "Personnes qui n'ont jamais envoyé la moindre reconnaissance depuis la création de leur compte.",
        calcNoActivity: "Effectif total du périmètre moins les personnes ayant au moins une reconnaissance envoyée sur tout leur historique.",
        whatAudienceStaff: 'Personnes disposant d’un compte corporatif Entra ID.',
        whatAudienceFrontline: 'Personnes qui s’inscrivent sur la plateforme avec leur propre adresse électronique.',
        whatPrevPeriod: 'Reconnaissances envoyées sur le même nombre de jours immédiatement avant la période sélectionnée.',
        whatVariation: 'De combien le volume de reconnaissances a progressé ou reculé face à la période précédente équivalente.',
        calcVariation: 'La période précédente couvre le même nombre de jours immédiatement avant celle sélectionnée. La variation est la différence entre les deux, divisée par le total de la période précédente.',
        whatFunnel: 'Segmente le périmètre par fréquence d\'envoi sur la période choisie, la même que ci-dessus : Réguliers (quatre fois ou plus par mois en moyenne), Occasionnels (au moins une fois, en dessous de cette moyenne) et Inactifs (aucune). Pour une période de moins d\'un mois, le seuil d\'un mois s\'applique. Chaque étape est ventilée en administratifs et opérationnels.',
        calcFunnel: "Le pourcentage et la colonne Personnes se calculent sur l'effectif du périmètre. Administratifs et opérationnels comptent ces mêmes personnes par type de poste et restent vides si cette classification n'est pas disponible.",
        whatRankings: 'Les personnes les plus reconnues et celles qui reconnaissent le plus pendant la période, jusqu’à 200 dans chaque liste.',
        calcRankings: "On trie par nombre de reconnaissances reçues ou envoyées. Qui n'atteint pas le seuil d'anonymat apparaît masqué.",
        whatAllRecognitions: "Détail brut de la période, une ligne par candidat : les blocs Nominee, OnBehalfOf et Candidate complets, la date, la matrice des Habitudes actives et les indicateurs d'audit. Les personnes ne sont pas masquées : c'est la source de travail du comité, et le seuil d'anonymat s'applique aux rapports agrégés. Le fichier inclut les reconnaissances des campagnes Brillants Ensemble en cours, car le rapport quotidien les compte toutes.",
        calcAllRecognitions: 'Liste complète des reconnaissances de la période. Les colonnes d\'Habitudes n\'incluent que celles actives dans le catalogue au moment de l\'export. La colonne Reco_ID reste vide car le système ne génère pas encore d\'identifiant unique par ligne.',
        whatGroupRecognitions: 'Combien des reconnaissances envoyées étaient destinées à deux personnes ou plus. Chaque reconnaissance de groupe compte une fois, quel que soit le nombre de personnes reconnues.',
        calcGroupRecognitions: 'On compte les reconnaissances avec deux personnes reconnues ou plus. « Toutes les reconnaissances » contient une ligne par personne reconnue : elle peut donc avoir plus de lignes que le total des reconnaissances envoyées.',
        whatReceived: 'Détail de ce qu’ont reçu les personnes des OU sélectionnées dans le filtre, même si la personne qui les a reconnues appartient à une autre OU (reconnaissances Cross-OU).',
        calcReceived: 'Chaque personne reconnue dont l’OU fait partie de la sélection (avec ses unités dépendantes) est incluse. Une personne sans OU compte avec l’OU de la personne qui l’a reconnue. Avec toutes les OU, la feuille ne contient aucun enregistrement.',
        noteLeader: "Un rôle est considéré comme leader lorsqu'il encadre une équipe.",
        masked: 'Masqué par anonymat',
      },
    },
    shine: {
      pointsAwarded: 'Points attribués',
      pointsAwardedHint: '{{nominaciones}} nominations · {{personas}} personnes',
      personaNoFiltraCampanas: 'Le filtre Personne ne s’applique pas à la liste des campagnes : elle est restreinte par UO et statut.',
      personaEnElReporte: "Avec Personne, le rapport affiche ce que cette personne a envoyé ou reçu dans la campagne ; « Reconnaissances effectuées » et le classement ne comptent que ce qu’elle a envoyé.",
      title: 'Brillons Ensemble',
      subtitle: 'Classement des nominations de la campagne et KPIs en direct.',
      recognitionsMade: 'Reconnaissances effectuées',
      uniqueRecognized: 'Personnes uniques reconnues',
      uniqueRecognizers: 'Personnes uniques qui reconnaissent',
      participationRate: 'Taux de participation',
      totalHeadcount: 'Effectif total',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Exporter Shine (7 feuilles)',
      exporting: 'Exportation…',
      exportError: 'Le téléchargement n’a pas pu aboutir. Réessayez.',
      exportTooLarge: 'Le rapport dépasse 200 000 lignes par feuille. Réduisez la période ou les filtres et exportez à nouveau.',
      winnersFormat: "Format de l'export des gagnants",
      datesFromCampaign: "Les dates ont été ajustées à la période de la campagne choisie ; vous pouvez les modifier.",
      rankingCountsPeople: "Les cartes comptent des reconnaissances et le classement compte des personnes : une reconnaissance de groupe compte une fois en haut et une fois par personne ici, les chiffres peuvent donc différer.",
      winnersOnlyExpired: "Disponible lorsque la campagne a expiré : il n’y a pas de gagnants avant.",
      winnersEmpty: "Cette campagne n’a pas encore de gagnants enregistrés.",
      formatRaw: 'Brut',
      formatCascaded: 'En cascade',
      exportWinners: 'Exporter les gagnants',
      colPos: 'Position',
      kpiTotal: 'Total',
      kpiParticipants: 'Participants',
      kpiParticipation: 'Participation',
      kpiAvgPerPerson: 'Moyenne par personne',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Campagne',
      campaignScope: "Périmètre de la campagne :",
      allCampaigns: "Toutes les campagnes",
      scopeOnlyCoversAll: "Cette campagne ne couvre que {{alcance}} ; les autres OU ne sont pas incluses dans ce rapport.",
      scopeOnlyCoversSome: "Cette campagne ne couvre que {{alcance}}. Hors de son périmètre : {{fuera}}.",
      campaignStatusLabel: "Statut de la campagne",
      campaignStatus: { activa: "Active", finalizada: "Expirée" },
      noCampaigns: "Aucune campagne avec ce statut pour les OU sélectionnées",
      campaignsForbidden: "Vous n'avez pas l'autorisation de consulter les campagnes",
      campaignsLoadError: 'Impossible de charger les campagnes',
      filtersHelp: "Choisissez d’abord l’OU : la liste des campagnes en dépend. Puis le statut et la campagne, qui fait foi : les chiffres proviennent de son périmètre. Le Site, le Fondamental et la personne affinent dans ce périmètre. La plage de dates ne s’applique qu’aux campagnes actives ; une campagne expirée est présentée en entier.",
      filtersHelpAria: "Comment les filtres se combinent avec la campagne",
      modalidadSelector: 'Filtre Brillants Ensemble',
      daysLeft: 'Jours restants',
      activeOus: 'OU actives',
      modalidadTodos: 'Tous les nommés',
      modalidadPersonaUnica: 'Destinataire unique seulement',

      modalidadGrupal: 'Groupe uniquement (équipe)',
      modalidadCrossOu: 'Inter-OU',
      pickCampaign: "Sélectionnez d’abord une campagne.",
      habitsRanking: 'Classement des Daily Habits',
      colHabit: 'Daily Habit',
      colRecognitions: 'Reconnaissances',
      colName: 'Nom',
      colBu: 'BU',
      colDept: 'Dépt.',
      colOrigin: 'Source',
      filterHabitsByFundamental: 'Filtrer les habitudes par Fondamental',
      allFundamentals: 'Tous les Fondamentaux',
      colCount: 'Reconnaissances',
      colOu: 'OU',
      colCountry: 'Pays',
      colBadge: 'Badge',
      colCrossed: 'Origine croisée',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colCrossOu` reusa la misma
      // traducción que ya usa `reports.daily` para el mismo dato.
      colEmail: 'E-mail',
      colEmployeeId: 'Matricule',
      colCrossOu: 'Inter-OU',
      colDominantType: 'Type dominant',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Utilisateurs Staff',
      adoptionFrontline: 'Utilisateurs Frontline',
      adoptionTotal: 'Utilisateurs totaux',
      noActivity: 'Sans activité',
      adoptionHint: '{{reconocedores}} sur {{plantilla}} ont nommé',
      adoptionTotalHint: '{{pct}} de l’effectif total ({{plantilla}})',
      noActivityHint: 'N’ont jamais envoyé de nomination',
      clearAll: 'Tout effacer',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        kpiCrossOu: 'Reconnaissances inter-UO',
        whatCrossOu: 'Reconnaissances où au moins une personne reconnue appartient à une UO différente de celle de l’auteur.',
        calcCrossOu: 'Comptée une fois par reconnaissance : il suffit qu’une personne reconnue soit d’une autre UO. Si l’UO d’une personne reconnue est inconnue, ce n’est pas un croisement.',
        datumAwardsPoints: 'La campagne attribue des points',
        whatAwardsPoints: '{{valor}}. Indique si les reconnaissances de cette campagne rapportent des points aux personnes reconnues.',
        calcAwardsPoints: 'Issu de la configuration de la campagne (« Attribuer des points »). Seuls les administrateurs de points voient les points.',
        sheetReceivedRecognitions: 'Toutes reconn. reçues',
        receivedRecognitionsTitle: 'Toutes les reconnaissances reçues',
        receivedRecognitionsSubtitle: "Mêmes colonnes que «Toutes les reconnaissances», avec ce qu’ont reçu les personnes de l’OU filtrée (ou de l’OU de la personne qui exporte) dans toutes les campagnes Brillamos de la période. La colonne Campaign indique laquelle.",
        sheetSummary: 'Résumé exécutif',
        sheetDefinitions: 'Définitions',
        sheetDistribution: 'Répartition Fondamental',
        sheetFunnel: 'Entonnoir d\'adoption',
        sheetTopRecognized: 'Plus reconnus',
        sheetTopRecognizers: 'Plus reconnaissants',
        sheetAllRecognitions: 'Toutes les reconnaissances',
        summaryTitle: 'Campagne Brillants Ensemble',
        definitionsTitle: 'Que signifie chaque donnée ?',
        definitionsSubtitle: 'Explication en langage simple, pour toute personne qui télécharge ce fichier, sans connaissances en données.',
        distributionTitle: 'Répartition par Fondamental',
        distributionSubtitle: 'Part calculée à partir des reconnaissances de cette campagne.',
        distributionChart: 'Reconnaissances par Fondamental',
        distributionNote: 'Une reconnaissance peut porter sur plusieurs Fondamentaux ou plusieurs Habitudes à la fois, et chacun est compté séparément : les totaux de ce tableau peuvent ne pas correspondre au total de la campagne ni au décompte de leur Fondamental.',
        distributionEmpty: 'Aucune donnée : la campagne n\'a pas de reconnaissance avec un Fondamental enregistré sur la période.',
        funnelTitle: 'Entonnoir d\'adoption',
        funnelSubtitle: 'Segmentation calculée selon la fréquence des reconnaissances envoyées pendant la campagne.',
        funnelEmpty: 'Aucune donnée : la campagne n\'a pas de reconnaissance sur la période.',
        topRecognizedTitle: 'Les plus reconnus',
        topRecognizersTitle: 'Les plus reconnaissants',
        rankingSubtitle: 'Classement calculé à partir des reconnaissances de cette campagne.',
        topRecognizersEmpty: 'Aucune donnée : personne n\'a reconnu au sein de cette campagne.',
        allRecognitionsTitle: 'Toutes les reconnaissances',
        allRecognitionsSubtitle: 'Détail brut de la campagne : une ligne par candidat reconnu. Les noms de colonnes gardent leur forme d\'origine pour que les tableaux croisés du comité continuent de fonctionner.',
        metaPeriod: 'Période',
        metaFilters: 'Filtres appliqués',
        metaScope: 'Périmètre',
        whatPointsAwarded: 'Somme des points en vigueur que la campagne a attribués à chaque personne reconnue, sur la période et le périmètre du rapport. Administrateurs de points uniquement.',
        noPoints: "Sans points",
        metaGenerated: 'Généré',
        colKpi: 'KPI',
        colValue: 'Valeur',
        colDetail: 'Détail',
        colDatum: 'Donnée',
        colWhatIs: 'Ce que c\'est',
        colHowCalculated: 'Mode de calcul',
        colFundamentals: 'Fondamentaux',
        colPercentOfTotal: '% du total',
        colSegment: 'Segment',
        colPeople: 'Personnes',
        colAdministrative: 'Administratifs',
        colOperational: 'Opérationnels',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Fondamental',
        colRank: '#',
        colArea: 'Domaine',
        colSite: 'Site',
        headcountTitle: 'Effectif',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personnes',
        kpiPeers: 'Pairs (reconnaissances uniques entre pairs)',
        kpiLeaders: 'Managers (reconnaissances uniques impliquant un manager)',
        kpiTotalSent: 'Total des reconnaissances envoyées',
        kpiIndividual: 'Total des reconnaissances à une seule personne',
        kpiGroup: 'Total des reconnaissances adressées à des groupes',
        kpiPeopleInGroup: "Personnes reconnues dans des reconnaissances de groupe",
        whatPeopleInGroup: "Combien de personnes ont reçu les reconnaissances de groupe : une reconnaissance de groupe à 5 personnes compte 5.",
        calcPeopleInGroup: "Somme des destinataires de chaque reconnaissance qui en a plus d’un, avec les mêmes filtres que les autres KPI.",
        kpiTotalNominations: "Total des nominations (une par personne reconnue)",
        whatTotalNominations: "À une seule personne + Personnes reconnues dans des reconnaissances de groupe. C’est l’unité de la feuille « Toutes les reconnaissances », qui a une ligne par personne.",
        calcTotalNominations: "Total des reconnaissances à une seule personne + Personnes reconnues dans des reconnaissances de groupe. À ne pas confondre avec « Total des reconnaissances envoyées » (= une seule personne + groupe), qui compte chaque reconnaissance une fois. « Toutes les reconnaissances » liste aussi les nominations masquées ou signalées (avec leur Status) et celles venues d’une autre campagne via « envoyer à Brillons Ensemble » ; la colonne Reco_ID regroupe les lignes d’une même reconnaissance.",
        datumTeamRecognitions: 'Reconnaissances adressées à des équipes',
        datumAudienceStaff: 'Population Staff (administratifs)',
        datumAudienceFrontline: 'Population Frontline (opérationnels)',
        datumLeader: 'Manager',
        whatRecognitionsMade: 'Combien de reconnaissances ont été envoyées au total dans la campagne, avec les filtres appliqués.',
        calcRecognitionsMade: 'Toutes les reconnaissances datées dans la période de la campagne sont additionnées.',
        whatUniqueRecognized: 'Combien de personnes différentes ont reçu au moins une reconnaissance. Celle qui en a reçu cinq compte une seule fois.',
        calcUniqueRecognized: 'On compte les personnes différentes qui apparaissent comme bénéficiaires sur la période.',
        whatTeamRecognitions: 'Une reconnaissance est collective lorsqu\'elle compte plus d\'un destinataire.',
        calcTeamRecognitions: 'On compte les reconnaissances ayant deux destinataires ou plus.',
        whatIndividual: 'Reconnaissances de la campagne adressées à une seule personne.',
        calcIndividual: 'On compte les reconnaissances ayant exactement un destinataire.',
        whatPeers: 'Reconnaissances où ni l\'émetteur ni le bénéficiaire n\'encadre d\'équipe : collaborateur à collaborateur, manager à manager, directeur à directeur.',
        calcPeers: 'On filtre les reconnaissances entre pairs au sein de cette campagne.',
        whatLeaders: 'Reconnaissances impliquant au moins une personne qui encadre une équipe.',
        calcLeaders: 'On filtre les reconnaissances où l\'émetteur ou le bénéficiaire a un rôle de manager, de superviseur ou de directeur.',
        whatStaffAdoption: 'Parmi les personnes de bureau (Staff), quelle part a déjà reconnu quelqu\'un dans cette campagne.',
        calcStaffAdoption: 'Personnes Staff ayant envoyé au moins une reconnaissance dans la campagne, divisées par le total des personnes Staff de sa population.',
        whatFrontlineAdoption: 'Parmi les personnes de production ou de site (Frontline), quelle part a déjà reconnu quelqu\'un dans cette campagne.',
        calcFrontlineAdoption: 'Personnes Frontline ayant envoyé au moins une reconnaissance dans la campagne, divisées par le total des personnes Frontline de sa population.',
        whatTotalUsers: 'Combien de personnes de la population de la campagne ont envoyé au moins une reconnaissance en son sein.',
        calcTotalUsers: 'Personnes ayant envoyé au moins une reconnaissance pendant la période de la campagne. Il ne s\'agit pas d\'un cumul historique.',
        whatNoActivity: 'Personnes de la population qui n\'ont envoyé aucune reconnaissance pendant la campagne.',
        calcNoActivity: 'Population de la campagne moins les personnes ayant envoyé au moins une reconnaissance en son sein.',
        whatAudienceStaff: 'Personnes disposant d\'un compte Entra ID d\'entreprise.',
        whatAudienceFrontline: 'Personnes qui s\'inscrivent sur la plateforme avec leur propre adresse e-mail.',
        whatParticipationRate: 'Part de la population cible qui a participé à la campagne en envoyant au moins une reconnaissance.',
        calcParticipationRate: 'Participants divisés par la population cible de la campagne.',
        whatUniqueRecognizers: 'Personnes différentes ayant envoyé au moins une reconnaissance au sein de cette campagne.',
        calcUniqueRecognizers: 'Décompte des émetteurs différents dans les reconnaissances de la campagne.',
        whatDistribution: "Hiérarchie à deux niveaux : chaque Fondamental avec sa part du total de la campagne et, en dessous et en retrait, ses habitudes quotidiennes avec la part qu'elles représentent au sein de ce Fondamental.",
        calcDistribution: 'La part d\'un Fondamental est son nombre de reconnaissances divisé par le total de la campagne. Celle d\'une Habitude est son nombre de reconnaissances divisé par le total de son Fondamental.',
        whatFunnel: 'Segmente la population de la campagne par fréquence : Réguliers (quatre fois ou plus par mois), Occasionnels (une à trois fois) et Inactifs (aucune). Chaque étape est aussi ventilée en Administratifs et Opérationnels.',
        calcFunnel: 'Le pourcentage et la colonne Personnes sont calculés sur la population de la campagne, pas sur toute l\'organisation. Administratifs et Opérationnels comptent ces mêmes personnes par type de poste et restent vides si cette classification n\'est pas disponible.',
        whatAllRecognitions: 'Détail brut de la campagne, une ligne par candidat : les blocs Nominee, OnBehalfOf et Candidate complets, la date, la matrice des Habitudes actives et les indicateurs d\'audit. Les personnes ne sont pas masquées : c\'est la source de travail du comité, et le seuil d\'anonymat s\'applique aux rapports agrégés.',
        calcAllRecognitions: 'Liste complète des reconnaissances de la période. Les colonnes d\'Habitudes n\'incluent que celles actives dans le catalogue au moment de l\'export. La colonne Reco_ID reste vide car le système ne génère pas encore d\'identifiant unique par ligne.',
        noteLeader: 'Un rôle est considéré comme manager dès lors qu\'il encadre des collaborateurs.',
        masked: 'Masqué par anonymat',
        crossOuCount: '{{count}} OU',
      },
    },
    history: {
      selectCampaign: 'Choisir une campagne',
      colName: 'Nom',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
        colType: "Type",
        colStatus: "Statut",
        colRecognitions: "Reconnaissances",
        colExpiration: "Date de fin",
        colActions: "Actions",
        status: {
        activo: "Active",
          expirado: "Expirée",
          borrador: "Brouillon",
        },
      // P18-ter — rapport GLOBAL des campagnes (toutes, pas une seule), calqué sur 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Total des campagnes',
      kpiTotalRecognitions: 'Total des reconnaissances',
      kpiAudienceTotal: 'Audience totale',
      kpiParticipantsTotal: 'Participants',
      kpiParticipantsStaff: 'Participants Staff',
      kpiParticipantsFrontline: 'Participants Frontline',
      kpiParticipationRate: 'Taux de participation',
      kpiAvgPerParticipant: 'Moyenne de reconnaissances par participant',
      colDescription: 'Description',
      colParticipants: 'Participants',
      colParticipantsStaff: 'Participants Staff',
      colParticipantsFrontline: 'Participants Frontline',
      colDuration: 'Durée de la campagne',
      colFrequency: 'Fréquence',
      colGoalPercent: '% de l\'objectif',
      downloadGlobalExcel: 'Télécharger le rapport global',
      downloadGlobalError: 'Impossible de télécharger le rapport global.',
      // Excel Historiques (`historicosExcel.ts`) — textes EXCLUSIFS du fichier téléchargeable :
      // noms de feuille, bandeau, métadonnées et glossaire. Les libellés de donnée réutilisent les
      // clés `kpi*`/`col*` ci-dessus, pour que la colonne du fichier et celle de l'écran coïncident.
      excel: {
        sheetSummary: 'Résumé exécutif',
        sheetDefinitions: 'Définitions',
        sheetCampaigns: 'Campagnes historiques',
        summaryTitle: 'Historique par campagne',
        summarySubtitle: "Consolide l'historique des campagnes de reconnaissance : audience, participation et volume de reconnaissances de chacune.",
        campaignsSubtitle: 'Détail comparatif par campagne.',
        definitionsTitle: 'Que signifie chaque donnée ?',
        definitionsSubtitle: 'Explication en langage simple, harmonisée avec le Résumé exécutif et précisant comment chaque KPI est mesuré.',
        metaFilter: 'Filtre appliqué',
        metaGenerated: 'Généré le',
        filterAllCampaigns: 'Toutes les campagnes',
        colKpi: 'KPI',
        colValue: 'Valeur',
        colNote: 'Note / définition',
        colDatum: 'Donnée',
        colWhatIs: "Ce que c'est",
        colHowMeasured: 'Comment on la mesure',
        colHowCalculated: 'Comment on la calcule',
        colComparedTo: 'Se compare à',
        colWhereShown: 'Où elle apparaît',
        colAudienceOu: 'Audience OU',
        whereSummary: 'Résumé exécutif',
        whereSummaryCampaigns: 'Résumé exécutif / Campagnes historiques',
        datumStaffFrontline: 'Participants Staff / Participants Frontline',
        durationDays_one: '{{count}} jour',
        durationDays_few: '{{count}} jours',
        durationDays_other: '{{count}} jours',
        whatCampaigns: "Nombre de campagnes incluses dans l'historique ou dans le filtre appliqué.",
        measuredCampaigns: "On compte chaque campagne enregistrée avec un nom valide dans l'historique.",
        calcCampaigns: 'Décompte des campagnes uniques comprises dans le périmètre du rapport.',
        vsCampaigns: "À l'ensemble des campagnes disponibles ou aux relevés précédents.",
        whatRecognitions: 'Reconnaissances cumulées dans le périmètre sélectionné.',
        measuredRecognitions: 'On compte chaque reconnaissance enregistrée pour les campagnes retenues.',
        calcRecognitions: 'Somme de toutes les reconnaissances des campagnes filtrées.',
        vsRecognitions: "À d'autres campagnes, aux périodes antérieures ou à l'objectif défini.",
        whatAudience: 'Nombre de collaborateurs visés par la campagne.',
        measuredAudience: "On prend l'audience cible définie dans la configuration de la campagne.",
        calcAudience: "Total des collaborateurs éligibles dans l'OU, le pays, la BU ou le périmètre configuré.",
        vsAudience: "Base de calcul de la participation ; 100 % équivaut à couvrir toute l'audience.",
        whatParticipants: 'Personnes distinctes ayant participé en envoyant au moins une reconnaissance.',
        measuredParticipants: 'On compte les personnes uniques ayant envoyé au moins une reconnaissance.',
        calcParticipants: 'Décompte distinct des émetteurs ayant une reconnaissance ou plus.',
        vsParticipants: "À l'Audience totale et à des campagnes comparables.",
        whatStaffFrontline: 'Parmi les participants, combien travaillent en bureau (Staff) et combien sur site (Frontline).',
        measuredStaffFrontline: 'Le segment actuel de chaque personne est retenu au moment du rapport, pas celui du jour de sa participation.',
        calcStaffFrontline: 'Décompte des participants selon le segment inscrit dans leur fiche annuaire.',
        vsStaffFrontline: 'Au total des Participants de la même ligne.',
        whatRate: "Part de l'audience cible qui a effectivement participé.",
        measuredRate: "On mesure la proportion de participants sur l'audience totale.",
        calcRate: 'Participants / Audience totale.',
        vsRate: "À l'objectif de participation ; 100 % signifie que toute l'audience a participé.",
        whatAvg: 'Moyenne de reconnaissances générées par participant actif.',
        measuredAvg: 'On la mesure parmi les personnes ayant envoyé au moins une reconnaissance.',
        calcAvg: 'Total des reconnaissances / participants.',
        vsAvg: "À d'autres campagnes ou à la moyenne attendue par participant.",
      },
    },
    headcount: {
      notaPeriodo: 'Référence de la période : les indicateurs ci-dessus sont calculés sur cet effectif.',
      notaAdopcion: 'C’est le dénominateur de l’adoption : sur cet effectif, combien de personnes ont nommé.',
      title: 'Effectif',
      updatedOn: 'Effectif mis à jour : {{fecha}}',
      updatedOnTitle: 'Effectif mis à jour',
      sourceLatam: 'LATAM : {{fecha}}',
      sourceEuropa: 'Europe : {{fecha}}',
      sourceUsa: 'États-Unis : {{fecha}}',
      sinDato: 'Aucune donnée',
      hint: 'Dernier chargement des utilisateurs inscrits sur la plateforme',
      total: 'Personnes au total',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Carte de chaleur OU × Fondamental',
      subtitle: 'Volume de reconnaissances par OU et Fondamental. L\'intensité de la couleur montre la concentration relative au sein de chaque colonne.',
      ou: 'Unité organisationnelle',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Total',
    },
    network: {
      title: 'Réseau ONA',
      subtitle: 'Flux de reconnaissance entre unités (collaboration croisée).',
      ous: 'Unités',
      flows: 'Flux',
      legendCross: 'Flux cross-OU',
      legendInternal: 'Flux interne',
      legendNode: 'Unité (taille = volume)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Flux (De → Vers)',
      colRecognitions: 'Reconnaissances',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Volume de reconnaissances',
      colDominantFundamentalHelp: 'La longueur de la barre représente le volume de reconnaissances du flux ; la couleur indique quel Fondamental a été le plus reconnu dans celui-ci.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: 'Que signifie chaque donnée ?',
      subtitle: 'Explication en langage simple pour toute personne qui télécharge ce fichier, sans connaissances en données.',
      colData: 'Donnée',
      colWhat: 'Ce que c\'est',
      colHow: 'Mode de calcul',
      colVs: 'Comparé à',
      percentTotalWhat: 'La part de l\'effectif actif total qui appartient à chaque génération.',
      percentTotalHow: 'Personnes actives de cette génération, dans toutes les OU du périmètre, divisées par l\'effectif actif total dont la tranche générationnelle est connue.',
      percentTotalVs: 'Les autres générations du même tableau.',
      gapWhat: 'À quel point une génération incarne chaque Fondamental, sur une échelle de 1 à 4, et l\'écart entre son Fondamental le plus faible et le plus élevé.',
      gapHow: 'Moyenne des scores Pulso par génération et Fondamental ; le Δ correspond au maximum moins le minimum de la ligne, à une décimale.',
      gapVs: 'Les autres Fondamentaux de la même génération.',
      heatmapWhat: 'Combien de reconnaissances ont été données dans chaque unité organisationnelle, réparties par Fondamental.',
      heatmapHow: 'Comptage groupé par OU et Fondamental ; les cellules de moins de 5 reconnaissances sont masquées par anonymat.',
      heatmapVs: 'Les autres OU et Fondamentaux du même tableau.',
      networkWhat: 'Combien de reconnaissances ont circulé d\'une unité organisationnelle à une autre.',
      networkHow: 'Comptage des reconnaissances envoyées d\'une OU à une autre, du plus élevé au plus faible.',
      networkVs: 'Les autres flux du même tableau.',
    },
    generational: {
      title: 'Répartition générationnelle',
      subtitle: 'Reconnaissances regroupées par tranche générationnelle.',
      filterBu: 'Filtrer par BU…',
      buAll: 'BU : Toutes',
      filterDepto: 'Filtrer par département…',
      roleAll: 'Tous',
      roleLeaders: 'Leaders',
      rolePeers: 'Pairs',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Écart générationnel × Fondamental',
      gapSubtitle: 'Score moyen (1–4) par génération et Fondamental. Δ Écart ≥ 1,0 = critique.',
      gapTitleHelp: 'Chaque cellule est arrondie à 1 décimale pour l\'affichage. Le Δ Écart est calculé sur la valeur complète (non arrondie) du maximum moins le minimum de la ligne, il peut donc ne pas correspondre à la soustraction visuelle des colonnes arrondies.',
      colGeneration: 'Génération',
      colGap: 'Δ Écart',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} personne',
      people_other: '{{count}} personnes',
      majority: 'majorité',
      coverageTitle: 'Unités avec couverture de données générationnelles',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Exporter le panneau Démographique (4 feuilles)',
      // Task 9 — etiquetas de columna para la hoja de export de distribución generacional.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Composition des effectifs par génération, OU et type de collaborateur',
      metaPeriod: 'Période',
      metaFilters: 'Filtres appliqués',
      metaGenerated: 'Généré',
      colPercentTotal: '% du total',
      colYearRange: 'Plage d\'années',
      colPeople: 'Personnes',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Note',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Majorité',
      noteSmallSample: 'Échantillon réduit',
    },
    leaders: {
      title: 'Leaders',
      subtitle: "Taille d'équipe directe et reconnaissances par leader.",
      export: 'Exporter vers Excel',
      colLeader: 'Leader',
      colPosition: 'Poste',
      colOu: 'UO',
      colLevel: 'Niveau',
      colTeamSize: "Taille de l'équipe",
      colTeamReceived: 'Reconnaissances équipe (reçues)',
      colTeamReceivedHelp: 'Total des reconnaissances reçues par des personnes au sein des structures des leaders.',
      colTeamSent: 'Reconnaissances équipe (envoyées)',
      colTeamSentHelp: 'Total des reconnaissances envoyées par des personnes au sein des structures des leaders.',
      colLeaderSent: 'Reconnaissances envoyées par le leader',
      colLeaderReceived: 'Reconnaissances reçues par le leader',
      colParticipation: 'Participation',
      colRatio: 'Ratio',
      colExport: 'Exporter',
      exportRow: 'Exporter cette ligne',
      exportRowFor: 'Exporter la ligne de {{name}}',
      kpiTotalLeaders: 'Total de leaders',
      kpiTeamSizeSum: "Taille de l'équipe",
      kpiRatioAvg: 'Ratio reçues/envoyées',
      kpiParticipationAvg: 'Participation',
      emptyByPerson: 'Aucun résultat trouvé : la personne sélectionnée n’a personne sous sa responsabilité dans votre périmètre.',
      currentWeek: '(semaine en cours, par défaut)',
      teamSizeNote: 'La taille de l’équipe compte les rattachements directs de l’organigramme et ne change pas avec les dates ni le Fondamental ; les reconnaissances de l’équipe, oui.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Synthèse',
        sheetDefinitions: 'Définitions',
        sheetTeams: 'Équipes par leader',
        teamsSubtitle: 'Détail des reconnaissances par structure hiérarchique.',
        definitionsTitle: 'Que signifie chaque donnée ?',
        definitionsSubtitle: 'Explication en langage simple, pour toute personne qui télécharge ce fichier — sans avoir besoin de s’y connaître en données.',
        metaPeriod: 'Période',
        metaFilters: 'Filtres appliqués',
        metaGenerated: 'Généré le',
        colKpi: 'Indicateur',
        colValue: 'Valeur',
        colDetail: 'Détail',
        colDatum: 'Donnée',
        colWhatIs: 'De quoi s’agit-il',
        colHowCalculated: 'Mode de calcul',
        detailTotalLeaders: 'Nombre total de leaders ayant des personnes à leur charge dans les effectifs.',
        detailTeamSize: "Somme de la taille d'équipe (collaborateurs directs) des leaders affichés.",
        detailTeamReceived: 'Total des reconnaissances reçues par les personnes au sein des structures des leaders.',
        detailTeamSent: 'Total des reconnaissances envoyées par les personnes au sein des structures des leaders.',
        detailLeaderReceived: 'Total des reconnaissances reçues directement par les leaders.',
        detailLeaderSent: 'Total des reconnaissances envoyées directement par les leaders.',
        detailRatio: 'Reconnaissances d’équipe reçues divisées par celles envoyées.',
        detailParticipation: 'Participation moyenne des équipes des leaders.',
        whatTeamSize: 'Combien de personnes sont rattachées directement à ce leader.',
        howTeamSize: 'Nombre de personnes dont le manager est le leader. Les niveaux inférieurs de l’organigramme ne sont pas cumulés.',
        whatTeamReceived: 'Combien de reconnaissances l’équipe de ce leader a reçues au total, de la part de n’importe qui.',
        howTeamReceived: 'Somme des reconnaissances dont le destinataire appartient à l’équipe directe du leader.',
        whatTeamSent: 'Combien de reconnaissances l’équipe de ce leader a envoyées au total, à n’importe qui.',
        howTeamSent: 'Somme des reconnaissances dont l’émetteur appartient à l’équipe directe du leader.',
        whatLeaderReceived: 'Combien de reconnaissances le leader a reçues au total, de la part de n’importe qui.',
        howLeaderReceived: 'Nombre de reconnaissances dont le destinataire est le leader. Son équipe n’est pas incluse.',
        whatLeaderSent: 'Combien de reconnaissances le leader a envoyées, à n’importe qui.',
        howLeaderSent: 'Nombre de reconnaissances dont l’émetteur est le leader. Son équipe n’est pas incluse.',
        whatRatio: 'Dans quelle mesure une équipe reçoit plus de reconnaissance qu’elle n’en adresse aux autres.',
        howRatio: 'Reconnaissances d’équipe reçues divisées par celles envoyées. « — » si l’équipe n’en a envoyé aucune.',
        whatParticipation: 'Quel pourcentage de l’équipe de ce leader a reconnu quelqu’un au moins une fois.',
        howParticipation: 'Personnes de l’équipe ayant envoyé au moins 1 reconnaissance, divisées par la taille de l’équipe. Recevoir ne compte pas : c’est l’action de quelqu’un d’autre.',
        whatLeader: 'Collaborateur qui encadre du personnel dans l’effectif de l’entreprise.',
        howLeader: 'Toute personne ayant au moins un collaborateur direct. La synthèse additionne les leaders de toutes les géographies du périmètre consulté.',
        whatLevel: 'Profondeur du leader dans l’organigramme : N-1 est la racine (sans manager), puis N-2, N-3… vers le bas.',
        howLevel: 'Chaîne de managers jusqu’à la racine + 1, calculée sur toute l’entreprise et non uniquement parmi les leaders visibles dans cette liste.',
      },
    },
    moderation: {
      title: 'Modération',
      subtitle: 'Détail des reconnaissances signalées. Inclut les données de contact pour l’escalade.',
      total: 'Signalements totaux',
      pending: 'En attente',
      hidden: 'Masqués',
      restored: 'Restaurés',
      colReported: 'Signalé',
      colReportedEmail: 'Email signalé',
      colOu: 'UO',
      colCountry: 'Pays',
      colReporter: 'Signaleur',
      colReporterEmail: 'Email signaleur',
      colReason: 'Motif',
      colStatus: 'Statut',
      colDate: 'Date',
      statusPending: 'En attente',
      statusHidden: 'Masqué',
      statusRestored: 'Restauré',
      statusPublished: 'Publié',
      colComment: 'Commentaire signalé',
      colLanguage: 'Langue',
      colReportCount: '# Signalements',
      export: 'Exporter vers Excel',
      colCampaign: 'Campagne',
      allCampaigns: 'Toutes les campagnes',
      campaignNone: 'Sans campagne',
      campaignUnavailable: 'Campagne indisponible',
    },
    campaigns: {
      title: 'Historique des campagnes',
      subtitle: 'Campagnes clôturées : audience et reconnaissances.',
      search: 'Rechercher par nom…',
      // D4 — sélecteur de catégorie (Fundamentales/Brillamos/Personalizada) qui remplace l'export
      // combiné du tableau.
      filterTypeLabel: 'Catégorie',
      filterAllTypes: 'Toutes les catégories',
      summaryParticipants: 'Total des participants',
      summaryRate: '% de participation',
      colName: 'Nom',
      colType: 'Type',
      colAudience: 'Audience (personnes)',
      colRecognitions: 'Reconnaissances',
      // C2 — «Participation par campagne» (rep-panel-campgeneral).
      colParticipants: 'Participants',
      colRate: 'Taux de participation',
      colAvgUser: 'Moyenne par participant',
      colAvgUserHelp: 'Reconnaissances moyennes générées par chaque participant à la campagne : reconnaissances ÷ participants.',
      dominantFundamentalTooltip: 'Fondamental le plus reconnu : {{name}}',
      colStart: "Date de début",
      colExpiration: "Date de fin",
      prevPage: 'Précédent',
      nextPage: 'Suivant',
      pageOf: 'Page {{page}} sur {{total}}',
      type: {
        Fundamentales: 'Fondamentaux',
        Brillamos: 'Shine Together',
        Personalizada: 'Personnalisée',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      // D6 — erreur visible pour l'utilisateur si l'export de la campagne échoue (réseau/backend), via Toast.
    },
  },
  // ── D5 Pass-C — Préférences, équipe, tableau de bord, classement, campagne personnalisée ──
  notifPrefs: {
    title: 'Notifications',
    subtitle: 'Choisissez les avis que vous souhaitez recevoir par e-mail.',
    unavailable: 'Impossible de charger vos préférences.',
    emailEnabled: 'Recevoir des e-mails',
    emailHint: 'Interrupteur général de tous les e-mails.',
    saveError: "Impossible d'enregistrer vos préférences.",
    cat: {
      recognitionReceived: 'Reconnaissances reçues',
      streakAndBadges: 'Séries et badges',
      campaigns: 'Campagnes',
      digest: "Résumé d'activité",
    },
    catHint: {
      recognitionReceived: "Quand quelqu'un vous reconnaît.",
      streakAndBadges: 'Votre série et vos badges débloqués.',
      campaigns: 'Nouveautés des campagnes Brillons.',
      digest: 'Résumé périodique de votre activité.',
    },
    catLockedAntiSpoiler: "Verrouillé tant que le Mode Anti-Spoiler est actif : nous ne pouvons pas vous informer de vos reconnaissances avant la fin de la campagne.",
  },
  team: {
    mostRecognized: 'Les Plus Reconnus', mostRecognizers: 'Les Plus Reconnaissants',
    title: 'Mon équipe',
    subtitle: 'Participation de votre équipe à la reconnaissance.',
    subtitleFor: 'Équipe de {{name}}',
    empty: "Il n'y a pas encore d'activité de votre équipe.",
    teamSize: "Taille de l'équipe",
    sent: 'Envoyées',
    received: 'Reçues',
    participation: 'Participation',
    members: "Membres de l'équipe",
    emptyMembers: "Il n'y a aucun membre à afficher.",
    colMember: 'Membre',
    colSent: 'Envoyées',
    colReceived: 'Reçues',
    colStreak: 'Série',
    noStreak: 'Sans série',
    explore: 'Explorer son équipe',
    myTeam: 'Mon équipe',
    breadcrumb: 'Chemin des équipes',
    colTopFundamental: 'Top fondamental',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'Reconnu pour :',
    fundEnviado: 'Reconnaît pour :',
    colActions: 'Actions',
    viewButton: 'Voir le profil de {{name}}',
    viewButton_short: 'Voir',
    backToTeam: "Retour à l'équipe",
    backToProfile: 'Retour à mon profil',
    expandMember: 'Voir les détails de {{name}}',
  },
  tablero: {
    title: 'Tableau de bord exécutif',
    subtitle: 'KPI du Programme de Reconnaissance. Seuls les administrateurs de points voient les points.',
    pointsTitle: 'Points de la campagne',
    pointsCampaign: 'Campagne avec points',
    pointsNone: 'Aucune campagne n’attribue de points.',
    pointsHint: 'Avec l’UO et la période de la barre.',
    empty: "Il n'y a aucun KPI pour le périmètre sélectionné.",
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'Tous les Fondamentaux',
    allGenerations: 'Toutes les générations',
    notApplicableNote: 'Avec le filtre de génération, les KPI calculés sur l’effectif total s’affichent « n/a » : le recensement n’est pas ventilé par génération, ce pourcentage signifierait donc autre chose.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Génération Alpha',
      GenZ: 'Génération Z',
      Millennial: 'Millennials',
      GenX: 'Génération X',
      BabyBoomer: 'Baby-boomers',
      Silent: 'Génération silencieuse',
    },
  },
  leaderboard: {
    title: 'Classement par OU',
    subtitle: 'Nominations par unité organisationnelle/pays.',
    noOu: 'Sans OU',
    you: ' (vous)',
  },
  campaignType: {
    personalizada: 'Campagne personnalisée',
  },
  campaignLanding: {
    customNote: 'Ceci est une campagne informative. Explorez ses documents et son microsite.',
  },
  innovacion: {
    kpiStreak: 'Série',
    kpiStreakHint: 'record : {{record}} semaines',
    kpiStreakHintMonthly: 'record : {{record}} mois',
    kpiNominationsHint2: '{{count}} personnes différentes',
    fundamentalsTitle: 'Fondamentaux de cette campagne',
    nominateSecondary: 'Aller à la page Nominer',
    kpiNominations: 'Nominations',
    kpiNominationsHint: 'Envoyées dans cette campagne',
    kpiUnique: 'Personnes nominées',
    kpiUniqueHint: 'Destinataires uniques',
    kpiDaysLeft: 'Jours restants',
    suppressed: 'Les données sont supprimées pour des raisons de confidentialité : le groupe est trop petit pour afficher des chiffres.',
    kpisUnavailable: 'Les KPIs en direct ne sont pas disponibles pour le moment.',
    recentTitle: 'Reconnaissances récentes',
    recentEmpty: 'Aucune reconnaissance dans cette campagne pour l’instant.',
    noCampaign: 'Aucune campagne personnalisée active. Elle peut être créée depuis Administration → Campagnes.',
  },
};

export default recognition;
